webpackJsonp([1],{

/***/ "+6Cr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 144.031 112"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 144.031 112","xml:space":"preserve"}},[_c('path',{attrs:{"id":"bubble","d":"M134.281,25.875c-6.5-7.917-15.25-14.208-26.25-18.875s-23-7-36-7s-25,2.333-36,7s-19.75,10.958-26.25,18.875S0.031,42.5,0.031,52c0,5.833,1.292,11.417,3.875,16.75S10.114,79,14.781,83.5c-1,6-2.583,10.917-4.75,14.75c-1.333,2.167-3.5,4.583-6.5,7.25l-2,1.75c-1.167,1.167-1.667,2.083-1.5,2.75s0.542,1.167,1.125,1.5s1.208,0.5,1.875,0.5c13.5-1.333,25.333-6,35.5-14c10.5,4,21.667,6,33.5,6c13,0,25.042-2.333,36.125-7s19.833-10.958,26.25-18.875S144.031,61.5,144.031,52S140.781,33.792,134.281,25.875z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#FFFFFF"},attrs:{"d":"M104.015,35.358l-43.25,43c-0.5,0.5-1.166,0.75-2,0.75s-1.584-0.334-2.25-1l-22.75-22.75c-0.5-0.667-0.75-1.417-0.75-2.25s0.334-1.5,1-2l5.5-5.75c0.666-0.5,1.416-0.75,2.25-0.75s1.5,0.25,2,0.75l15,15.25l35.25-35c0.667-0.667,1.417-1,2.25-1s1.5,0.333,2,1l5.75,5.5c0.5,0.667,0.75,1.417,0.75,2.25S104.515,34.858,104.015,35.358z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+aZZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Kt7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3D1X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4mX6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5/u5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6U+c":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0ic21pbGV5IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MiIgaGVpZ2h0PSI1NyIgdmlld0JveD0iMCAwIDYyIDU3Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgICAvKiBEZWZhdWx0ICovCiAgICAgICAgI2JhY2tncm91bmR7ZmlsbDogI2ZmZjt9CiAgICAgICAgLmZhY2Uge2ZpbGw6ICMwMDA7fQogICAgICAgICNoZWFkLWJvcmRlcntmaWxsOiAjMDAwO30KICAgICAgICAKICAgICAgICAvKiBBY3RpdmUgKi8KICAgICAgICAvKgogICAgICAgICNiYWNrZ3JvdW5ke2ZpbGw6ICMwZGEwZGY7fQogICAgICAgIC5mYWNlIHtmaWxsOiAjMGRhMGRmO30KICAgICAgICAjaGVhZC1ib3JkZXJ7ZmlsbDogI2ZmZjt9CiAgICAgICAgKi8KCiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+aWNvbl9zdXJ2ZXlfc21pbGV5PC90aXRsZT4KICA8cGF0aCBpZD0iYmFja2dyb3VuZCIgZD0iTTU3Ljg4NywwSDQuMTEzQTQuMTE0LDQuMTE0LDAsMCwwLDAsNC4xMTNWNTIuODg3QTQuMTE0LDQuMTE0LDAsMCwwLDQuMTEzLDU3SDU3Ljg4N0E0LjExNCw0LjExNCwwLDAsMCw2Miw1Mi44ODdWNC4xMTNBNC4xMTQsNC4xMTQsMCwwLDAsNTcuODg3LDBaTTMxLDQ4LjVhMjAsMjAsMCwxLDEsMjAtMjBBMjAsMjAsMCwwLDEsMzEsNDguNVoiLz4KICA8Y2lyY2xlIGlkPSJoZWFkIiBzdHlsZT0iZmlsbDogI2ZmZjsiIGN4PSIzMSIgY3k9IjI4LjUiIHI9IjE2LjY2NyIvPgogIDxwYXRoIGlkPSJoZWFkLWJvcmRlciIgZD0iTTMxLDguNWEyMCwyMCwwLDEsMCwyMCwyMEEyMCwyMCwwLDAsMCwzMSw4LjVabTAsMzYuNjY3QTE2LjY2NywxNi42NjcsMCwxLDEsNDcuNjY3LDI4LjUsMTYuNjgyLDE2LjY4MiwwLDAsMSwzMSw0NS4xNjdaIi8+CiAgPGVsbGlwc2UgaWQ9ImxlZnQtZXllIiBjbGFzcz0iZmFjZSIgY3g9IjI0LjUiIGN5PSIyMS44MzMiIHJ4PSIzLjUiIHJ5PSIzLjMzMyIvPgogIDxwYXRoIGlkPSJtb3V0aC1tZWRpdW0iIGNsYXNzPSJmYWNlIiBkPSJNMzkuMzMzLDM1LjE2N0gyMi42NjdhMS42NjcsMS42NjcsMCwwLDEsMC0zLjMzNEgzOS4zMzNhMS42NjcsMS42NjcsMCwwLDEsMCwzLjMzNFoiLz4gIAogIDxjaXJjbGUgaWQ9InJpZ2h0LWV5ZSIgY2xhc3M9ImZhY2UiIGN4PSIzNy42NjciIGN5PSIyMS44MzMiIHI9IjMuMzMzIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "8Y3J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C0yJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CiIe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dntb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EpSK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fctk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GCfW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GCsD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicBubble_vue__ = __webpack_require__("VRK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicBubble_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicBubble_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f09bb482_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_svg_xlink_href_use_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicBubble_vue__ = __webpack_require__("+6Cr");
function injectStyle (ssrContext) {
  __webpack_require__("lQOO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f09bb482"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicBubble_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f09bb482_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_svg_xlink_href_use_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicBubble_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HYY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"arrow-right","data-name":"arrow-right","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.333 16.229"}},[_c('path',{attrs:{"id":"inner","d":"M4.667,11.334A1.248,1.248,0,0,1,5.885,10h7.333L10.167,6.938a1.308,1.308,0,0,1,0-1.875l.781-.792a1.337,1.337,0,0,1,.937-.385,1.384,1.384,0,0,1,.949.385l6.781,6.792A1.343,1.343,0,0,1,20,12a1.384,1.384,0,0,1-.385.948l-6.781,6.771a1.351,1.351,0,0,1-.949.4,1.325,1.325,0,0,1-.937-.4l-.781-.771a1.333,1.333,0,0,1,0-1.9L13.218,14H5.885a1.247,1.247,0,0,1-1.218-1.333Z","transform":"translate(-4.667 -3.886)"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JPJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowLeft_vue__ = __webpack_require__("XTCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowLeft_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowLeft_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7953eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_svg_xlink_href_use_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowLeft_vue__ = __webpack_require__("h/qv");
function injectStyle (ssrContext) {
  __webpack_require__("n2rp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f7953eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowLeft_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7953eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_svg_xlink_href_use_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowLeft_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LCSo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LHCj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0ic21pbGV5IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MiIgaGVpZ2h0PSI1NyIgdmlld0JveD0iMCAwIDYyIDU3Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgICAvKiBEZWZhdWx0ICovCiAgICAgICAgI2JhY2tncm91bmR7ZmlsbDogI2ZmZjt9CiAgICAgICAgLmZhY2Uge2ZpbGw6ICMwMDA7fQogICAgICAgICNoZWFkLWJvcmRlcntmaWxsOiAjMDAwO30KICAgICAgICAKICAgICAgICAvKiBBY3RpdmUgKi8KICAgICAgICAvKgogICAgICAgICNiYWNrZ3JvdW5ke2ZpbGw6ICMwZGEwZGY7fQogICAgICAgIC5mYWNlIHtmaWxsOiAjMGRhMGRmO30KICAgICAgICAjaGVhZC1ib3JkZXJ7ZmlsbDogI2ZmZjt9CiAgICAgICAgKi8KCiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+aWNvbl9zdXJ2ZXlfc21pbGV5PC90aXRsZT4KICA8cGF0aCBpZD0iYmFja2dyb3VuZCIgZD0iTTU3Ljg4NywwSDQuMTEzQTQuMTE0LDQuMTE0LDAsMCwwLDAsNC4xMTNWNTIuODg3QTQuMTE0LDQuMTE0LDAsMCwwLDQuMTEzLDU3SDU3Ljg4N0E0LjExNCw0LjExNCwwLDAsMCw2Miw1Mi44ODdWNC4xMTNBNC4xMTQsNC4xMTQsMCwwLDAsNTcuODg3LDBaTTMxLDQ4LjVhMjAsMjAsMCwxLDEsMjAtMjBBMjAsMjAsMCwwLDEsMzEsNDguNVoiLz4KICA8Y2lyY2xlIGlkPSJoZWFkIiBzdHlsZT0iZmlsbDogI2ZmZjsiIGN4PSIzMSIgY3k9IjI4LjUiIHI9IjE2LjY2NyIvPgogIDxwYXRoIGlkPSJoZWFkLWJvcmRlciIgZD0iTTMxLDguNWEyMCwyMCwwLDEsMCwyMCwyMEEyMCwyMCwwLDAsMCwzMSw4LjVabTAsMzYuNjY3QTE2LjY2NywxNi42NjcsMCwxLDEsNDcuNjY3LDI4LjUsMTYuNjgyLDE2LjY4MiwwLDAsMSwzMSw0NS4xNjdaIi8+CiAgPGVsbGlwc2UgaWQ9ImxlZnQtZXllIiBjbGFzcz0iZmFjZSIgY3g9IjI0LjUiIGN5PSIyMS44MzMiIHJ4PSIzLjUiIHJ5PSIzLjMzMyIvPgogIDxwYXRoIGlkPSJtb3V0aF92ZXJ5LXVuaGFwcHkiIGNsYXNzPSJmYWNlIiBkPSJNMjIuNTM3LDM5LjI1NWExLjc1NCwxLjc1NCwwLDAsMCwuMjEuMDQ2aC4wMDlhMS41MjYsMS41MjYsMCwwLDAsLjI1LjAyNmMuMDI3LDAsLjA1Mi4wMDguMDc5LjAwOGwxNS44MywwYy4wMjcsMCwuMDUyLS4wMDcuMDc5LS4wMDhhMS42NDQsMS42NDQsMCwwLDAsLjI1LS4wMjZsLjAwOSwwYTEuNTc0LDEuNTc0LDAsMCwwLC4yMS0uMDQ1LDEuNjU0LDEuNjU0LDAsMCwwLDEuMDY4LTIuMDgzLDkuOTIyLDkuOTIyLDAsMCwwLTkuNTMxLTd2MGE5LjkyMiw5LjkyMiwwLDAsMC05LjUzMSw3QTEuNjU0LDEuNjU0LDAsMCwwLDIyLjUzNywzOS4yNTVaIi8+CiAgPGNpcmNsZSBpZD0icmlnaHQtZXllIiBjbGFzcz0iZmFjZSIgY3g9IjM3LjY2NyIgY3k9IjIxLjgzMyIgcj0iMy4zMzMiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "LNSM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJFYmVuZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDE3LjAzMSAxMC4zNzMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE3LjAzMSAxMC4zNzM7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cGF0aCBzdHlsZT0iZmlsbDogI2ZmZiIgZD0iTTE2Ljc1OCw3Ljg5MWMwLjE4MywwLjE4MiwwLjI3MywwLjQwNCwwLjI3MywwLjY2NHMtMC4wOTEsMC40ODItMC4yNzMsMC42NjRsLTAuODU5LDAuODU5Yy0wLjE4MywwLjE4Mi0wLjQwMywwLjI3OS0wLjY2NCwwLjI5M3MtMC40ODEtMC4wNzItMC42NjQtMC4yNTRMOC41MTYsNC4wNjJsLTYuMDU1LDYuMDU1Yy0wLjE4MiwwLjE4Mi0wLjQwNCwwLjI2OC0wLjY2NCwwLjI1NHMtMC40ODItMC4xMTEtMC42NjQtMC4yOTNMMC4yNzMsOS4yMTlDMC4wOTEsOS4wMzcsMCw4LjgxNCwwLDguNTU1czAuMDkxLTAuNDgyLDAuMjczLTAuNjY0bDcuNTc4LTcuNTc4QzguMDM0LDAuMTA0LDguMjU1LDAsOC41MTYsMEM4Ljc3NiwwLDguOTk3LDAuMTA0LDkuMTgsMC4zMTJMMTYuNzU4LDcuODkxeiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./src/globals.js


var globals_eventHub = new vue_esm["a" /* default */]();
window.eventHub = globals_eventHub;
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RadioButton.vue


/* harmony default export */ var RadioButton = ({
  props: ['active']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d52e210a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RadioButton.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:{selected: _vm.active},attrs:{"id":"radio-button","data-name":"Radio active","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","width":"20","height":"20"}},[_c('path',{attrs:{"d":"M12,4a8,8,0,1,1-8,8,8.009,8.009,0,0,1,8-8m0-2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Z","transform":"translate(-2 -2)"}}),_vm._v(" "),(_vm.active)?_c('circle',{attrs:{"cx":"10","cy":"10","r":"5"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_RadioButton = (esExports);
// CONCATENATED MODULE: ./src/components/RadioButton.vue
function injectStyle (ssrContext) {
  __webpack_require__("8Y3J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d52e210a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  RadioButton,
  components_RadioButton,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_RadioButton = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardAnswerOption.vue



/* harmony default export */ var CardAnswerOption = ({
  props: ['question'],
  methods: {
    answer_question: function answer_question(answer) {
      var answer_data = { 'answerValue': answer.value, 'answerId': answer.id, 'questionId': this.question.id };
      if ('score' in answer) {
        answer_data['answerScore'] = answer['score'];
      }
      eventHub.$emit('answer-question', answer_data);
    }
  },
  components: {
    RadioButton: src_components_RadioButton
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ad7ef94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardAnswerOption.vue
var CardAnswerOption_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-answer cst-survey-answer-options"},[_c('ul',_vm._l((_vm.question.answers),function(answerOption){return _c('li',{key:answerOption.id,class:{ selected: !!_vm.question.answer && _vm.question.answer.answerId == answerOption.id},on:{"click":function($event){return _vm.answer_question(answerOption)}}},[_c('radio-button',{attrs:{"active":!!_vm.question.answer && _vm.question.answer.answerId == answerOption.id}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(answerOption.text)}})],1)}),0)])}
var CardAnswerOption_staticRenderFns = []
var CardAnswerOption_esExports = { render: CardAnswerOption_render, staticRenderFns: CardAnswerOption_staticRenderFns }
/* harmony default export */ var components_CardAnswerOption = (CardAnswerOption_esExports);
// CONCATENATED MODULE: ./src/components/CardAnswerOption.vue
function CardAnswerOption_injectStyle (ssrContext) {
  __webpack_require__("eqAT")
}
var CardAnswerOption_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardAnswerOption___vue_template_functional__ = false
/* styles */
var CardAnswerOption___vue_styles__ = CardAnswerOption_injectStyle
/* scopeId */
var CardAnswerOption___vue_scopeId__ = "data-v-6ad7ef94"
/* moduleIdentifier (server only) */
var CardAnswerOption___vue_module_identifier__ = null
var CardAnswerOption_Component = CardAnswerOption_normalizeComponent(
  CardAnswerOption,
  components_CardAnswerOption,
  CardAnswerOption___vue_template_functional__,
  CardAnswerOption___vue_styles__,
  CardAnswerOption___vue_scopeId__,
  CardAnswerOption___vue_module_identifier__
)

/* harmony default export */ var src_components_CardAnswerOption = (CardAnswerOption_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppScalePercentageMobile.vue


/* harmony default export */ var AppScalePercentageMobile = ({
  props: ['answer_question', 'isPercentageSelected'],
  data: function data() {
    return {
      clickableBlocks: [{ percentage: 0, path: 'M136.959,361.793c-15.419-15.625-27.683-34.673-35.539-55.199l73.073-27.304c3.945,10.129,9.999,19.535,17.578,27.311L136.959,361.793z' }, { percentage: 10, path: 'M100.729,304.719c-7.533-20.617-10.774-43.038-9.392-64.976l77.812,5.525c-0.62,10.854,0.979,21.924,4.642,32.146L100.729,304.719z' }, { percentage: 20, path: 'M91.489,237.752c1.714-21.882,8.082-43.623,18.454-63.003l68.481,37.355c-5.073,9.614-8.219,20.349-9.134,31.168L91.489,237.752z' }, { percentage: 30, path: 'M110.907,173c10.65-19.191,25.476-36.321,42.962-49.641l46.77,62.433c-8.609,6.637-15.93,15.094-21.257,24.555L110.907,173z' }, { percentage: 40, path: 'M155.474,122.17c17.662-13.031,38.264-22.453,59.704-27.303l16.602,76.221c-10.587,2.459-20.76,7.109-29.538,13.502L155.474,122.17z' }, { percentage: 50, path: 'M217.131,94.452c10.78-2.269,21.838-3.418,32.881-3.418c10.998,0,22.016,1.14,32.769,3.389l-16.568,76.228c-5.329-1.082-10.78-1.631-16.219-1.631c-5.456,0-10.92,0.552-16.259,1.641L217.131,94.452z' }, { percentage: 60, path: 'M297.716,184.561c-8.791-6.393-18.966-11.037-29.545-13.486l16.56-76.219c21.414,4.817,42.024,14.221,59.727,27.251L297.716,184.561z' }, { percentage: 70, path: 'M320.592,210.301c-5.341-9.467-12.667-17.92-21.271-24.542l46.731-62.447c17.478,13.279,32.318,30.396,43.006,49.603L320.592,210.301z' }, { percentage: 80, path: 'M330.704,243.22c-0.924-10.831-4.076-21.562-9.151-31.162l68.453-37.386c10.38,19.341,16.767,41.076,18.508,62.987L330.704,243.22z' }, { percentage: 90, path: 'M326.225,277.365c3.66-10.236,5.252-21.308,4.624-32.146l77.798-5.565c1.406,21.904-1.815,44.328-9.335,64.982L326.225,277.365z' }, { percentage: 100, path: 'M307.964,306.562c7.582-7.79,13.63-17.199,17.562-27.32l73.077,27.262c-7.822,20.508-20.069,39.566-35.491,55.23L307.964,306.562z' }]
    };
  },
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c85382a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppScalePercentageMobile.vue
var AppScalePercentageMobile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{staticStyle:{"enable-background":"new 0 0 500 500"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"85 85 330 285","xml:space":"preserve"}},[_c('g',{attrs:{"id":"Border"}},[_c('path',{staticClass:"st0",attrs:{"d":"M283.97,93.653v0.01l-16.99,78.17c-11.2-2.42-22.81-2.42-34.01,0.01l-17.03-78.16C238.34,88.823,261.58,88.823,283.97,93.653z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M100.129,306.01l0.008-0.005l74.935-27.999c4.024,10.729,10.304,20.493,18.407,28.598l-56.523,56.605C120.752,346.999,108.179,327.453,100.129,306.01z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M363.117,363.15l-0.008-0.005l-56.553-56.577c8.094-8.11,14.375-17.875,18.39-28.609l74.948,27.96C391.864,327.386,379.292,346.932,363.117,363.15z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M90.406,238.677l0.01-0.001l79.794,5.667c-0.798,11.431,0.858,22.922,4.861,33.661l-74.932,28.004C92.134,284.529,88.819,261.527,90.406,238.677z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M399.903,305.922l-0.01-0.001l-74.948-27.966c3.993-10.74,5.649-22.232,4.841-33.664l79.79-5.708C411.192,261.448,407.877,284.45,399.903,305.922z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M109.538,173.391l0.01,0.003l70.226,38.308c-5.475,10.066-8.743,21.206-9.564,32.637l-79.793-5.661C92.059,215.816,98.601,193.516,109.538,173.391z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M409.587,238.584l-0.01,0.003l-79.792,5.702c-0.831-11.428-4.099-22.569-9.584-32.632l70.205-38.344C401.377,193.44,407.919,215.74,409.587,238.584z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M154.066,121.957l0.008,0.007l47.961,64.023c-9.162,6.881-16.764,15.657-22.26,25.713l-70.228-38.302C120.54,153.284,135.756,135.718,154.066,121.957z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M390.417,173.31l-0.008,0.007L320.2,211.655c-5.504-10.05-13.105-18.825-22.275-25.7l47.927-64.047C364.192,135.658,379.408,153.224,390.417,173.31z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M345.859,121.901l-0.004,0.009l-47.933,64.044c-9.182-6.855-19.742-11.678-30.94-14.122l16.984-78.17C306.361,98.549,327.5,108.205,345.859,121.901z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M215.939,93.673l0.004,0.009l17.025,78.162c-11.193,2.452-21.753,7.276-30.931,14.14l-47.965-64.019C172.427,108.238,193.566,98.582,215.939,93.673z"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Fields"}},_vm._l((_vm.clickableBlocks),function(entry){return _c('path',{key:entry.percentage,class:{st1: true, selected:_vm.isPercentageSelected(entry.percentage)},attrs:{"d":entry.path},on:{"click":function($event){return _vm.answer_question(entry.percentage)}}})}),0),_vm._v(" "),_c('g',{attrs:{"id":"Typo"}},[_c('g',{staticClass:"st2"},[_c('path',{attrs:{"d":"M241.315,133.428c0.374,0.387,0.817,0.727,1.33,1.021c0.513,0.293,1.143,0.439,1.89,0.439c0.387,0,0.75-0.07,1.09-0.21c0.34-0.14,0.637-0.337,0.89-0.59c0.253-0.253,0.453-0.561,0.6-0.92c0.146-0.36,0.22-0.76,0.22-1.2c0-0.88-0.247-1.566-0.74-2.06c-0.494-0.493-1.153-0.74-1.98-0.74c-0.44,0-0.817,0.066-1.13,0.2c-0.313,0.133-0.664,0.326-1.05,0.58l-0.88-0.561l0.42-6.14h6.38v1.42h-4.94l-0.34,3.78c0.307-0.16,0.613-0.287,0.92-0.381c0.307-0.093,0.653-0.14,1.04-0.14c0.546,0,1.06,0.08,1.54,0.24s0.9,0.403,1.26,0.729c0.36,0.327,0.643,0.74,0.85,1.24s0.311,1.097,0.311,1.79s-0.12,1.307-0.36,1.84s-0.561,0.983-0.96,1.351c-0.4,0.366-0.857,0.646-1.37,0.84c-0.514,0.193-1.05,0.29-1.61,0.29c-0.507,0-0.97-0.05-1.39-0.15c-0.42-0.1-0.8-0.229-1.14-0.39c-0.34-0.16-0.647-0.344-0.92-0.55c-0.273-0.207-0.517-0.424-0.73-0.65L241.315,133.428z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M254.935,136.249c-1.294,0-2.301-0.573-3.021-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.9c0.72-1.12,1.727-1.68,3.021-1.68c1.279,0,2.279,0.56,3,1.68c0.72,1.12,1.079,2.753,1.079,4.9s-0.359,3.793-1.079,4.939C257.214,135.675,256.214,136.249,254.935,136.249z M254.935,134.928c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.779-0.96c0.221-0.434,0.391-0.987,0.511-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.4s-0.29-1.21-0.511-1.63c-0.22-0.42-0.479-0.73-0.779-0.93c-0.3-0.2-0.637-0.3-1.01-0.3c-0.374,0-0.714,0.1-1.021,0.3c-0.307,0.2-0.57,0.51-0.79,0.93c-0.22,0.42-0.39,0.964-0.51,1.63s-0.18,1.466-0.18,2.4c0,1.867,0.229,3.224,0.689,4.07S254.188,134.928,254.935,134.928z"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{attrs:{"d":"M141.662,319.72c-1.293,0-2.3-0.573-3.02-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.899c0.72-1.121,1.727-1.681,3.02-1.681c1.28,0,2.28,0.56,3,1.681c0.72,1.119,1.08,2.753,1.08,4.899s-0.359,3.793-1.08,4.939C143.942,319.146,142.942,319.72,141.662,319.72z M141.662,318.399c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.78-0.96c0.22-0.434,0.39-0.987,0.51-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.399c-0.12-0.667-0.29-1.211-0.51-1.631s-0.48-0.73-0.78-0.93c-0.3-0.2-0.637-0.301-1.01-0.301c-0.374,0-0.713,0.101-1.02,0.301c-0.307,0.199-0.57,0.51-0.79,0.93c-0.22,0.42-0.39,0.964-0.51,1.631c-0.12,0.666-0.18,1.466-0.18,2.399c0,1.867,0.23,3.224,0.69,4.07S140.915,318.399,141.662,318.399z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M150.301,314.399c-0.906,0-1.63-0.36-2.17-1.08s-0.81-1.746-0.81-3.08c0-1.319,0.27-2.337,0.81-3.05s1.264-1.07,2.17-1.07c0.894,0,1.613,0.357,2.16,1.07s0.82,1.73,0.82,3.05c0,1.334-0.273,2.36-0.82,3.08S151.195,314.399,150.301,314.399z M150.301,313.38c0.507,0,0.92-0.264,1.24-0.79c0.32-0.527,0.48-1.311,0.48-2.351s-0.16-1.816-0.48-2.329c-0.32-0.514-0.733-0.771-1.24-0.771c-0.52,0-0.939,0.257-1.26,0.771c-0.32,0.513-0.479,1.289-0.479,2.329s0.159,1.823,0.479,2.351C149.362,313.116,149.782,313.38,150.301,313.38z M150.662,319.72l7.24-13.601h1.12l-7.24,13.601H150.662z M159.442,319.72c-0.907,0-1.63-0.36-2.17-1.08s-0.811-1.747-0.811-3.08c0-1.32,0.271-2.337,0.811-3.05c0.54-0.714,1.263-1.07,2.17-1.07c0.893,0,1.613,0.356,2.16,1.07c0.546,0.713,0.819,1.729,0.819,3.05c0,1.333-0.273,2.36-0.819,3.08C161.055,319.359,160.334,319.72,159.442,319.72z M159.442,318.699c0.506,0,0.92-0.263,1.239-0.79c0.32-0.526,0.48-1.31,0.48-2.35s-0.16-1.816-0.48-2.33c-0.319-0.513-0.733-0.77-1.239-0.77c-0.521,0-0.94,0.257-1.261,0.77c-0.319,0.514-0.479,1.29-0.479,2.33s0.16,1.823,0.479,2.35C158.501,318.437,158.921,318.699,159.442,318.699z"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{attrs:{"d":"M328.586,318.119h2.92v-9.399h-2.319v-1.061c0.586-0.106,1.096-0.236,1.529-0.39s0.823-0.337,1.17-0.55h1.261v11.399h2.64v1.36h-7.2V318.119z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M341.926,319.72c-1.294,0-2.301-0.573-3.021-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.9s1.727-1.68,3.021-1.68c1.279,0,2.279,0.56,3,1.68c0.72,1.12,1.079,2.754,1.079,4.9s-0.359,3.793-1.079,4.939C344.205,319.146,343.205,319.72,341.926,319.72z M341.926,318.399c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.779-0.96c0.221-0.434,0.391-0.987,0.511-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.4c-0.12-0.666-0.29-1.21-0.511-1.63c-0.22-0.42-0.479-0.73-0.779-0.93c-0.3-0.2-0.637-0.301-1.01-0.301c-0.374,0-0.714,0.101-1.021,0.301c-0.307,0.199-0.57,0.51-0.79,0.93s-0.39,0.964-0.51,1.63c-0.12,0.667-0.18,1.467-0.18,2.4c0,1.867,0.229,3.224,0.689,4.07S341.179,318.399,341.926,318.399z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M351.866,319.72c-1.294,0-2.301-0.573-3.021-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.9s1.727-1.68,3.021-1.68c1.279,0,2.279,0.56,3,1.68c0.72,1.12,1.079,2.754,1.079,4.9s-0.359,3.793-1.079,4.939C354.146,319.146,353.146,319.72,351.866,319.72z M351.866,318.399c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.779-0.96c0.221-0.434,0.391-0.987,0.511-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.4c-0.12-0.666-0.29-1.21-0.511-1.63c-0.22-0.42-0.479-0.73-0.779-0.93c-0.3-0.2-0.637-0.301-1.01-0.301c-0.374,0-0.714,0.101-1.021,0.301c-0.307,0.199-0.57,0.51-0.79,0.93s-0.39,0.964-0.51,1.63c-0.12,0.667-0.18,1.467-0.18,2.4c0,1.867,0.229,3.224,0.689,4.07S351.119,318.399,351.866,318.399z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M360.505,314.399c-0.906,0-1.63-0.36-2.17-1.08s-0.81-1.746-0.81-3.08c0-1.32,0.27-2.337,0.81-3.05s1.264-1.07,2.17-1.07c0.894,0,1.613,0.357,2.16,1.07s0.82,1.729,0.82,3.05c0,1.334-0.273,2.36-0.82,3.08S361.398,314.399,360.505,314.399z M360.505,313.38c0.507,0,0.92-0.264,1.24-0.79c0.32-0.527,0.48-1.311,0.48-2.351s-0.16-1.816-0.48-2.33c-0.32-0.513-0.733-0.77-1.24-0.77c-0.52,0-0.939,0.257-1.26,0.77c-0.32,0.514-0.479,1.29-0.479,2.33s0.159,1.823,0.479,2.351C359.565,313.116,359.985,313.38,360.505,313.38z M360.865,319.72l7.24-13.601h1.12l-7.24,13.601H360.865z M369.646,319.72c-0.907,0-1.63-0.36-2.17-1.08s-0.811-1.747-0.811-3.08c0-1.32,0.271-2.337,0.811-3.05c0.54-0.714,1.263-1.07,2.17-1.07c0.893,0,1.613,0.356,2.16,1.07c0.546,0.713,0.819,1.729,0.819,3.05c0,1.333-0.273,2.36-0.819,3.08C371.259,319.359,370.538,319.72,369.646,319.72z M369.646,318.699c0.506,0,0.92-0.263,1.239-0.79c0.32-0.526,0.48-1.31,0.48-2.35s-0.16-1.816-0.48-2.33c-0.319-0.513-0.733-0.77-1.239-0.77c-0.521,0-0.94,0.257-1.261,0.77c-0.319,0.514-0.479,1.29-0.479,2.33s0.16,1.823,0.479,2.35C368.705,318.437,369.125,318.699,369.646,318.699z"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{attrs:{"d":"M123.799,270.69h2.92v-9.399h-2.32v-1.06c0.586-0.107,1.096-0.237,1.53-0.391c0.433-0.153,0.823-0.336,1.17-0.55h1.26v11.399H131v1.36h-7.2V270.69z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M137.139,272.291c-1.294,0-2.301-0.573-3.021-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.899c0.72-1.12,1.727-1.681,3.021-1.681c1.279,0,2.279,0.561,3,1.681c0.72,1.119,1.079,2.753,1.079,4.899s-0.359,3.793-1.079,4.939C139.418,271.718,138.418,272.291,137.139,272.291z M137.139,270.971c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.779-0.96c0.221-0.434,0.391-0.987,0.511-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.399c-0.12-0.667-0.29-1.21-0.511-1.631c-0.22-0.42-0.479-0.729-0.779-0.93s-0.637-0.3-1.01-0.3c-0.374,0-0.714,0.1-1.021,0.3s-0.57,0.51-0.79,0.93c-0.22,0.421-0.39,0.964-0.51,1.631c-0.12,0.666-0.18,1.466-0.18,2.399c0,1.867,0.229,3.224,0.689,4.07S136.392,270.971,137.139,270.971z"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{attrs:{"d":"M359.854,269.911c0.267,0.307,0.583,0.553,0.95,0.739c0.366,0.188,0.75,0.28,1.15,0.28c0.453,0,0.88-0.093,1.279-0.28c0.4-0.187,0.754-0.496,1.061-0.93c0.307-0.433,0.553-0.996,0.74-1.689c0.187-0.693,0.286-1.554,0.3-2.58c-0.4,0.507-0.867,0.906-1.4,1.199c-0.533,0.294-1.066,0.44-1.6,0.44c-1.107,0-1.987-0.326-2.641-0.98c-0.653-0.652-0.979-1.64-0.979-2.959c0-0.613,0.1-1.17,0.3-1.67s0.47-0.931,0.811-1.29c0.34-0.36,0.739-0.641,1.199-0.841c0.46-0.199,0.943-0.3,1.45-0.3c0.627,0,1.21,0.127,1.75,0.38c0.54,0.254,1.007,0.638,1.4,1.15c0.394,0.514,0.7,1.153,0.92,1.92s0.33,1.663,0.33,2.689c0,1.28-0.134,2.37-0.4,3.271c-0.267,0.899-0.627,1.633-1.08,2.2c-0.453,0.566-0.97,0.979-1.55,1.239c-0.58,0.261-1.189,0.391-1.83,0.391c-0.68,0-1.276-0.127-1.79-0.38c-0.514-0.254-0.943-0.573-1.29-0.96L359.854,269.911z M362.614,265.851c0.413,0,0.856-0.13,1.329-0.39c0.474-0.26,0.924-0.696,1.351-1.311c-0.107-1.253-0.4-2.199-0.88-2.84c-0.48-0.64-1.127-0.96-1.94-0.96c-0.307,0-0.597,0.067-0.87,0.2c-0.273,0.134-0.51,0.323-0.71,0.57s-0.356,0.543-0.47,0.89s-0.17,0.728-0.17,1.141c0,0.84,0.193,1.499,0.58,1.979C361.221,265.61,361.813,265.851,362.614,265.851z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M372.834,272.291c-1.294,0-2.301-0.573-3.021-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.899c0.72-1.12,1.727-1.681,3.021-1.681c1.279,0,2.279,0.561,3,1.681c0.72,1.119,1.079,2.753,1.079,4.899s-0.359,3.793-1.079,4.939C375.113,271.718,374.113,272.291,372.834,272.291z M372.834,270.971c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.779-0.96c0.221-0.434,0.391-0.987,0.511-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.399c-0.12-0.667-0.29-1.21-0.511-1.631c-0.22-0.42-0.479-0.729-0.779-0.93s-0.637-0.3-1.01-0.3c-0.374,0-0.714,0.1-1.021,0.3s-0.57,0.51-0.79,0.93c-0.22,0.421-0.39,0.964-0.51,1.631c-0.12,0.666-0.18,1.466-0.18,2.399c0,1.867,0.229,3.224,0.689,4.07S372.087,270.971,372.834,270.971z"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{attrs:{"d":"M126.6,220.617c0.96-0.96,1.813-1.826,2.56-2.6s1.373-1.49,1.88-2.15c0.506-0.659,0.893-1.266,1.16-1.819c0.267-0.553,0.4-1.09,0.4-1.61c0-0.732-0.2-1.333-0.6-1.8c-0.4-0.467-1.007-0.7-1.82-0.7c-0.533,0-1.027,0.15-1.48,0.45s-0.867,0.664-1.24,1.09l-0.94-0.939c0.533-0.587,1.1-1.057,1.7-1.41s1.32-0.53,2.16-0.53c1.187,0,2.12,0.344,2.8,1.03s1.021,1.597,1.021,2.729c0,0.601-0.131,1.204-0.391,1.811s-0.62,1.233-1.08,1.88s-1.007,1.319-1.64,2.02s-1.33,1.443-2.09,2.23c0.346-0.026,0.707-0.054,1.08-0.08c0.374-0.026,0.727-0.04,1.06-0.04h3.7v1.42h-8.24V220.617z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M140.72,221.838c-1.294,0-2.301-0.573-3.021-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.899c0.72-1.12,1.727-1.681,3.021-1.681c1.279,0,2.279,0.561,3,1.681c0.72,1.119,1.079,2.753,1.079,4.899s-0.359,3.793-1.079,4.939C143,221.265,142,221.838,140.72,221.838z M140.72,220.518c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.779-0.96c0.221-0.434,0.391-0.987,0.511-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.399c-0.12-0.667-0.29-1.21-0.511-1.631c-0.22-0.42-0.479-0.729-0.779-0.93s-0.637-0.3-1.01-0.3c-0.374,0-0.714,0.1-1.021,0.3s-0.57,0.51-0.79,0.93c-0.22,0.421-0.39,0.964-0.51,1.631c-0.12,0.666-0.18,1.466-0.18,2.399c0,1.867,0.229,3.224,0.689,4.07S139.973,220.518,140.72,220.518z"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{attrs:{"d":"M355.115,218.25c0-0.413,0.07-0.797,0.21-1.15c0.14-0.353,0.32-0.673,0.54-0.96c0.22-0.286,0.473-0.54,0.76-0.76s0.583-0.41,0.891-0.57v-0.08c-0.468-0.333-0.881-0.736-1.24-1.21c-0.36-0.473-0.54-1.05-0.54-1.73c0-0.493,0.093-0.94,0.28-1.34c0.187-0.4,0.439-0.743,0.76-1.03c0.319-0.287,0.7-0.51,1.14-0.67c0.44-0.16,0.92-0.24,1.44-0.24c0.56,0,1.06,0.083,1.5,0.25c0.439,0.167,0.816,0.4,1.13,0.7c0.312,0.3,0.553,0.66,0.72,1.08c0.166,0.42,0.25,0.877,0.25,1.37c0,0.333-0.057,0.653-0.17,0.96c-0.113,0.307-0.254,0.594-0.42,0.86c-0.167,0.268-0.354,0.507-0.561,0.721c-0.206,0.213-0.409,0.393-0.609,0.54v0.079c0.28,0.16,0.553,0.344,0.82,0.551c0.266,0.206,0.502,0.439,0.709,0.699c0.207,0.261,0.373,0.558,0.5,0.891s0.19,0.713,0.19,1.14c0,0.48-0.101,0.927-0.3,1.34c-0.2,0.414-0.48,0.773-0.84,1.08c-0.36,0.307-0.794,0.547-1.3,0.721c-0.507,0.173-1.067,0.26-1.681,0.26c-0.6,0-1.156-0.087-1.67-0.26c-0.514-0.174-0.953-0.417-1.32-0.73c-0.366-0.313-0.656-0.684-0.869-1.11C355.222,219.224,355.115,218.757,355.115,218.25z M356.595,218.09c0,0.36,0.07,0.687,0.21,0.979c0.141,0.294,0.334,0.551,0.58,0.771c0.247,0.22,0.537,0.39,0.87,0.51s0.693,0.18,1.08,0.18c0.747,0,1.351-0.206,1.811-0.619s0.689-0.953,0.689-1.62c0-0.413-0.093-0.767-0.28-1.061c-0.187-0.293-0.439-0.55-0.76-0.77c-0.319-0.22-0.689-0.42-1.109-0.601c-0.42-0.18-0.857-0.362-1.311-0.55c-0.507,0.347-0.93,0.75-1.27,1.21S356.595,217.503,356.595,218.09z M360.195,214.55c0.427-0.387,0.757-0.793,0.99-1.22c0.232-0.426,0.35-0.873,0.35-1.34c0-0.64-0.193-1.177-0.58-1.61s-0.934-0.65-1.64-0.65c-0.601,0-1.094,0.187-1.48,0.56c-0.387,0.374-0.58,0.874-0.58,1.5c0,0.387,0.08,0.717,0.24,0.99c0.16,0.273,0.377,0.517,0.65,0.73c0.272,0.214,0.586,0.403,0.939,0.57S359.809,214.404,360.195,214.55z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M369.215,221.75c-1.294,0-2.301-0.573-3.021-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.9c0.72-1.12,1.727-1.68,3.021-1.68c1.279,0,2.279,0.56,3,1.68c0.72,1.12,1.079,2.753,1.079,4.9s-0.359,3.793-1.079,4.939C371.494,221.177,370.494,221.75,369.215,221.75z M369.215,220.43c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.779-0.96c0.221-0.434,0.391-0.987,0.511-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.4s-0.29-1.21-0.511-1.63c-0.22-0.42-0.479-0.73-0.779-0.93c-0.3-0.2-0.637-0.3-1.01-0.3c-0.374,0-0.714,0.1-1.021,0.3c-0.307,0.2-0.57,0.51-0.79,0.93c-0.22,0.42-0.39,0.964-0.51,1.63s-0.18,1.466-0.18,2.4c0,1.867,0.229,3.224,0.689,4.07S368.468,220.43,369.215,220.43z"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{attrs:{"d":"M151.401,174.476c0.387,0.399,0.837,0.753,1.35,1.06s1.15,0.46,1.91,0.46c0.773,0,1.406-0.21,1.9-0.63c0.493-0.42,0.74-0.99,0.74-1.71c0-0.373-0.07-0.717-0.21-1.03c-0.14-0.312-0.37-0.583-0.69-0.81c-0.32-0.227-0.74-0.4-1.26-0.521s-1.16-0.18-1.92-0.18v-1.26c0.68,0,1.25-0.061,1.71-0.181c0.46-0.119,0.833-0.286,1.12-0.5c0.287-0.213,0.49-0.466,0.61-0.76c0.12-0.293,0.18-0.606,0.18-0.94c0-0.626-0.197-1.12-0.59-1.48c-0.394-0.36-0.93-0.54-1.61-0.54c-0.534,0-1.023,0.12-1.47,0.36c-0.447,0.24-0.863,0.553-1.25,0.94l-0.88-1.04c0.493-0.467,1.037-0.85,1.63-1.15c0.593-0.3,1.27-0.45,2.03-0.45c0.56,0,1.073,0.073,1.54,0.22c0.466,0.146,0.87,0.356,1.21,0.63c0.34,0.273,0.603,0.61,0.79,1.01c0.187,0.4,0.28,0.86,0.28,1.38c0,0.773-0.214,1.407-0.641,1.899c-0.427,0.494-0.987,0.874-1.68,1.141v0.08c0.386,0.093,0.747,0.229,1.08,0.409c0.333,0.181,0.626,0.407,0.88,0.681c0.253,0.273,0.45,0.59,0.59,0.95c0.14,0.359,0.21,0.76,0.21,1.199c0,0.561-0.11,1.067-0.33,1.521s-0.52,0.837-0.9,1.149c-0.38,0.313-0.823,0.554-1.33,0.721c-0.507,0.166-1.053,0.25-1.64,0.25c-0.507,0-0.97-0.05-1.39-0.15c-0.42-0.1-0.804-0.233-1.15-0.399c-0.347-0.167-0.657-0.357-0.93-0.57c-0.273-0.213-0.517-0.44-0.73-0.68L151.401,174.476z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M164.961,177.356c-1.294,0-2.301-0.573-3.021-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.9c0.72-1.12,1.727-1.68,3.021-1.68c1.279,0,2.279,0.56,3,1.68c0.72,1.12,1.079,2.753,1.079,4.9s-0.359,3.793-1.079,4.939C167.24,176.783,166.24,177.356,164.961,177.356z M164.961,176.036c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.779-0.96c0.221-0.434,0.391-0.987,0.511-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.4s-0.29-1.21-0.511-1.63c-0.22-0.42-0.479-0.73-0.779-0.93c-0.3-0.2-0.637-0.3-1.01-0.3c-0.374,0-0.714,0.1-1.021,0.3c-0.307,0.2-0.57,0.51-0.79,0.93c-0.22,0.42-0.39,0.964-0.51,1.63s-0.18,1.466-0.18,2.4c0,1.867,0.229,3.224,0.689,4.07S164.214,176.036,164.961,176.036z"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{attrs:{"d":"M333.88,173.816c0.16-1,0.384-1.95,0.67-2.851c0.287-0.899,0.653-1.77,1.101-2.609c0.446-0.84,0.983-1.7,1.61-2.58h-6.36v-1.42h8.22v1.02c-0.76,0.96-1.377,1.88-1.85,2.76c-0.474,0.88-0.851,1.777-1.13,2.69c-0.28,0.913-0.483,1.88-0.61,2.9c-0.127,1.02-0.217,2.149-0.27,3.39h-1.7C333.613,175.916,333.721,174.816,333.88,173.816z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M344.94,177.356c-1.294,0-2.301-0.573-3.021-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.9c0.72-1.12,1.727-1.68,3.021-1.68c1.279,0,2.279,0.56,3,1.68c0.72,1.12,1.079,2.753,1.079,4.9s-0.359,3.793-1.079,4.939C347.22,176.783,346.22,177.356,344.94,177.356z M344.94,176.036c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.779-0.96c0.221-0.434,0.391-0.987,0.511-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.4s-0.29-1.21-0.511-1.63c-0.22-0.42-0.479-0.73-0.779-0.93c-0.3-0.2-0.637-0.3-1.01-0.3c-0.374,0-0.714,0.1-1.021,0.3c-0.307,0.2-0.57,0.51-0.79,0.93c-0.22,0.42-0.39,0.964-0.51,1.63s-0.18,1.466-0.18,2.4c0,1.867,0.229,3.224,0.689,4.07S344.193,176.036,344.94,176.036z"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{attrs:{"d":"M297.471,136.172c-0.268-0.307-0.584-0.55-0.95-0.73c-0.367-0.18-0.75-0.27-1.15-0.27c-0.439,0-0.859,0.094-1.26,0.28c-0.399,0.187-0.753,0.493-1.06,0.92c-0.308,0.427-0.554,0.983-0.74,1.67c-0.187,0.687-0.287,1.537-0.3,2.55c0.399-0.493,0.866-0.883,1.399-1.17c0.533-0.286,1.061-0.43,1.58-0.43c1.106,0,1.99,0.327,2.65,0.979c0.659,0.653,0.989,1.641,0.989,2.96c0,0.614-0.1,1.17-0.3,1.67s-0.474,0.931-0.82,1.29c-0.346,0.36-0.746,0.641-1.199,0.841c-0.453,0.199-0.94,0.3-1.46,0.3c-0.627,0-1.207-0.127-1.74-0.38c-0.533-0.254-0.997-0.637-1.39-1.15c-0.394-0.513-0.704-1.153-0.931-1.92s-0.34-1.663-0.34-2.69c0-1.279,0.134-2.37,0.4-3.27s0.626-1.633,1.08-2.2c0.453-0.566,0.97-0.98,1.55-1.24c0.58-0.26,1.19-0.39,1.83-0.39c0.693,0,1.29,0.13,1.79,0.39c0.5,0.26,0.93,0.583,1.29,0.97L297.471,136.172z M294.851,145.733c0.32,0,0.613-0.067,0.88-0.2c0.267-0.134,0.5-0.323,0.7-0.57c0.2-0.246,0.356-0.54,0.47-0.88s0.17-0.724,0.17-1.15c0-0.84-0.193-1.5-0.58-1.979c-0.387-0.48-0.979-0.72-1.779-0.72c-0.4,0-0.837,0.13-1.311,0.39s-0.924,0.689-1.35,1.29c0.106,1.253,0.396,2.203,0.87,2.85C293.394,145.41,294.037,145.733,294.851,145.733z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M304.41,147.033c-1.294,0-2.301-0.573-3.021-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.9c0.72-1.12,1.727-1.68,3.021-1.68c1.279,0,2.279,0.56,3,1.68c0.72,1.12,1.079,2.753,1.079,4.9s-0.359,3.793-1.079,4.939C306.689,146.459,305.689,147.033,304.41,147.033z M304.41,145.712c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.779-0.96c0.221-0.434,0.391-0.987,0.511-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.4s-0.29-1.21-0.511-1.63c-0.22-0.42-0.479-0.73-0.779-0.93c-0.3-0.2-0.637-0.3-1.01-0.3c-0.374,0-0.714,0.1-1.021,0.3c-0.307,0.2-0.57,0.51-0.79,0.93c-0.22,0.42-0.39,0.964-0.51,1.63s-0.18,1.466-0.18,2.4c0,1.867,0.229,3.224,0.689,4.07S303.663,145.712,304.41,145.712z"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{attrs:{"d":"M199.928,143.273h-1.74v3.52h-1.56v-3.52h-5.74v-1.08l5.46-8.16h1.84v7.92h1.74V143.273z M196.628,141.953v-3.7c0-0.347,0.01-0.756,0.03-1.23c0.02-0.473,0.043-0.883,0.07-1.23h-0.08c-0.16,0.307-0.327,0.607-0.5,0.9c-0.173,0.293-0.354,0.594-0.54,0.9l-2.98,4.36H196.628z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M205.468,147.033c-1.294,0-2.301-0.573-3.021-1.721c-0.72-1.146-1.08-2.793-1.08-4.939s0.36-3.78,1.08-4.9c0.72-1.12,1.727-1.68,3.021-1.68c1.279,0,2.279,0.56,3,1.68c0.72,1.12,1.079,2.753,1.079,4.9s-0.359,3.793-1.079,4.939C207.747,146.46,206.747,147.033,205.468,147.033z M205.468,145.713c0.373,0,0.71-0.104,1.01-0.31c0.3-0.207,0.56-0.527,0.779-0.96c0.221-0.434,0.391-0.987,0.511-1.66c0.12-0.674,0.18-1.477,0.18-2.41s-0.06-1.733-0.18-2.4s-0.29-1.21-0.511-1.63c-0.22-0.42-0.479-0.73-0.779-0.93c-0.3-0.2-0.637-0.3-1.01-0.3c-0.374,0-0.714,0.1-1.021,0.3c-0.307,0.2-0.57,0.51-0.79,0.93c-0.22,0.42-0.39,0.964-0.51,1.63s-0.18,1.466-0.18,2.4c0,1.867,0.229,3.224,0.689,4.07S204.721,145.713,205.468,145.713z"}})])])])])}
var AppScalePercentageMobile_staticRenderFns = []
var AppScalePercentageMobile_esExports = { render: AppScalePercentageMobile_render, staticRenderFns: AppScalePercentageMobile_staticRenderFns }
/* harmony default export */ var components_AppScalePercentageMobile = (AppScalePercentageMobile_esExports);
// CONCATENATED MODULE: ./src/components/AppScalePercentageMobile.vue
function AppScalePercentageMobile_injectStyle (ssrContext) {
  __webpack_require__("Dntb")
}
var AppScalePercentageMobile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppScalePercentageMobile___vue_template_functional__ = false
/* styles */
var AppScalePercentageMobile___vue_styles__ = AppScalePercentageMobile_injectStyle
/* scopeId */
var AppScalePercentageMobile___vue_scopeId__ = "data-v-9c85382a"
/* moduleIdentifier (server only) */
var AppScalePercentageMobile___vue_module_identifier__ = null
var AppScalePercentageMobile_Component = AppScalePercentageMobile_normalizeComponent(
  AppScalePercentageMobile,
  components_AppScalePercentageMobile,
  AppScalePercentageMobile___vue_template_functional__,
  AppScalePercentageMobile___vue_styles__,
  AppScalePercentageMobile___vue_scopeId__,
  AppScalePercentageMobile___vue_module_identifier__
)

/* harmony default export */ var src_components_AppScalePercentageMobile = (AppScalePercentageMobile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardAnswerPercent.vue



/* harmony default export */ var CardAnswerPercent = ({
  props: ['question'],
  data: function data() {
    return {
      currentlyHovered: false,
      categories: function () {
        var percentage_categories = [];
        var percentages = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
        for (var index in percentages) {
          var percentage = percentages[index];
          percentage_categories.push({
            percent: percentage,
            description: 'percent' + percentage + 'Description'
          });
        }
        return percentage_categories;
      }()
    };
  },
  methods: {
    answer_question: function answer_question(percent) {
      eventHub.$emit('answer-question', { 'answerScore': percent, 'answerValue': percent, 'questionId': this.question.id });
    },
    getCategoryByPercentage: function getCategoryByPercentage(percent) {
      for (var index in this.categories) {
        var category = this.categories[index];
        if (category.percent === percent) {
          return category;
        }
      }
      return false;
    },
    percentageSign: function percentageSign(index, list) {
      if (index === 0 || index === list.length - 1) {
        return '%';
      }
      return '';
    },
    isPercentageSelected: function isPercentageSelected(percent) {
      return !!this.question.answer && this.question.answer.answerScore * 1 === percent * 1;
    }
  },
  computed: {
    currentlyHighlightedCategoryDescription: function currentlyHighlightedCategoryDescription() {
      if (this.currentlyHovered) {
        return this.$t(this.currentlyHovered.description);
      } else if (this.question.answer.answerValue !== '') {
        return this.$t(this.getCategoryByPercentage(this.question.answer.answerValue).description);
      }
      return '';
    }
  },
  components: {
    AppScalePercentageMobile: src_components_AppScalePercentageMobile
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5de0a428","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardAnswerPercent.vue
var CardAnswerPercent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-answer cst-survey-answer-percent"},[_c('div',{staticClass:"cst-survey-answer-percent-desktop"},[_c('div',{staticClass:"cst-survey-answer-percent-legend-container"},[_c('div',{staticClass:"legend-primer legend-primer-negative"},[_vm._v(_vm._s(_vm.$t('legendPrimerNegative')))]),_vm._v(" "),_c('div',{staticClass:"legend-primer legend-primer-positive"},[_vm._v(_vm._s(_vm.$t('legendPrimerPositive')))])]),_vm._v(" "),_c('ul',_vm._l((_vm.categories),function(entry,index){return _c('li',{key:entry.percent,class:{ selected: _vm.isPercentageSelected(entry.percent)},on:{"mouseover":function($event){_vm.currentlyHovered = entry},"mouseleave":function($event){_vm.currentlyHovered = false},"click":function($event){return _vm.answer_question(entry.percent)}}},[_vm._v("\n                "+_vm._s(entry.percent)+_vm._s(_vm.percentageSign(index,_vm.categories))+"\n            ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"cst-survey-answer-percent-mobile"},[_c('app-scale-percentage-mobile',{attrs:{"answer_question":_vm.answer_question,"isPercentageSelected":_vm.isPercentageSelected}})],1)])}
var CardAnswerPercent_staticRenderFns = []
var CardAnswerPercent_esExports = { render: CardAnswerPercent_render, staticRenderFns: CardAnswerPercent_staticRenderFns }
/* harmony default export */ var components_CardAnswerPercent = (CardAnswerPercent_esExports);
// CONCATENATED MODULE: ./src/components/CardAnswerPercent.vue
function CardAnswerPercent_injectStyle (ssrContext) {
  __webpack_require__("+aZZ")
}
var CardAnswerPercent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardAnswerPercent___vue_template_functional__ = false
/* styles */
var CardAnswerPercent___vue_styles__ = CardAnswerPercent_injectStyle
/* scopeId */
var CardAnswerPercent___vue_scopeId__ = "data-v-5de0a428"
/* moduleIdentifier (server only) */
var CardAnswerPercent___vue_module_identifier__ = null
var CardAnswerPercent_Component = CardAnswerPercent_normalizeComponent(
  CardAnswerPercent,
  components_CardAnswerPercent,
  CardAnswerPercent___vue_template_functional__,
  CardAnswerPercent___vue_styles__,
  CardAnswerPercent___vue_scopeId__,
  CardAnswerPercent___vue_module_identifier__
)

/* harmony default export */ var src_components_CardAnswerPercent = (CardAnswerPercent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppSmiley.vue


/* harmony default export */ var AppSmiley = ({
  props: ['currentlyHighlightedCategoryName', 'category'],
  data: function data() {
    return {};
  },
  computed: {
    isHighlighted: function isHighlighted() {
      return this.currentlyHighlightedCategoryName === this.category.name;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8efe4eb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSmiley.vue
var AppSmiley_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{class:{ selected: _vm.isHighlighted},attrs:{"id":"smiley","xmlns":"http://www.w3.org/2000/svg","width":"62","height":"57","viewBox":"0 0 62 57"}},[_c('defs'),_vm._v(" "),_c('path',{attrs:{"id":"background","d":"M57.887,0H4.113A4.114,4.114,0,0,0,0,4.113V52.887A4.114,4.114,0,0,0,4.113,57H57.887A4.114,4.114,0,0,0,62,52.887V4.113A4.114,4.114,0,0,0,57.887,0ZM31,48.5a20,20,0,1,1,20-20A20,20,0,0,1,31,48.5Z"}}),_vm._v(" "),_c('circle',{staticStyle:{"fill":"#fff"},attrs:{"id":"head","cx":"31","cy":"28.5","r":"16.667"}}),_vm._v(" "),_c('path',{attrs:{"id":"head-border","d":"M31,8.5a20,20,0,1,0,20,20A20,20,0,0,0,31,8.5Zm0,36.667A16.667,16.667,0,1,1,47.667,28.5,16.682,16.682,0,0,1,31,45.167Z"}}),_vm._v(" "),_c('ellipse',{staticClass:"face",attrs:{"id":"left-eye","cx":"24.5","cy":"21.833","rx":"3.5","ry":"3.333"}}),_vm._v(" "),(_vm.category.name == 'veryhappy')?_c('path',{staticClass:"face",attrs:{"id":"mouth_very-happy","d":"M39.463,31.081a1.574,1.574,0,0,0-.21-.045l-.009,0a1.644,1.644,0,0,0-.25-.026c-.027,0-.052-.008-.079-.008l-15.83,0c-.027,0-.052.007-.079.008a1.782,1.782,0,0,0-.25.026l-.009,0a1.749,1.749,0,0,0-.21.045,1.655,1.655,0,0,0-1.068,2.083A9.923,9.923,0,0,0,31,40.167v0a9.922,9.922,0,0,0,9.531-7A1.654,1.654,0,0,0,39.463,31.081Z"}}):(_vm.category.name == 'happy')?_c('path',{staticClass:"face",attrs:{"id":"mouth-happy","d":"M31,40.167a9.923,9.923,0,0,1-9.531-7.006,1.664,1.664,0,1,1,3.177-.989,6.661,6.661,0,0,0,12.708,0,1.677,1.677,0,0,1,2.109-1.094,1.655,1.655,0,0,1,1.068,2.083A9.923,9.923,0,0,1,31,40.167Z"}}):(_vm.category.name == 'medium')?_c('path',{staticClass:"face",attrs:{"id":"mouth-medium","d":"M39.333,35.167H22.667a1.667,1.667,0,0,1,0-3.334H39.333a1.667,1.667,0,0,1,0,3.334Z"}}):(_vm.category.name == 'unhappy')?_c('path',{staticClass:"face",attrs:{"id":"mouth-unhappy","d":"M39.463,39.255a1.676,1.676,0,0,1-2.109-1.094,6.661,6.661,0,0,0-12.708,0,1.664,1.664,0,1,1-3.177-.99,9.987,9.987,0,0,1,19.062,0A1.655,1.655,0,0,1,39.463,39.255Z"}}):(_vm.category.name == 'veryunhappy')?_c('path',{staticClass:"face",attrs:{"id":"mouth_very-unhappy","d":"M22.537,39.255a1.754,1.754,0,0,0,.21.046h.009a1.526,1.526,0,0,0,.25.026c.027,0,.052.008.079.008l15.83,0c.027,0,.052-.007.079-.008a1.644,1.644,0,0,0,.25-.026l.009,0a1.574,1.574,0,0,0,.21-.045,1.654,1.654,0,0,0,1.068-2.083,9.922,9.922,0,0,0-9.531-7v0a9.922,9.922,0,0,0-9.531,7A1.654,1.654,0,0,0,22.537,39.255Z"}}):_vm._e(),_vm._v(" "),_c('circle',{staticClass:"face",attrs:{"id":"right-eye","cx":"37.667","cy":"21.833","r":"3.333"}})])])}
var AppSmiley_staticRenderFns = []
var AppSmiley_esExports = { render: AppSmiley_render, staticRenderFns: AppSmiley_staticRenderFns }
/* harmony default export */ var components_AppSmiley = (AppSmiley_esExports);
// CONCATENATED MODULE: ./src/components/AppSmiley.vue
function AppSmiley_injectStyle (ssrContext) {
  __webpack_require__("vIWH")
}
var AppSmiley_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppSmiley___vue_template_functional__ = false
/* styles */
var AppSmiley___vue_styles__ = AppSmiley_injectStyle
/* scopeId */
var AppSmiley___vue_scopeId__ = "data-v-8efe4eb2"
/* moduleIdentifier (server only) */
var AppSmiley___vue_module_identifier__ = null
var AppSmiley_Component = AppSmiley_normalizeComponent(
  AppSmiley,
  components_AppSmiley,
  AppSmiley___vue_template_functional__,
  AppSmiley___vue_styles__,
  AppSmiley___vue_scopeId__,
  AppSmiley___vue_module_identifier__
)

/* harmony default export */ var src_components_AppSmiley = (AppSmiley_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardAnswerScale.vue



/* harmony default export */ var CardAnswerScale = ({
  props: ['question'],
  data: function data() {
    return {
      currentlyHovered: false,
      entryunselectedText: this.$t('smileyNotScored'),
      categories: [{
        name: 'veryunhappy',
        url: __webpack_require__("LHCj"),
        percentage: 20,
        description: this.$t('smileyVeryUnhappy')
      }, {
        name: 'unhappy',
        url: __webpack_require__("lv/G"),
        percentage: 40,
        description: this.$t('smileyUnhappy')
      }, {
        name: 'medium',
        url: __webpack_require__("6U+c"),
        percentage: 60,
        description: this.$t('smileyMedium')
      }, {
        name: 'happy',
        url: __webpack_require__("SieH"),
        percentage: 80,
        description: this.$t('smileyHappy')
      }, {
        name: 'veryhappy',
        url: __webpack_require__("hfGC"),
        percentage: 100,
        description: this.$t('smileyVeryHappy')
      }]
    };
  },
  computed: {
    currentlyHighlightedCategoryName: function currentlyHighlightedCategoryName() {
      if (this.currentlyHovered) {
        return this.currentlyHovered.name;
      } else if (this.question.answer.answerValue !== '') {
        for (var category_index in this.categories) {
          var category = this.categories[category_index];
          if (category.percentage === this.question.answer.answerValue * 1) {
            return category.name;
          }
        }
      } else {
        return '';
      }
    },
    currentlySelectedElement: function currentlySelectedElement() {
      if (this.currentlyHovered) {
        return this.currentlyHovered.description;
      } else if (this.question.answer.answerValue === '') {
        return this.entryunselectedText;
      } else {
        for (var category_index in this.categories) {
          var category = this.categories[category_index];
          if (category.percentage === this.question.answer.answerValue) {
            return category.description;
          }
        }
      }
    }
  },
  methods: {
    answer_question: function answer_question(answer) {
      eventHub.$emit('answer-question', { 'answerScore': answer, 'answerValue': answer, 'questionId': this.question.id });
    }
  },
  components: {
    AppSmiley: src_components_AppSmiley
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2202eac6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardAnswerScale.vue
var CardAnswerScale_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-answer cst-survey-answer-scale"},[_c('div',{staticClass:"currently-selected"},[_vm._v(" "+_vm._s(_vm.currentlySelectedElement)+" ")]),_vm._v(" "),_c('ul',_vm._l((_vm.categories),function(entry){return _c('li',{key:entry.name,class:{ selected: _vm.question.answer.answerValue != '' && _vm.question.answer.answerValue == entry.percentage},on:{"mouseover":function($event){_vm.currentlyHovered = entry},"mouseleave":function($event){_vm.currentlyHovered = false},"click":function($event){return _vm.answer_question(entry.percentage)}}},[_c('app-smiley',{attrs:{"currentlyHighlightedCategoryName":_vm.currentlyHighlightedCategoryName,"category":entry}})],1)}),0)])}
var CardAnswerScale_staticRenderFns = []
var CardAnswerScale_esExports = { render: CardAnswerScale_render, staticRenderFns: CardAnswerScale_staticRenderFns }
/* harmony default export */ var components_CardAnswerScale = (CardAnswerScale_esExports);
// CONCATENATED MODULE: ./src/components/CardAnswerScale.vue
function CardAnswerScale_injectStyle (ssrContext) {
  __webpack_require__("3D1X")
}
var CardAnswerScale_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardAnswerScale___vue_template_functional__ = false
/* styles */
var CardAnswerScale___vue_styles__ = CardAnswerScale_injectStyle
/* scopeId */
var CardAnswerScale___vue_scopeId__ = "data-v-2202eac6"
/* moduleIdentifier (server only) */
var CardAnswerScale___vue_module_identifier__ = null
var CardAnswerScale_Component = CardAnswerScale_normalizeComponent(
  CardAnswerScale,
  components_CardAnswerScale,
  CardAnswerScale___vue_template_functional__,
  CardAnswerScale___vue_styles__,
  CardAnswerScale___vue_scopeId__,
  CardAnswerScale___vue_module_identifier__
)

/* harmony default export */ var src_components_CardAnswerScale = (CardAnswerScale_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardAnswerText.vue


/* harmony default export */ var CardAnswerText = ({
  data: function data() {
    return {
      answerText: '',
      currentAnswerText: ''
    };
  },
  props: ['question'],
  methods: {
    answer_question: function answer_question() {
      var _this = this;

      return new promise_default.a(function (resolve, reject) {
        if (_this.answerText !== _this.currentAnswerText) {
          eventHub.$emit('answer-question', { 'answerValue': 0, 'answerText': _this.answerText, 'questionId': _this.question.id }, false);
        }
        resolve();
      });
    }
  },
  created: function created() {
    this.answerText = this.question.answer.answerText;
    this.currentAnswerText = this.question.answer.answerText;
    eventHub.$emit('pre-change-register', this.answer_question);
  },
  watch: {
    answerText: function answerText() {
      this.question.answer.answerText = this.answerText;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d12a684","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardAnswerText.vue
var CardAnswerText_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-answer cst-survey-answer-text"},[_c('textarea',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.answerText),expression:"answerText",modifiers:{"lazy":true}}],domProps:{"value":(_vm.answerText)},on:{"change":function($event){_vm.answerText=$event.target.value}}})])}
var CardAnswerText_staticRenderFns = []
var CardAnswerText_esExports = { render: CardAnswerText_render, staticRenderFns: CardAnswerText_staticRenderFns }
/* harmony default export */ var components_CardAnswerText = (CardAnswerText_esExports);
// CONCATENATED MODULE: ./src/components/CardAnswerText.vue
function CardAnswerText_injectStyle (ssrContext) {
  __webpack_require__("jQtg")
}
var CardAnswerText_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardAnswerText___vue_template_functional__ = false
/* styles */
var CardAnswerText___vue_styles__ = CardAnswerText_injectStyle
/* scopeId */
var CardAnswerText___vue_scopeId__ = "data-v-8d12a684"
/* moduleIdentifier (server only) */
var CardAnswerText___vue_module_identifier__ = null
var CardAnswerText_Component = CardAnswerText_normalizeComponent(
  CardAnswerText,
  components_CardAnswerText,
  CardAnswerText___vue_template_functional__,
  CardAnswerText___vue_styles__,
  CardAnswerText___vue_scopeId__,
  CardAnswerText___vue_module_identifier__
)

/* harmony default export */ var src_components_CardAnswerText = (CardAnswerText_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardButtonBar.vue


/* harmony default export */ var CardButtonBar = ({
  props: ['question', 'skippable'],
  methods: {
    showFeedbackModal: function showFeedbackModal() {
      eventHub.$emit('show-modal', { type: 'card-feedback-comment', id: 6, content: { title: this.question.group_title, group_id: this.question.group_id } });
    },
    skipCard: function skipCard() {
      eventHub.$emit('card-next');
    }
  },
  computed: {
    isFilloutHintShown: function isFilloutHintShown() {
      return this.question.review && !keys_default()(this.$store.state.reviews).length;
    },
    isNextButtonShown: function isNextButtonShown() {
      return this.question.type === 'text';
    },
    isSkipButtonShown: function isSkipButtonShown() {
      return this.question.type === 'percent' && this.skippable;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79d053aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardButtonBar.vue
var CardButtonBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'spacer-box': 1, 'fillout-hint': _vm.isFilloutHintShown}},[_c('div',{staticClass:"cst-survey-card-button-bar"},[(_vm.question.review)?_c('button',{staticClass:"cst-survey-comment",on:{"click":function($event){return _vm.showFeedbackModal()}}},[_vm._v(_vm._s(_vm.$t("btnFeedback")))]):_vm._e(),_vm._v(" "),(_vm.isNextButtonShown)?_c('button',{staticClass:"cst-survey-next-skip-btn",class:{'cst-survey-btn-disabled': !_vm.skippable},attrs:{"disabled":!_vm.skippable},on:{"click":_vm.skipCard}},[_vm._v(_vm._s(_vm.$t("btnNext")))]):_vm._e(),_vm._v(" "),(_vm.isSkipButtonShown)?_c('button',{staticClass:"cst-survey-next-skip-btn",on:{"click":_vm.skipCard}},[_vm._v(_vm._s(_vm.$t("btnSkip")))]):_vm._e(),_vm._v(" "),(_vm.question.review)?_c('div',{staticClass:"survey-comment-mobile-box"},[_c('button',{staticClass:"cst-survey-comment-mobile",on:{"click":function($event){return _vm.showFeedbackModal()}}},[_vm._v(_vm._s(_vm.$t("btnFeedback"))),_c('img',{staticClass:"arrow-icon",attrs:{"src":__webpack_require__("LNSM")}})])]):_vm._e()]),_vm._v(" "),(_vm.isFilloutHintShown)?_c('div',{class:{ 'comment-fillout-hint': 1, 'additional-button': _vm.isNextButtonShown || _vm.isSkipButtonShown }},[_c('div',{staticClass:"comment-fillout-hint-content"},[_c('img',{staticClass:"comment-fillout-arrow",attrs:{"src":__webpack_require__("gw6/")}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('txtSuggestFeedback'))+" ")])])]):_vm._e()])}
var CardButtonBar_staticRenderFns = []
var CardButtonBar_esExports = { render: CardButtonBar_render, staticRenderFns: CardButtonBar_staticRenderFns }
/* harmony default export */ var components_CardButtonBar = (CardButtonBar_esExports);
// CONCATENATED MODULE: ./src/components/CardButtonBar.vue
function CardButtonBar_injectStyle (ssrContext) {
  __webpack_require__("LCSo")
  __webpack_require__("lAVY")
}
var CardButtonBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardButtonBar___vue_template_functional__ = false
/* styles */
var CardButtonBar___vue_styles__ = CardButtonBar_injectStyle
/* scopeId */
var CardButtonBar___vue_scopeId__ = "data-v-79d053aa"
/* moduleIdentifier (server only) */
var CardButtonBar___vue_module_identifier__ = null
var CardButtonBar_Component = CardButtonBar_normalizeComponent(
  CardButtonBar,
  components_CardButtonBar,
  CardButtonBar___vue_template_functional__,
  CardButtonBar___vue_styles__,
  CardButtonBar___vue_scopeId__,
  CardButtonBar___vue_module_identifier__
)

/* harmony default export */ var src_components_CardButtonBar = (CardButtonBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardQuestion.vue







/* harmony default export */ var CardQuestion = ({
  data: function data() {
    return {};
  },
  props: ['content'],
  computed: {
    skippable: function skippable() {
      return this.question.skippable();
    },
    answerType: function answerType() {
      return 'card-answer-' + this.question.type;
    },
    question: function question() {
      return this.$store.state.decks[0].questions[this.content.id];
    }
  },
  created: function created() {
    eventHub.$emit('set-title', this.question.group_title);
  },
  watch: {
    question: function question(newQuestion, oldQuestion) {
      eventHub.$emit('set-title', newQuestion.group_title);
    }
  },
  components: {
    CardAnswerOption: src_components_CardAnswerOption, CardAnswerScale: src_components_CardAnswerScale, CardAnswerPercent: src_components_CardAnswerPercent, CardButtonBar: src_components_CardButtonBar, CardAnswerText: src_components_CardAnswerText
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e901428","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardQuestion.vue
var CardQuestion_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-card-question"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.question.question)}}),_vm._v(" "),_c(_vm.answerType,{tag:"component",attrs:{"question":_vm.question}}),_vm._v(" "),_c('card-button-bar',{attrs:{"question":_vm.question,"skippable":_vm.skippable}})],1)}
var CardQuestion_staticRenderFns = []
var CardQuestion_esExports = { render: CardQuestion_render, staticRenderFns: CardQuestion_staticRenderFns }
/* harmony default export */ var components_CardQuestion = (CardQuestion_esExports);
// CONCATENATED MODULE: ./src/components/CardQuestion.vue
function CardQuestion_injectStyle (ssrContext) {
  __webpack_require__("riau")
}
var CardQuestion_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardQuestion___vue_template_functional__ = false
/* styles */
var CardQuestion___vue_styles__ = CardQuestion_injectStyle
/* scopeId */
var CardQuestion___vue_scopeId__ = "data-v-6e901428"
/* moduleIdentifier (server only) */
var CardQuestion___vue_module_identifier__ = null
var CardQuestion_Component = CardQuestion_normalizeComponent(
  CardQuestion,
  components_CardQuestion,
  CardQuestion___vue_template_functional__,
  CardQuestion___vue_styles__,
  CardQuestion___vue_scopeId__,
  CardQuestion___vue_module_identifier__
)

/* harmony default export */ var src_components_CardQuestion = (CardQuestion_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardPublicQuestion.vue







/* harmony default export */ var CardPublicQuestion = ({
  data: function data() {
    return {
      special: {
        privacy: null
      }
    };
  },
  props: ['content'],
  computed: {
    skippable: function skippable() {
      return this.question.optional || this.question.answer.answerValue !== '' || this.question.answer.answerText !== '';
    },
    answerType: function answerType() {
      return 'card-answer-' + this.question.type;
    },
    question: function question() {
      return this.$store.state.decks[0].questions[this.content.id];
    },
    privacyEmail: function privacyEmail() {
      return this.$store.state.hotelData.hotel.email;
    },
    detailLink: function detailLink() {
      var hotelId = this.$store.state.hotelId;
      return 'http://hotel-barometer.com/hotel-' + hotelId + '/detail.html';
    }
  },
  methods: {
    nextCard: function nextCard() {
      eventHub.$emit('card-next');
    }
  },
  created: function created() {
    eventHub.$emit('set-title', this.question.group_title);
  },
  watch: {
    question: function question(newQuestion, oldQuestion) {
      eventHub.$emit('set-title', newQuestion.group_title);
    },
    'special.privacy': function specialPrivacy(newValue, oldValue) {
      this.content.privacy = newValue;
      if (!!newValue && this.content.errors.indexOf('error_privacy') !== -1) {
        this.content.errors.splice(this.content.errors.indexOf('error_privacy'), 1);
      }
    }
  },
  components: {
    CardAnswerOption: src_components_CardAnswerOption, CardAnswerScale: src_components_CardAnswerScale, CardAnswerPercent: src_components_CardAnswerPercent, CardButtonBar: src_components_CardButtonBar, CardAnswerText: src_components_CardAnswerText
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64da343a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardPublicQuestion.vue
var CardPublicQuestion_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-card-question"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.question.question)}}),_vm._v(" "),_c(_vm.answerType,{tag:"component",attrs:{"question":_vm.question}}),_vm._v(" "),_c('div',{staticClass:"cst-public-review-example"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content.privacy),expression:"content.privacy"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.content.privacy)?_vm._i(_vm.content.privacy,null)>-1:(_vm.content.privacy)},on:{"change":function($event){var $$a=_vm.content.privacy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.content, "privacy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.content, "privacy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.content, "privacy", $$c)}}}}),_c('span',{staticClass:"data-privacy-hint",domProps:{"innerHTML":_vm._s(_vm.$t('txtPrivacyHint', { mail: _vm.privacyEmail, link: _vm.detailLink }))}})]),_vm._v(" "),(_vm.content.errors.indexOf('error_privacy') != -1 && !_vm.content.privacy)?_c('div',{staticClass:"cst-error-hint"},[_vm._v("\n        "+_vm._s(_vm.$t('txtPrivacyValidationHint'))+"\n      ")]):_vm._e()]),_vm._v(" "),_c('card-button-bar',{attrs:{"question":_vm.question,"skippable":_vm.skippable}})],1)}
var CardPublicQuestion_staticRenderFns = []
var CardPublicQuestion_esExports = { render: CardPublicQuestion_render, staticRenderFns: CardPublicQuestion_staticRenderFns }
/* harmony default export */ var components_CardPublicQuestion = (CardPublicQuestion_esExports);
// CONCATENATED MODULE: ./src/components/CardPublicQuestion.vue
function CardPublicQuestion_injectStyle (ssrContext) {
  __webpack_require__("lTKt")
}
var CardPublicQuestion_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardPublicQuestion___vue_template_functional__ = false
/* styles */
var CardPublicQuestion___vue_styles__ = CardPublicQuestion_injectStyle
/* scopeId */
var CardPublicQuestion___vue_scopeId__ = "data-v-64da343a"
/* moduleIdentifier (server only) */
var CardPublicQuestion___vue_module_identifier__ = null
var CardPublicQuestion_Component = CardPublicQuestion_normalizeComponent(
  CardPublicQuestion,
  components_CardPublicQuestion,
  CardPublicQuestion___vue_template_functional__,
  CardPublicQuestion___vue_styles__,
  CardPublicQuestion___vue_scopeId__,
  CardPublicQuestion___vue_module_identifier__
)

/* harmony default export */ var src_components_CardPublicQuestion = (CardPublicQuestion_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardThanks.vue

/* harmony default export */ var CardThanks = ({
  props: ['content'],
  methods: {
    finish: function finish() {
      this.$store.dispatch('gotoNamedCard', 'finished');
    },
    next: function next() {
      eventHub.$emit('card-next');
    },
    holidayCheck: function holidayCheck() {
      this.$store.dispatch('gotoNamedCard', 'holiday-check');
    }
  },
  created: function created() {
    eventHub.$emit('set-title', this.$t('thanksTitle'));
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fc3dcf9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardThanks.vue
var CardThanks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-thanks"},[_c('p',[_vm._v(_vm._s(_vm.$t('thanksTextFinish')))]),_vm._v(" "),_c('button',{staticClass:"cst-survey-btn-finish",on:{"click":_vm.finish}},[_vm._v(_vm._s(_vm.$t('thanksBtnFinish')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('thanksTextContinue')))]),_vm._v(" "),_c('button',{staticClass:"cst-survey-btn-next",on:{"click":_vm.next}},[_vm._v(_vm._s(_vm.$t('thanksBtnContinue')))])])}
var CardThanks_staticRenderFns = []
var CardThanks_esExports = { render: CardThanks_render, staticRenderFns: CardThanks_staticRenderFns }
/* harmony default export */ var components_CardThanks = (CardThanks_esExports);
// CONCATENATED MODULE: ./src/components/CardThanks.vue
function CardThanks_injectStyle (ssrContext) {
  __webpack_require__("ORkm")
}
var CardThanks_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardThanks___vue_template_functional__ = false
/* styles */
var CardThanks___vue_styles__ = CardThanks_injectStyle
/* scopeId */
var CardThanks___vue_scopeId__ = "data-v-1fc3dcf9"
/* moduleIdentifier (server only) */
var CardThanks___vue_module_identifier__ = null
var CardThanks_Component = CardThanks_normalizeComponent(
  CardThanks,
  components_CardThanks,
  CardThanks___vue_template_functional__,
  CardThanks___vue_styles__,
  CardThanks___vue_scopeId__,
  CardThanks___vue_module_identifier__
)

/* harmony default export */ var src_components_CardThanks = (CardThanks_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/build.js
var build = __webpack_require__("XILU");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppDatePicker.vue




/* harmony default export */ var AppDatePicker = ({
  props: ['value', 'field', 'validationScope'],
  inject: ['$validator'],
  data: function data() {
    return {
      date: null
    };
  },
  computed: {
    locale: function locale() {
      return this.$store.state.locale;
    }
  },
  components: {
    Datepicker: build_default.a
  },
  watch: {
    date: function date(newVal, oldVal) {
      this.$emit('input', newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d0caee6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDatePicker.vue
var AppDatePicker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-datepicker"},[_c('datepicker',{attrs:{"language":_vm.locale,"calendar-button":false,"calendar-button-icon":"fa fa-calendar","wrapper-class":"cst-survey-customer-field","input-class":"cst-survey-datepicker-input","placeholder":' '+_vm.$t('pickDate'),"monday-first":true},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var AppDatePicker_staticRenderFns = []
var AppDatePicker_esExports = { render: AppDatePicker_render, staticRenderFns: AppDatePicker_staticRenderFns }
/* harmony default export */ var components_AppDatePicker = (AppDatePicker_esExports);
// CONCATENATED MODULE: ./src/components/AppDatePicker.vue
function AppDatePicker_injectStyle (ssrContext) {
  __webpack_require__("aZ9g")
  __webpack_require__("T5Mi")
}
var AppDatePicker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppDatePicker___vue_template_functional__ = false
/* styles */
var AppDatePicker___vue_styles__ = AppDatePicker_injectStyle
/* scopeId */
var AppDatePicker___vue_scopeId__ = "data-v-5d0caee6"
/* moduleIdentifier (server only) */
var AppDatePicker___vue_module_identifier__ = null
var AppDatePicker_Component = AppDatePicker_normalizeComponent(
  AppDatePicker,
  components_AppDatePicker,
  AppDatePicker___vue_template_functional__,
  AppDatePicker___vue_styles__,
  AppDatePicker___vue_scopeId__,
  AppDatePicker___vue_module_identifier__
)

/* harmony default export */ var src_components_AppDatePicker = (AppDatePicker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CustomerField.vue




/* harmony default export */ var CustomerField = ({
  props: ['field', 'validationScope'],
  inject: ['$validator'],
  computed: {
    fieldTitle: function fieldTitle() {
      return this.$t(this.field.title);
    },
    fieldClass: function fieldClass() {
      return 'cst-survey-customer-field cst-survey-customer-field-' + this.field.title;
    },
    validationFieldName: function validationFieldName() {
      return this.validationScope + '.' + this.field.title;
    },
    validationTypes: function validationTypes() {
      var validations = {};
      if (this.field.required) {
        validations.required = true;
      }
      if (this.field.type === 'email') {
        validations.email = true;
      }
      return validations;
    }
  },
  components: {
    AppDatePicker: src_components_AppDatePicker
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-555433d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerField.vue
var CustomerField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field.display)?_c('div',{class:_vm.fieldClass},[_c('label',{attrs:{"for":_vm.field.title}},[_vm._v(_vm._s(_vm.fieldTitle)),(_vm.field.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),(_vm.field.type=='select')?_c('span',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.field.value),expression:"field.value"},{name:"validate",rawName:"v-validate",value:(_vm.validationTypes),expression:"validationTypes"}],attrs:{"name":this.field.title},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.field, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('selectChooseOption'))+" ")]),_vm._v(" "),_vm._l((_vm.field.options),function(option){return _c('option',{key:option,domProps:{"value":_vm.$t(option)}},[_vm._v(_vm._s(_vm.$t(option)))])})],2)]):(_vm.field.type=='date')?_c('span',[_c('app-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.validationTypes),expression:"validationTypes"}],attrs:{"data-vv-scope":_vm.validationScope,"data-vv-name":this.field.title,"validationScope":_vm.validationScope,"field":_vm.field},model:{value:(_vm.field.value),callback:function ($$v) {_vm.$set(_vm.field, "value", $$v)},expression:"field.value"}})],1):_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field.value),expression:"field.value"},{name:"validate",rawName:"v-validate",value:(_vm.validationTypes),expression:"validationTypes"}],attrs:{"data-vv-validate-on":"blur","type":"text","name":this.field.title},domProps:{"value":(_vm.field.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.field, "value", $event.target.value)}}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationFieldName)),expression:"errors.has(validationFieldName)"}],staticClass:"cst-survey-customer-field-error"},[_vm._v(_vm._s(_vm.errors.first(_vm.validationFieldName)))])]):_vm._e()}
var CustomerField_staticRenderFns = []
var CustomerField_esExports = { render: CustomerField_render, staticRenderFns: CustomerField_staticRenderFns }
/* harmony default export */ var components_CustomerField = (CustomerField_esExports);
// CONCATENATED MODULE: ./src/components/CustomerField.vue
function CustomerField_injectStyle (ssrContext) {
  __webpack_require__("2Kt7")
  __webpack_require__("hU5T")
}
var CustomerField_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CustomerField___vue_template_functional__ = false
/* styles */
var CustomerField___vue_styles__ = CustomerField_injectStyle
/* scopeId */
var CustomerField___vue_scopeId__ = "data-v-555433d8"
/* moduleIdentifier (server only) */
var CustomerField___vue_module_identifier__ = null
var CustomerField_Component = CustomerField_normalizeComponent(
  CustomerField,
  components_CustomerField,
  CustomerField___vue_template_functional__,
  CustomerField___vue_styles__,
  CustomerField___vue_scopeId__,
  CustomerField___vue_module_identifier__
)

/* harmony default export */ var src_components_CustomerField = (CustomerField_Component.exports);

// CONCATENATED MODULE: ./src/components/BaseCardMixin.js

/* harmony default export */ var BaseCardMixin = ({
  data: function data() {
    return {
      message: 'hello',
      foo: 'abc'
    };
  },
  created: function created() {
    this.setTitle();
  },
  watch: {
    '$store.state.locale': function $storeStateLocale() {
      this.setTitle();
    }
  },
  methods: {
    setTitle: function setTitle() {
      eventHub.$emit('set-title', this.getTitle());
    },
    getTitle: function getTitle() {
      return 'Title missing';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardCustomerData.vue




/* harmony default export */ var CardCustomerData = ({
  mixins: [BaseCardMixin],
  props: ['content'],
  data: function data() {
    return {
      customer: this.content.customer,
      visit: this.content.visit,
      special: { privacy: null },
      validationScope: 'customer'
    };
  },
  methods: {
    next: function next() {
      var _this = this;

      this.$validator.validateAll(this.validationScope).then(function (hasPassed) {
        if (hasPassed) {
          _this.$store.dispatch('createSurvey', { customer: _this.customer, visit: _this.visit }).then(function () {
            return eventHub.$emit('card-next');
          });
        }
      });
    },
    getTitle: function getTitle() {
      return this.welcomeText;
    }
  },
  watch: {
    welcomeText: function welcomeText(a, b) {
      this.setTitle();
    }
  },
  computed: {
    welcomeText: function welcomeText() {
      return this.$store.state.hotelData.text.welcome;
    },
    privacyLink: function privacyLink() {
      return this.$store.state.hotelData.hotel.urls.privacy;
    },
    privacyEmail: function privacyEmail() {
      return this.$store.state.hotelData.hotel.email;
    }
  },
  components: {
    CustomerField: src_components_CustomerField
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-831854fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardCustomerData.vue
var CardCustomerData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-card-customer-data"},[_c('div',{staticClass:"cst-survey-customer-data-form"},[_c('form',{attrs:{"data-vv-scope":_vm.validationScope}},[_c('fieldset',{staticClass:"cst-survey-customer"},[_c('div',[_c('customer-field',{attrs:{"validationScope":_vm.validationScope,"field":_vm.customer.title}})],1),_vm._v(" "),_c('div',[_c('customer-field',{attrs:{"validationScope":_vm.validationScope,"field":_vm.customer.firstname}}),_vm._v(" "),_c('customer-field',{attrs:{"validationScope":_vm.validationScope,"field":_vm.customer.lastname}})],1),_vm._v(" "),_c('div',[_c('customer-field',{attrs:{"validationScope":_vm.validationScope,"field":_vm.customer.email}})],1)]),_vm._v(" "),_c('fieldset',{staticClass:"cst-survey-visit"},[_c('div',[_c('customer-field',{attrs:{"validationScope":_vm.validationScope,"field":_vm.visit.from}}),_vm._v(" "),_c('customer-field',{attrs:{"validationScope":_vm.validationScope,"field":_vm.visit.to}})],1),_vm._v(" "),_c('div',[_c('customer-field',{attrs:{"validationScope":_vm.validationScope,"field":_vm.visit.room}})],1)])]),_vm._v(" "),_c('div',{class:{'privacy-consent': 1, 'required': _vm.errors.has( this.validationScope +'.privacy') }},[_c('label',{class:{'privacy-hint': 1 }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.special.privacy),expression:"special.privacy"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"checkbox","data-vv-scope":this.validationScope,"name":"privacy","id":"privacy-checkbox","data-vv-rules":"required"},domProps:{"checked":Array.isArray(_vm.special.privacy)?_vm._i(_vm.special.privacy,null)>-1:(_vm.special.privacy)},on:{"change":function($event){var $$a=_vm.special.privacy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.special, "privacy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.special, "privacy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.special, "privacy", $$c)}}}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('txtPrivacyConsent',{'link': _vm.privacyLink, 'mail': _vm.privacyEmail}))}})])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(this.validationScope + '.privacy')),expression:"errors.has(this.validationScope + '.privacy')"}],staticClass:"cst-field-error"},[_vm._v(_vm._s(_vm.$t("requiredField" )))]),_vm._v(" "),_c('button',{staticClass:"btn-start",on:{"click":_vm.next}},[_vm._v(" "+_vm._s(_vm.$t("btnStart"))+" ")]),_vm._v(" "),_c('div',{staticClass:"required-field-hint"},[_vm._v("* "+_vm._s(_vm.$t("requiredField" )))])])])}
var CardCustomerData_staticRenderFns = []
var CardCustomerData_esExports = { render: CardCustomerData_render, staticRenderFns: CardCustomerData_staticRenderFns }
/* harmony default export */ var components_CardCustomerData = (CardCustomerData_esExports);
// CONCATENATED MODULE: ./src/components/CardCustomerData.vue
function CardCustomerData_injectStyle (ssrContext) {
  __webpack_require__("5/u5")
}
var CardCustomerData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardCustomerData___vue_template_functional__ = false
/* styles */
var CardCustomerData___vue_styles__ = CardCustomerData_injectStyle
/* scopeId */
var CardCustomerData___vue_scopeId__ = "data-v-831854fc"
/* moduleIdentifier (server only) */
var CardCustomerData___vue_module_identifier__ = null
var CardCustomerData_Component = CardCustomerData_normalizeComponent(
  CardCustomerData,
  components_CardCustomerData,
  CardCustomerData___vue_template_functional__,
  CardCustomerData___vue_styles__,
  CardCustomerData___vue_scopeId__,
  CardCustomerData___vue_module_identifier__
)

/* harmony default export */ var src_components_CardCustomerData = (CardCustomerData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CheckBox.vue


/* harmony default export */ var CheckBox = ({
  props: ['moduleId', 'selectedModules'],
  computed: {
    selected: function selected() {
      return this.selectedModules.indexOf(parseInt(this.moduleId)) !== -1;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cfe95f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckBox.vue
var CheckBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-check-box"},[_c('svg',{class:{selected: _vm.selected},attrs:{"id":"check-box","data-name":"Checkbox default","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}},[(!_vm.selected)?_c('path',{staticStyle:{"opacity":"0.54"},attrs:{"d":"M20,4V20H4V4H20m0-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z","transform":"translate(-2 -2)"}}):_vm._e(),_vm._v(" "),(_vm.selected)?_c('rect',{attrs:{"width":"20","height":"20","rx":"2","ry":"2"}}):_vm._e(),_vm._v(" "),(_vm.selected)?_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M19,9.94a.845.845,0,0,0,0-1.18L17.8,7.58a.845.845,0,0,0-1.18,0l-5.68,5.7L8.38,10.72a.845.845,0,0,0-1.18,0L6.02,11.9a.845.845,0,0,0,0,1.18l4.32,4.34a.845.845,0,0,0,1.18,0l1.18-1.18,6.28-6.3Z","transform":"translate(-2 -2)"}}):_vm._e()])])}
var CheckBox_staticRenderFns = []
var CheckBox_esExports = { render: CheckBox_render, staticRenderFns: CheckBox_staticRenderFns }
/* harmony default export */ var components_CheckBox = (CheckBox_esExports);
// CONCATENATED MODULE: ./src/components/CheckBox.vue
function CheckBox_injectStyle (ssrContext) {
  __webpack_require__("pYj7")
}
var CheckBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CheckBox___vue_template_functional__ = false
/* styles */
var CheckBox___vue_styles__ = CheckBox_injectStyle
/* scopeId */
var CheckBox___vue_scopeId__ = "data-v-7cfe95f6"
/* moduleIdentifier (server only) */
var CheckBox___vue_module_identifier__ = null
var CheckBox_Component = CheckBox_normalizeComponent(
  CheckBox,
  components_CheckBox,
  CheckBox___vue_template_functional__,
  CheckBox___vue_styles__,
  CheckBox___vue_scopeId__,
  CheckBox___vue_module_identifier__
)

/* harmony default export */ var src_components_CheckBox = (CheckBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardQuestionSelector.vue




/* harmony default export */ var CardQuestionSelector = ({
  props: ['content'],
  methods: {
    next: function next() {
      eventHub.$emit('card-next');
    },
    pushData: function pushData() {
      var _this = this;

      return new promise_default.a(function (resolve, reject) {
        if (_this.content.hasExternalQuestions) {
          _this.$store.dispatch('loadExtendedSurvey', { 'modules': _this.selectedModules }).then(function () {
            return resolve();
          });
        } else {
          resolve();
        }
      });
    },
    handleSelection: function handleSelection(moduleId) {
      var moduleIndex = this.selectedModules.indexOf(parseInt(moduleId));
      if (moduleIndex !== -1) {
        this.selectedModules.splice(moduleIndex, 1);
      } else {
        this.selectedModules.push(parseInt(moduleId));
      }
    }
  },
  computed: {
    selectedModules: {
      get: function get() {
        return this.$store.state.selectedModules;
      },
      set: function set(value) {
        this.$store.commit('setSelectedModules', value.map(function (e) {
          return parseInt(e);
        }));
      }
    },
    modules: function modules() {
      return this.$store.state.decks[0].modules;
    }
  },

  created: function created() {
    eventHub.$emit('set-title', this.$t('selectorTitle'));
    eventHub.$emit('pre-change-register', this.pushData);
  },
  components: {
    CheckBox: src_components_CheckBox
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e0c404","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardQuestionSelector.vue
var CardQuestionSelector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-card-question"},[_c('h2',[_vm._v(_vm._s(_vm.$t('selectorTextThanks'))+" "),_c('br'),_vm._v("\n       "+_vm._s(_vm.$t('selectorTextSelect')))]),_vm._v(" "),_c('ul',_vm._l((_vm.modules),function(module){return _c('li',{key:module.id,staticClass:"cst-survey-module",on:{"click":function($event){return _vm.handleSelection(module.id)}}},[_c('check-box',{attrs:{"moduleId":module.id,"selectedModules":_vm.selectedModules}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedModules),expression:"selectedModules"}],staticClass:"cst-base-input",attrs:{"type":"checkbox","id":module.id},domProps:{"value":module.id,"checked":Array.isArray(_vm.selectedModules)?_vm._i(_vm.selectedModules,module.id)>-1:(_vm.selectedModules)},on:{"change":function($event){var $$a=_vm.selectedModules,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=module.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedModules=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedModules=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedModules=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":module.id}},[_vm._v(" "+_vm._s(module.name))])],1)}),0),_vm._v(" "),_c('button',{on:{"click":_vm.next}},[_vm._v(_vm._s(_vm.$t("btnNext")))])])}
var CardQuestionSelector_staticRenderFns = []
var CardQuestionSelector_esExports = { render: CardQuestionSelector_render, staticRenderFns: CardQuestionSelector_staticRenderFns }
/* harmony default export */ var components_CardQuestionSelector = (CardQuestionSelector_esExports);
// CONCATENATED MODULE: ./src/components/CardQuestionSelector.vue
function CardQuestionSelector_injectStyle (ssrContext) {
  __webpack_require__("qK2F")
}
var CardQuestionSelector_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardQuestionSelector___vue_template_functional__ = false
/* styles */
var CardQuestionSelector___vue_styles__ = CardQuestionSelector_injectStyle
/* scopeId */
var CardQuestionSelector___vue_scopeId__ = "data-v-73e0c404"
/* moduleIdentifier (server only) */
var CardQuestionSelector___vue_module_identifier__ = null
var CardQuestionSelector_Component = CardQuestionSelector_normalizeComponent(
  CardQuestionSelector,
  components_CardQuestionSelector,
  CardQuestionSelector___vue_template_functional__,
  CardQuestionSelector___vue_styles__,
  CardQuestionSelector___vue_scopeId__,
  CardQuestionSelector___vue_module_identifier__
)

/* harmony default export */ var src_components_CardQuestionSelector = (CardQuestionSelector_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardFinished.vue



/* harmony default export */ var CardFinished = ({
  mixins: [BaseCardMixin],
  created: function created() {
    this.$store.dispatch('finishSurvey');
    eventHub.$emit('set-title', this.getTitle());
  },
  methods: {
    getTitle: function getTitle() {
      return this.$t('surveyFinishedTitle');
    }
  },
  computed: {
    thanksText: function thanksText() {
      return this.$store.state.hotelData.text.thanks;
    },
    thanksImage: function thanksImage() {
      return this.$store.state.hotelData.images.thanks;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c3e9de2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardFinished.vue
var CardFinished_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-card-finished"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.thanksText)}}),_vm._v(" "),(_vm.thanksImage)?_c('img',{staticClass:"thanksImage",attrs:{"src":_vm.thanksImage}}):_vm._e()])}
var CardFinished_staticRenderFns = []
var CardFinished_esExports = { render: CardFinished_render, staticRenderFns: CardFinished_staticRenderFns }
/* harmony default export */ var components_CardFinished = (CardFinished_esExports);
// CONCATENATED MODULE: ./src/components/CardFinished.vue
function CardFinished_injectStyle (ssrContext) {
  __webpack_require__("Si4L")
}
var CardFinished_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardFinished___vue_template_functional__ = false
/* styles */
var CardFinished___vue_styles__ = CardFinished_injectStyle
/* scopeId */
var CardFinished___vue_scopeId__ = "data-v-0c3e9de2"
/* moduleIdentifier (server only) */
var CardFinished___vue_module_identifier__ = null
var CardFinished_Component = CardFinished_normalizeComponent(
  CardFinished,
  components_CardFinished,
  CardFinished___vue_template_functional__,
  CardFinished___vue_styles__,
  CardFinished___vue_scopeId__,
  CardFinished___vue_module_identifier__
)

/* harmony default export */ var src_components_CardFinished = (CardFinished_Component.exports);

// CONCATENATED MODULE: ./src/constants.js
/* harmony default export */ var constants = ({
  SURVEY_STATUS_FINISHED: 5,
  FOREIGN_SURVEY_TYPE_HOLIDAYCHECK: 1

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardHolidayCheck.vue



/* harmony default export */ var CardHolidayCheck = ({
  created: function created() {
    var _this = this;

    eventHub.$emit('set-title', this.$t('hcCardTitle'));
    this.$store.dispatch('loadExternalSurvey', constants.FOREIGN_SURVEY_TYPE_HOLIDAYCHECK).then(function () {
      _this.initValues();
    });
  },
  data: function data() {
    return {
      loaded: false,
      restrictions: {
        'title': [{ min: 2 }, { max: 50 }],
        'text': [{ min: 100 }],
        'firstName': [{ min: 1 }]
      },
      iconsEnabled: ['traveledWith', 'travelReason', 'ratingCostPerformance'],
      entryTypes: ['', 'suns', 'title', 'text', 'thumbs', 'options'],
      gaveConsent: false
    };
  },
  methods: {
    updateHoverSelection: function updateHoverSelection(entry, index) {
      vue_esm["a" /* default */].set(entry, 'hovered', index);
    },
    selectAnswerValue: function selectAnswerValue(entry, value) {
      entry.value = value;
    },
    submitHolidayCheck: function submitHolidayCheck() {
      var _this2 = this;

      if (!this.isFullyFilled) {
        alert(this.$t('hcFilledHint'));
        return;
      }

      var questionaire_data = this.$store.state.external_questionaires[1];
      this.$store.dispatch('submitExternalSurvey', { surveyType: constants.FOREIGN_SURVEY_TYPE_HOLIDAYCHECK, answers: questionaire_data.questionaire, mappedValues: questionaire_data.mapped_values, hotel: questionaire_data.meta.hotelId }).then(function (a) {
        _this2.$store.dispatch('gotoNamedCard', 'finished');
      });
    },
    hasRestrictions: function hasRestrictions(entry) {
      return entry.field_name in this.restrictions;
    },
    getRestrictions: function getRestrictions(entry) {
      if (entry.field_name in this.restrictions) {
        return this.restrictions[entry.field_name];
      }
      return [];
    },
    entryClass: function entryClass(entry) {
      return 'cst-survey-card-hc-entry hc-entry-type-' + this.entryTypes[entry.type * 1];
    },
    entryLength: function entryLength(entry) {
      if (entry.type === '2') {
        return entry.value ? entry.value.length : 0;
      }
      return entry.value ? entry.value.replace(/\s/g, '').length : 0;
    },
    restrictionToText: function restrictionToText(restriction) {
      var restriction_text = [];
      if ('min' in restriction) {
        restriction_text.push('min. ' + restriction.min);
      }
      if ('max' in restriction) {
        restriction_text.push('max. ' + restriction.max);
      }
      return restriction_text.join(' / ');
    },
    getRestrictionsText: function getRestrictionsText(entry) {
      var _this3 = this;

      return this.getRestrictions(entry).map(function (restriction) {
        return _this3.restrictionToText(restriction);
      }).join(' / ');
    },
    areRestrictionsFulfilled: function areRestrictionsFulfilled(entry) {
      var _this4 = this;

      var restrictions = this.getRestrictions(entry);
      if (!restrictions.length) {
        return true;
      }
      var res = restrictions.filter(function (restriction) {
        return !_this4.isRestrictionFulfilled(entry, restriction);
      });
      return res.length === 0;
    },
    isRestrictionFulfilled: function isRestrictionFulfilled(entry, restriction) {
      if ('max' in restriction && this.entryLength(entry) > restriction.max || 'min' in restriction && this.entryLength(entry) < restriction.min) {
        return false;
      }
      return true;
    },
    fieldHintText: function fieldHintText(entry) {
      var fieldName = 'hcTitle_' + entry.field_name;
      if (this.$te(fieldName)) {
        return this.$t(fieldName);
      }
      return entry.title;
    },
    fieldDescriptionText: function fieldDescriptionText(entry) {
      var fieldName = 'hcDescription_' + entry.field_name;
      if (this.$te(fieldName)) {
        return this.$t(fieldName);
      }
      return false;
    },
    optionValueText: function optionValueText(entry, option) {
      var option_name = option.alias ? option.alias : option.value;
      return this.$t('hcOption_' + entry.field_name + '_' + option_name);
    },
    optionIcon: function optionIcon(entry, option) {
      if (this.iconsEnabled.indexOf(entry.field_name) !== -1) {
        var file_name = option.alias ? option.alias : option.value;
        return '/static/hc/hc_' + entry.field_name + '_' + file_name + '.svg';
      }
      return false;
    },
    categoryIcon: function categoryIcon(entry) {
      return '/static/hc/hc_category_' + entry.field_name + '.svg';
    },

    shownOptions: function shownOptions(options) {
      return options.filter(function (option) {
        return !option.hidden;
      });
    },
    initValues: function initValues() {
      var mapped_values = this.$store.state.external_questionaires[constants.FOREIGN_SURVEY_TYPE_HOLIDAYCHECK].mapped_values;
      for (var entry_index in this.questionaire) {
        var entry = this.questionaire[entry_index];
        if (mapped_values[entry.field_name]) {
          entry.value = mapped_values[entry.field_name];
        }
      }
    }
  },
  computed: {
    questionaire: function questionaire() {
      try {
        return this.$store.state.external_questionaires[constants.FOREIGN_SURVEY_TYPE_HOLIDAYCHECK].questionaire.filter(function (entry) {
          return entry.type !== '0';
        });
      } catch (err) {
        return [];
      }
    },
    isFullyFilled: function isFullyFilled() {
      var _this5 = this;

      var missing_fields = this.questionaire.filter(function (entry) {
        return entry.value === null;
      });
      var wrongly_filled_fields = this.questionaire.filter(function (entry) {
        return !_this5.areRestrictionsFulfilled(entry);
      });
      return !missing_fields.length && !wrongly_filled_fields.length && this.gaveConsent;
    },
    introText: function introText() {
      return this.$store.state.hotelData.text.hc_intro;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1937492","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardHolidayCheck.vue
var CardHolidayCheck_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-card-hc"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.introText)}}),_vm._v(" "),_c('div',{staticClass:"cst-survey-card-hc-questions"},_vm._l((_vm.questionaire),function(entry){return _c('div',{key:entry.name,class:_vm.entryClass(entry)},[_c('h3',[(entry.type==1)?_c('img',{attrs:{"src":_vm.categoryIcon(entry)}}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.fieldHintText(entry))}})]),_vm._v(" "),(_vm.fieldDescriptionText(entry))?_c('span',{staticClass:"cst-survey-card-hc-field-desc",domProps:{"innerHTML":_vm._s(_vm.fieldDescriptionText(entry))}}):_vm._e(),_vm._v(" "),(entry.type==1)?_c('div',{staticClass:"cst-survey-hc-suns border-color-border",on:{"mouseleave":function($event){return _vm.updateHoverSelection(entry,0)}}},_vm._l((6),function(sunIndex){return _c('div',{key:sunIndex,class:{ sun: 1, selected: sunIndex <= (entry.hovered ? entry.hovered : entry.value ) },on:{"click":function($event){return _vm.selectAnswerValue(entry,sunIndex)},"mouseover":function($event){return _vm.updateHoverSelection(entry,sunIndex)}}})}),0):_vm._e(),_vm._v(" "),(entry.type==2)?_c('div',{staticClass:"cst-survey-hc-title"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(entry.value),expression:"entry.value"}],staticClass:"text-color",attrs:{"type":"text"},domProps:{"value":(entry.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(entry, "value", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(entry.type==3)?_c('div',{staticClass:"cst-survey-hc-text"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(entry.value),expression:"entry.value"}],staticClass:"text-color",domProps:{"value":(entry.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(entry, "value", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(entry.type==4)?_c('div',{staticClass:"cst-survey-hc-thumbs"},[_c('div',{class:{ thumbs: 1, thumbsup: 1, selected: entry.value == 1 },on:{"click":function($event){return _vm.selectAnswerValue(entry,1)}}}),_vm._v(" "),_c('div',{class:{ thumbs: 1, thumbsdown: 1, selected: entry.value == 0 },on:{"click":function($event){return _vm.selectAnswerValue(entry,0)}}})]):_vm._e(),_vm._v(" "),(entry.type==5)?_c('div',{staticClass:"cst-survey-hc-options"},_vm._l((_vm.shownOptions(entry.options)),function(option){return _c('div',{key:option.value,class:{ option: 1, selected: option.value == entry.value, 'border-color-border': 1 },on:{"click":function($event){return _vm.selectAnswerValue(entry,option.value)}}},[(_vm.optionIcon(entry,option))?_c('img',{attrs:{"src":_vm.optionIcon(entry,option)}}):_vm._e(),_vm._v("\n                   "+_vm._s(_vm.optionValueText(entry,option))+"\n                  ")])}),0):_vm._e(),_vm._v(" "),(_vm.hasRestrictions(entry))?_c('div',{class:{'is-not-filled': !_vm.areRestrictionsFulfilled(entry), 'restriction-box': 1 }},[_vm._v("\n                    "+_vm._s(_vm.entryLength(entry))+" / "+_vm._s(_vm.getRestrictionsText(entry))+"\n              ")]):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"cst-survey-card-hc-privacy-consent"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gaveConsent),expression:"gaveConsent"}],staticClass:"consent",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.gaveConsent)?_vm._i(_vm.gaveConsent,null)>-1:(_vm.gaveConsent)},on:{"change":function($event){var $$a=_vm.gaveConsent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.gaveConsent=$$a.concat([$$v]))}else{$$i>-1&&(_vm.gaveConsent=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.gaveConsent=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('hcConsentHint'))}}),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('hcPrivacyHint'))}})])])]),_vm._v(" "),(!_vm.isFullyFilled)?_c('div',{staticClass:"hc-fill-status-hint"},[_vm._v(" "+_vm._s(_vm.$t('hcFilledHint'))+" ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"cst-survey-hc-submit",on:{"click":function($event){return _vm.submitHolidayCheck()}}},[_vm._v(_vm._s(_vm.$t("btnSubmit")))])])}
var CardHolidayCheck_staticRenderFns = []
var CardHolidayCheck_esExports = { render: CardHolidayCheck_render, staticRenderFns: CardHolidayCheck_staticRenderFns }
/* harmony default export */ var components_CardHolidayCheck = (CardHolidayCheck_esExports);
// CONCATENATED MODULE: ./src/components/CardHolidayCheck.vue
function CardHolidayCheck_injectStyle (ssrContext) {
  __webpack_require__("jgLe")
}
var CardHolidayCheck_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardHolidayCheck___vue_template_functional__ = false
/* styles */
var CardHolidayCheck___vue_styles__ = CardHolidayCheck_injectStyle
/* scopeId */
var CardHolidayCheck___vue_scopeId__ = "data-v-f1937492"
/* moduleIdentifier (server only) */
var CardHolidayCheck___vue_module_identifier__ = null
var CardHolidayCheck_Component = CardHolidayCheck_normalizeComponent(
  CardHolidayCheck,
  components_CardHolidayCheck,
  CardHolidayCheck___vue_template_functional__,
  CardHolidayCheck___vue_styles__,
  CardHolidayCheck___vue_scopeId__,
  CardHolidayCheck___vue_module_identifier__
)

/* harmony default export */ var src_components_CardHolidayCheck = (CardHolidayCheck_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardHcSelector.vue

/* harmony default export */ var CardHcSelector = ({
  props: ['content'],
  data: function data() {
    return {};
  },
  methods: {
    holidayCheck: function holidayCheck() {
      this.$store.dispatch('gotoNamedCard', 'holiday-check');
    }
  },
  created: function created() {
    this.$store.dispatch('finishSurvey');
    eventHub.$emit('set-title', this.$t('finalThanksTitle'));
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ff9fbe0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardHcSelector.vue
var CardHcSelector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-hc-selector"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('finalThanksHolidayCheckIntro'))}}),_vm._v(" "),_c('button',{staticClass:"cst-survey-btn-finish",on:{"click":_vm.holidayCheck}},[_vm._v(_vm._s(_vm.$t('finalThanksHolidayCheckBtn')))])])}
var CardHcSelector_staticRenderFns = []
var CardHcSelector_esExports = { render: CardHcSelector_render, staticRenderFns: CardHcSelector_staticRenderFns }
/* harmony default export */ var components_CardHcSelector = (CardHcSelector_esExports);
// CONCATENATED MODULE: ./src/components/CardHcSelector.vue
function CardHcSelector_injectStyle (ssrContext) {
  __webpack_require__("cPK8")
}
var CardHcSelector_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardHcSelector___vue_template_functional__ = false
/* styles */
var CardHcSelector___vue_styles__ = CardHcSelector_injectStyle
/* scopeId */
var CardHcSelector___vue_scopeId__ = "data-v-8ff9fbe0"
/* moduleIdentifier (server only) */
var CardHcSelector___vue_module_identifier__ = null
var CardHcSelector_Component = CardHcSelector_normalizeComponent(
  CardHcSelector,
  components_CardHcSelector,
  CardHcSelector___vue_template_functional__,
  CardHcSelector___vue_styles__,
  CardHcSelector___vue_scopeId__,
  CardHcSelector___vue_module_identifier__
)

/* harmony default export */ var src_components_CardHcSelector = (CardHcSelector_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardSurveyDone.vue

/* harmony default export */ var CardSurveyDone = ({
  created: function created() {
    eventHub.$emit('set-title', this.$t('surveyFinishedTitle'));
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2df50d71","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardSurveyDone.vue
var CardSurveyDone_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-card-finished"},[_c('h2',[_vm._v(" "+_vm._s(_vm.$t('surveyAlreadyDone'))+" ")])])}
var CardSurveyDone_staticRenderFns = []
var CardSurveyDone_esExports = { render: CardSurveyDone_render, staticRenderFns: CardSurveyDone_staticRenderFns }
/* harmony default export */ var components_CardSurveyDone = (CardSurveyDone_esExports);
// CONCATENATED MODULE: ./src/components/CardSurveyDone.vue
function CardSurveyDone_injectStyle (ssrContext) {
  __webpack_require__("ycs9")
}
var CardSurveyDone_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardSurveyDone___vue_template_functional__ = false
/* styles */
var CardSurveyDone___vue_styles__ = CardSurveyDone_injectStyle
/* scopeId */
var CardSurveyDone___vue_scopeId__ = "data-v-2df50d71"
/* moduleIdentifier (server only) */
var CardSurveyDone___vue_module_identifier__ = null
var CardSurveyDone_Component = CardSurveyDone_normalizeComponent(
  CardSurveyDone,
  components_CardSurveyDone,
  CardSurveyDone___vue_template_functional__,
  CardSurveyDone___vue_styles__,
  CardSurveyDone___vue_scopeId__,
  CardSurveyDone___vue_module_identifier__
)

/* harmony default export */ var src_components_CardSurveyDone = (CardSurveyDone_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppContent.vue












/* harmony default export */ var AppContent = ({
  props: ['card'],
  components: {
    CardQuestion: src_components_CardQuestion, CardPublicQuestion: src_components_CardPublicQuestion, CardThanks: src_components_CardThanks, CardCustomerData: src_components_CardCustomerData, CardQuestionSelector: src_components_CardQuestionSelector, CardFinished: src_components_CardFinished, CardHolidayCheck: src_components_CardHolidayCheck, CardHcSelector: src_components_CardHcSelector, CardSurveyDone: src_components_CardSurveyDone
  },
  computed: {
    transition: function transition() {
      return this.$store.state.transition;
    },
    isSurveyFinished: function isSurveyFinished() {
      return this.$store.state.is_survey_finished;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37bac05c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppContent.vue
var AppContent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-content"},[_c('transition',{attrs:{"name":_vm.transition,"mode":"out-in"}},[(_vm.isSurveyFinished && (!_vm.card || _vm.card.type=='card-question' || _vm.card.type=='card-public-question'))?_c('card-survey-done',{attrs:{"card":_vm.card}}):(_vm.card)?_c(_vm.card.type,{key:_vm.card.id,tag:"component",attrs:{"content":_vm.card.content,"events":_vm.card.events}}):_vm._e()],1)],1)}
var AppContent_staticRenderFns = []
var AppContent_esExports = { render: AppContent_render, staticRenderFns: AppContent_staticRenderFns }
/* harmony default export */ var components_AppContent = (AppContent_esExports);
// CONCATENATED MODULE: ./src/components/AppContent.vue
function AppContent_injectStyle (ssrContext) {
  __webpack_require__("EpSK")
}
var AppContent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppContent___vue_template_functional__ = false
/* styles */
var AppContent___vue_styles__ = AppContent_injectStyle
/* scopeId */
var AppContent___vue_scopeId__ = "data-v-37bac05c"
/* moduleIdentifier (server only) */
var AppContent___vue_module_identifier__ = null
var AppContent_Component = AppContent_normalizeComponent(
  AppContent,
  components_AppContent,
  AppContent___vue_template_functional__,
  AppContent___vue_styles__,
  AppContent___vue_scopeId__,
  AppContent___vue_module_identifier__
)

/* harmony default export */ var src_components_AppContent = (AppContent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppInit.vue


/* harmony default export */ var AppInit = ({
  created: function created() {
    if (this.$store.state.cards.length) {
      this.$router.push({ name: 'card', params: { cardId: 0 } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bd540ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppInit.vue
var AppInit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    "+_vm._s(_vm.$t("txtAppStart"))+"\n")])}
var AppInit_staticRenderFns = []
var AppInit_esExports = { render: AppInit_render, staticRenderFns: AppInit_staticRenderFns }
/* harmony default export */ var components_AppInit = (AppInit_esExports);
// CONCATENATED MODULE: ./src/components/AppInit.vue
var AppInit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppInit___vue_template_functional__ = false
/* styles */
var AppInit___vue_styles__ = null
/* scopeId */
var AppInit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AppInit___vue_module_identifier__ = null
var AppInit_Component = AppInit_normalizeComponent(
  AppInit,
  components_AppInit,
  AppInit___vue_template_functional__,
  AppInit___vue_styles__,
  AppInit___vue_scopeId__,
  AppInit___vue_module_identifier__
)

/* harmony default export */ var src_components_AppInit = (AppInit_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/components/CstSurveyBaseDeck.js








function CstSurveyBaseDeck(parent, data) {
  var cards = [];
  var questions = {};
  var questionsRemaining = [];

  var modules = {};

  var allQuestions = [];
  var shownQuestions = {};

  var uuidv4 = function uuidv4() {
    var uuid = '';
    var i;
    var random;
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0;
      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-';
      }
      uuid += (i === 12 ? 4 : i === 16 ? random & 3 | 8 : random).toString(16);
    }
    return uuid;
  };

  var question_answered = function question_answered(answer) {
    var progress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    questions[answer.questionId * 1].answer = answer;
    if (parent.current_card().isValid()) {
      parent.answerQuestion(answer);
    }
    if (progress) {
      window.eventHub.$emit('card-next');
    }
  };

  var findNextQuestion = function findNextQuestion() {
    for (var index in allQuestions) {
      var currentQuestion = allQuestions[index];
      var usable = hasAllDependencies(currentQuestion);
      if (usable && !isQuestiondAlreadyOut(currentQuestion)) {
        return index;
      }
    }
    return -1;
  };

  var isQuestiondAlreadyOut = function isQuestiondAlreadyOut(question) {
    return question.id in shownQuestions;
  };

  var getRemainingCardCount = function getRemainingCardCount() {
    var allRemainingQuestions = allQuestions.filter(function (q) {
      return hasAllDependencies(q);
    });
    var allRemainingDefaultCards = defaultStack.filter(function (c) {
      return !!c.countsTowardsProgress;
    });
    return allRemainingQuestions.length - (keys_default()(shownQuestions).length + allRemainingDefaultCards.length);
  };

  var findFirstUnansweredQuestion = function findFirstUnansweredQuestion() {
    for (var index in allQuestions) {
      var currentQuestion = allQuestions[index];
      var answered = isAnswered(currentQuestion);
      var dependenciesFulfilled = hasAllDependencies(currentQuestion);
      if (!answered && dependenciesFulfilled && !shownQuestions[currentQuestion.id]) {
        return index * 1;
      }
    }
    return -1;
  };

  var getLastAnsweredQuestion = function getLastAnsweredQuestion() {
    var lastAnsweredIndex = 0;
    for (var index in allQuestions) {
      var currentQuestion = allQuestions[index];
      var answered = isAnswered(currentQuestion);
      if (answered) {
        lastAnsweredIndex = index;
      }
    }
    return lastAnsweredIndex * 1;
  };

  var hasTypeDependencies = function hasTypeDependencies(dependencyType, questionaire) {
    for (var index in allQuestions) {
      var question = allQuestions[index];
      for (var dindex in question.dependencies) {
        var dependency = question.dependencies[dindex];
        if (dependency.type === dependencyType && isDependencyFulfillable(dependency, questionaire)) {
          return true;
        }
      }
    }
    return false;
  };

  var isDependencyFulfillable = function isDependencyFulfillable(dependency, questionaire) {
    if (dependency.type === 'module') {
      var isFulfillable = questionaire.modules.filter(function (m) {
        return m.id === dependency.id;
      }).length > 0;
      return isFulfillable;
    }
    return true;
  };

  var hasNextCard = function hasNextCard() {
    return findNextQuestion() !== -1 || defaultStack.length > 0;
  };

  var initDefaultStack = function initDefaultStack(data) {
    var questionaire = data.questionaire;
    var stack = [{
      type: 'card-finished', id: uuidv4(), countsTowardsProgress: false
    }];
    if (data.options.includes('holidaycheck')) {
      stack.unshift({
        type: 'card-hc-selector'
      }, {
        type: 'card-holiday-check'
      });
    }
    if (questionaire.has_additional_questions || hasTypeDependencies('module', questionaire)) {
      stack.unshift({
        type: 'card-thanks', id: uuidv4(), countsTowardsProgress: false
      }, {
        type: 'card-question-selector',
        id: uuidv4(),
        skippable: function skippable() {
          return true;
        },
        content: {
          hasExternalQuestions: questionaire.has_additional_questions
        }
      });
    }
    return stack;
  };

  var defaultStack = [];

  var removeCard = function removeCard(card) {
    if (card.type === 'card-question') {
      delete shownQuestions[card.content.id];
    } else {
      defaultStack.unshift(card);
    }
  };

  var insertHistoryCards = function insertHistoryCards(cardId) {
    var cardIndex = router.currentRoute.params.cardId;
    var cardsInserted = 0;
    var questionsToInsert = [];
    for (var i in questionsRemaining) {
      var currentQuestion = questionsRemaining[i];
      if (hasAllDependencies(currentQuestion)) {
        questionsToInsert.push(currentQuestion);
        cardsInserted++;
      }
      if (cardsInserted >= cardIndex) {
        break;
      }
    }
    for (i in questionsToInsert) {
      var question = questionsToInsert[i];
      addQuestionToGame(question);
    }
  };

  var addCardtoGame = function addCardtoGame(card) {
    components_store.commit('addCard', card);
    cards.push(card);
  };

  var addQuestionToGame = function addQuestionToGame(question) {
    var card = generateCardFromQuestion(question.id);
    addCardtoGame(card);
    shownQuestions[question.id] = 1;
    questionsRemaining = questionsRemaining.filter(function (question) {
      return !shownQuestions[question.id];
    });
  };

  var prepareDeck = function prepareDeck() {
    if (router.currentRoute.params.cardId) {
      insertHistoryCards(router.currentRoute.params.cardId);
      components_store.commit('setCardIndex', router.currentRoute.params.cardId);
    } else {
      insertAnsweredCards();
    }
  };

  var getNextCard = function getNextCard() {
    var nextQuestionIndex = -1;

    if (nextQuestionIndex === -1) {
      nextQuestionIndex = findNextQuestion();
    }
    var card = void 0;
    if (nextQuestionIndex !== -1) {
      var nextQuestion = allQuestions[nextQuestionIndex];
      card = generateCardFromQuestion(nextQuestion.id);
      shownQuestions[nextQuestion.id] = 1;
    } else {
      card = defaultStack.shift();
    }
    this.cards.push(card);

    return card;
  };

  var mergeDeck = function mergeDeck(questionaire) {
    var questionsNew = generateQuestions(questionaire.questions);
    questionsRemaining = questionsRemaining.concat(questionsNew);
    allQuestions = allQuestions.concat(questionsNew);

    modules.splice(0, modules.length);
    for (var m in questionaire.modules) {
      modules.push(questionaire.modules[m]);
    }
  };

  var insertAnsweredCards = function insertAnsweredCards() {
    var filledQuestions = getAnsweredQuestions();
    for (var i in filledQuestions) {
      addQuestionToGame(filledQuestions[i]);
    }
  };

  var getAnsweredQuestions = function getAnsweredQuestions() {
    var firstUnansweredCardIndex = findFirstUnansweredQuestion();
    var lastAnsweredIndex = getLastAnsweredQuestion();
    var indexToStop = firstUnansweredCardIndex;
    if (lastAnsweredIndex > firstUnansweredCardIndex && questionsRemaining.length > lastAnsweredIndex) {
      indexToStop = lastAnsweredIndex * 1 + 1;
    }
    var filledCards = [];
    for (var i = 0; i < indexToStop; i++) {
      var question = questionsRemaining[i];
      if (hasAllDependencies(question)) {
        filledCards.push(question);
      }
    }
    return filledCards;
  };

  var hasAllDependencies = function hasAllDependencies(question) {
    var unfulfilledDependencies = [];
    for (var d in question.dependencies) {
      var dependency = question.dependencies[d];
      var isFulfilled = isDependencyFulfilled(dependency);
      if (!isFulfilled) {
        unfulfilledDependencies.push(dependency);
      }
    }
    return unfulfilledDependencies.length === 0;
  };

  var isAnswered = function isAnswered(question) {
    return question.answer.answerValue !== '' || question.answer.answerScore !== -1 || question.answer.answerText !== '';
  };

  var isDependencyFulfilled = function isDependencyFulfilled(dependency) {
    if (dependency.type === 'module') {
      return components_store.state.selectedModules.indexOf(parseInt(dependency['id'])) !== -1;
    } else if (dependency.type === 'regular') {
      return components_store.state.visit.customer_visit_regular * 1 === dependency['value'] * 1;
    } else if (dependency.type === 'category') {
      return components_store.state.visit.customer_visit_category * 1 === dependency['value'] * 1;
    } else if (dependency.type === 'question' && dependency.id in questions) {
      var a = questions[dependency.id].answer.answerValue * 1;
      var val = dependency['value'] * 1;
      switch (dependency['operator']) {
        case '==':
          return a === val;

        case '!=':
          return a !== val;

        case '>':
          return a > val;

        case '>=':
          return a >= val;

        case '<':
          return a < val;

        case '<=':
          return a <= val;

        default:
          return false;
      }
    }
    return true;
  };

  var generateCardFromQuestion = function generateCardFromQuestion(questionId) {
    var card_id = uuidv4();
    var question = questions[questionId];
    var validate = function validate() {
      return true;
    };
    var isValid = function isValid() {
      return true;
    };
    var cardType = 'card-question';
    if (question.options.indexOf('is_public_question') !== -1) {
      cardType = 'card-public-question';
      isValid = function isValid() {
        if (question.answer.answerText !== '' && !question.privacy) {
          return false;
        }
        return true;
      };
      validate = function validate() {
        if (!isValid()) {
          content['errors'].push('error_privacy');
          return false;
        }
        return true;
      };
    }

    var skippable = function skippable() {
      return question.optional * 1 || question.answer.answerValue !== '' || question.answer.answerText !== '';
    };

    var content = question;
    content.skippable = skippable;
    vue_esm["a" /* default */].set(content, 'errors', []);
    return {
      type: cardType,
      id: card_id,
      content: content,
      skippable: skippable,
      validate: validate,
      isValid: isValid
    };
  };

  var generateQuestions = function generateQuestions(questions_raw) {
    var answers = components_store.state.answers;
    var questions_out = [];
    for (var key in questions_raw) {
      var question = questions_raw[key];
      var found_answer = answers && question.id in answers ? answers[question.id] : false;
      var answer = void 0;
      if (found_answer) {
        answer = { answerText: found_answer.text, answerScore: found_answer.score, answerValue: found_answer.value, answerId: found_answer.value };
      } else {
        answer = { answerText: '', answerScore: -1, answerValue: '', answerId: -1 };
      }
      question.answer = answer;

      if (!(question.id in questions)) {
        questions[question.id] = question;
        questions_out.push(question);
      } else {
        questions[question.id] = question;
      }
    }
    return questions_out;
  };

  var changeLocale = function changeLocale(locale) {
    var actions = [parent.loadSurvey(components_store.state.surveyId, components_store.state.surveyKey, components_store.state.locale)];
    if (components_store.state.loadedExtendedQuestionaire) {
      actions.push(parent.loadExtendedSurvey({ modules: components_store.state.selectedModules }));
    }
    actions.push(parent.updateSurveyLanguage(locale));
    return promise_default.a.all(actions);
  };

  var init = function init() {
    if (data.survey.survey_status * 1 === constants.SURVEY_STATUS_FINISHED) {
      defaultStack = [{
        type: 'card-survey-done'
      }];
      components_store.state.is_survey_finished = true;
    } else {
      modules = data.questionaire.modules;
      var questionsNew = generateQuestions(data.questionaire.questions);
      questionsRemaining = questionsRemaining.concat(questionsNew);
      allQuestions = allQuestions.concat(questionsNew);
      window.eventHub.$on('answer-question', question_answered);
      defaultStack = initDefaultStack(data);
    }
    prepareDeck();
  };
  init();
  return {
    changeLocale: changeLocale,
    type: 'survey',
    current_card_index: 0,
    cards: cards,
    modules: modules,
    questions: questions,

    getNextCard: getNextCard,
    getRemainingCardCount: getRemainingCardCount,
    hasNextCard: hasNextCard,
    removeCard: removeCard,
    mergeDeck: mergeDeck
  };
}
// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./src/components/CstCustomerDataDeck.js





function CstCustomerDataDeck(survey, hotelData) {
  var finished = function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function finished() {
      return _ref.apply(this, arguments);
    };
  }();

  var fieldMap = {
    customer: {
      title: {
        title: 'customerTitle',
        type: 'select',
        options: ['salutationOptionMr', 'salutationOptionMrs', 'salutationOptionFamily'],
        db_name: 'customer_title'
      },
      firstname: {
        title: 'customerFirstname',
        type: 'text',
        db_name: 'customer_firstname'
      },
      lastname: {
        title: 'customerLastname',
        type: 'text',
        db_name: 'customer_surname'
      },
      email: {
        title: 'customerEmail',
        type: 'email',
        db_name: 'customer_email'
      }
    },
    visit: {
      from: {
        title: 'visitFrom',
        type: 'date',
        db_name: 'customer_visit_from'
      },
      to: {
        title: 'visitTo',
        type: 'date',
        db_name: 'customer_visit_to'
      },
      room: {
        title: 'visitRoom',
        db_name: 'customer_visit_room'
      }
    }
  };

  var changeLocale = function changeLocale(locale) {};

  var getRemainingCardCount = function getRemainingCardCount() {
    return 0;
  };

  var parseFieldData = function parseFieldData(field, creation_fields) {
    if (field.db_name in creation_fields) {
      field.display = 1;
      field.required = parseInt(creation_fields[field.db_name].required);
    } else {
      field.display = 0;
    }
    field.value = '';
    return field;
  };

  var generateFields = function generateFields() {
    for (var k in fieldMap.customer) {
      var field = fieldMap.customer[k];
      parseFieldData(field, hotelData.hotel.creation_fields);
    }
    for (var i in fieldMap.visit) {
      var _field = fieldMap.visit[i];
      parseFieldData(_field, hotelData.hotel.creation_fields);
    }
    return fieldMap;
  };

  var init = function init() {};

  init();

  return {
    getRemainingCardCount: getRemainingCardCount,
    changeLocale: changeLocale,
    type: 'customer-visit-data',
    current_card_index: 0,
    cards: [{ type: 'card-customer-data',
      id: 1,
      content: generateFields(),
      needsOverflow: true
    }],
    getNextCard: function getNextCard() {
      if (this.current_card_index + 1 > this.cards.length) {
        return false;
      } else {
        return this.cards[this.current_card_index++];
      }
    },
    hasNextCard: function hasNextCard() {
      return !(this.current_card_index + 1 > this.cards.length);
    },
    finished: finished
  };
}
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/languages/de.js
/* harmony default export */ var de = ({
  'introThanks': 'Vielen Dank, dass Sie uns mit Ihrem Feedback dabei unterstützen besser zu werden!',
  'customerFirstname': 'Vorname',
  'customerLastname': 'Nachname',
  'customerEmail': 'E-Mail',
  'customerTitle': 'Titel',
  'visitFrom': 'Tag der Anreise',
  'visitTo': 'Tag der Abreise',
  'visitRoom': 'Zimmernummer',
  'salutationOptionMr': 'Herr',
  'salutationOptionMrs': 'Frau',
  'salutationOptionFamily': 'Familie',
  'btnStart': 'Start',
  'thanksTitle': 'Vielen Dank!',
  'thanksTextFinish': 'Eilige können den Fragebogen jetzt...',
  'thanksBtnFinish': 'Abschliessen',
  'thanksTextContinue': '... wenn Sie aber noch ein paar Minuten Zeit hätten, würde wir Ihnen noch gerne ein paar weitere detaillierte Fragen stellen',
  'thanksBtnContinue': 'Weitere Fragen',
  'selectChooseOption': 'Bitte wählen Sie...',
  'btnNext': 'Weiter',
  'btnSkip': 'Überspringen',
  'btnFeedback': 'Kommentar',
  'selectorTextThanks': 'Super, vielen Dank für Ihre Unterstützung!',
  'selectorTextSelect': 'Welche der folgenden Angebote haben Sie genutzt?',
  'feedbackTitle': 'Ihr Kommentar zum Thema',
  'feedbackPositiveTitle': 'Was war positiv?',
  'feedbackNegativeTitle': 'Was war negativ?',
  'smileyVeryHappy': 'Sehr zufrieden',
  'smileyHappy': 'Zufrieden',
  'smileyMedium': 'Mittelmaß',
  'smileyUnhappy': 'Unzufrieden',
  'smileyVeryUnhappy': 'Sehr unzufrieden',
  'smileyNotScored': 'Nicht bewertet',
  'validationMessageEmail': 'Bitte geben Sie eine gültige Email-Adresse an',
  'validationMessageRequired': '"Pflichtfeld"',
  'txtAppStart': 'Lade Umfrage...',
  'selectorTitle': 'Nutzung unserer Angebote',
  'finalThanksTitle': 'Herzlichen Dank für Ihre Anregungen',
  'finalThanksHolidayCheckIntro': 'Dürfen wir ein Teil Ihrer Bewertung auch an HolidayCheck weitergeben?<br />Sie würden uns einen großen Gefallen tun! Auf der nächsten Seite zeigen wir Ihnen eine Zusammenfassung Ihrer Daten, die wir, Ihrer Erlaubnis vorrausgesetzt, zu HolidayCheck übertragen würden.<br /><br />Es sind nur wenige Klicks & Ergänzungen – dann haben Sie es geschafft.',
  'finalThanksHolidayCheckBtn': 'HolidayCheck - Zusammenfassung anzeigen',
  'pickDate': '... auswählen',
  'surveyFinishedTitle': 'Umfrage beendet',
  'surveyAlreadyDone': 'Sie haben an dieser Umfrage bereits teilgenommen, vielen Dank!',
  'legendPrimerPositive': 'vollkommen zufrieden',
  'legendPrimerNegative': 'Sehr unzufrieden',
  'hcTitle_recommendation': 'Empfehlen Sie das Hotel weiter?',
  'hcTitle_title': 'Wie lautet der Titel Ihrer Bewertung?',
  'hcTitle_text': 'Beschreiben Sie das Hotel ganz allgemein',
  'hcDescription_text': 'Beschreiben Sie in 2-3 Sätzen Ihren ersten Eindruck vom Hotel. War es z.B. für Ihren Reisegrund geeignet?',
  'hcFilledHint': 'Bitte füllen Sie alle Felder aus',
  'hcTitle_age': 'Wie alt sind sie?',
  'hcTitle_traveledWith': 'Mit wem sind Sie verreist?',
  'hcTitle_travelDuration': 'Aufenthaltslänge',
  'hcOption_traveledWith_friends': 'Freunde',
  'hcOption_traveledWith_family': 'Familie',
  'hcOption_traveledWith_couple': 'Paar',
  'hcOption_traveledWith_single': 'Allein',
  'hcOption_children_no': 'keine',
  'hcOption_children_one': '1',
  'hcOption_children_two': '2',
  'hcOption_children_three': '3',
  'hcOption_children_four': '4',
  'hcOption_children_more': 'mehr als 4',
  'hcOption_age_14-18': '16 - 18',
  'hcOption_age_19-25': '19 - 25',
  'hcOption_age_26-30': '26 - 30',
  'hcOption_age_31-35': '31 - 35',
  'hcOption_age_36-40': '36 - 40',
  'hcOption_age_41-45': '41 - 45',
  'hcOption_age_46-50': '46 - 50',
  'hcOption_age_51-55': '51 - 55',
  'hcOption_age_56-60': '56 - 60',
  'hcOption_age_61-65': '61 - 65',
  'hcOption_age_66-70': '66 - 70',
  'hcOption_age_70 >': '70+',
  'hcOption_ratingCostPerformance_poor': 'Sehr schlecht',
  'hcOption_ratingCostPerformance_bad': 'Eher schlecht',
  'hcOption_ratingCostPerformance_medium': 'Angemessen',
  'hcOption_ratingCostPerformance_good': 'Eher gut',
  'hcOption_ratingCostPerformance_great': 'Sehr gut',
  'hcOption_travelReason_business': 'Arbeit',
  'hcOption_travelReason_city': 'Stadt',
  'hcOption_travelReason_wellness': 'Wellness',
  'hcOption_travelReason_winter': 'Winter',
  'hcOption_travelReason_other': 'Sonstiges',
  'hcOption_travelReason_beach': 'Strand',
  'hcOption_travelDuration_1-3 days': '1 -3 Tage',
  'hcOption_travelDuration_3-5 days': '3 - 5 Tage',
  'hcOption_travelDuration_1 week': '1 Woche',
  'hcOption_travelDuration_2 weeks': '2 Wochen',
  'hcOption_travelDuration_3 weeks': 'Länger als 2 Wochen',
  'hcCardTitle': 'Holidaycheck Bewertungs-Übertragung',
  'btnSubmit': 'Abschicken',
  'requiredField': 'Pflichtfeld',
  'topicTitle': 'Anderes Thema?',
  'topicHint': 'Wählen Sie das Thema aus, zu dem Sie einen Kommentar hinterlassen möchten',
  'txtSuggestFeedback': 'Ihr Kommentar dazu wäre toll :-)',
  'txtFiguresPercent': 'Angaben in Prozent',
  'hcPrivacyHint': 'Die Informationen zum Datenschutz gemäß Art. 13 und 14 DSGVO finden Sie hier <a href="https://www.holidaycheck.de/datenschutz" target="_blank">Link zum Datenschutz von HolidayCheck</a>.',
  'hcConsentHint': ' Ich erkläre mich damit einverstanden, dass meine angegebenen persönlichen Daten sowie die Bewertung zu HolidayCheck übertragen und veröffentlicht wird und akzeptiere die <a  target="_blank" href="https://www.holidaycheck.de/nutzungsbedingungen">Nutzungsbedingungen</a> von HolidayCheck',
  'txtImpress': 'Impressum',
  'linkImpress': 'https://www.vioma.de/de/service/impressum/',
  'txtPrivacy': 'Datenschutzerklärung',
  'txtPrivacyConsent': 'Ich stimme zu, dass meine Angaben aus der Umfrage zur Verbesserung der Qualität erhoben und verarbeitet werden. Die Daten werden 24 Monate nach dem Absenden gelöscht. Sie können Ihre Einwilligung jederzeit per E-Mail an <a href="mailto:%{mail}">%{mail}</a> widerrufen. Detaillierte Informationen zum Umgang mit Nutzerdaten finden Sie in unserer <a href="%{link}" target="_blank">Datenschutzerklärung</a>.',
  'txtPrivacyHint': 'Ich stimme zu, dass mein Fazit auf der Webseite des Unternehmens und auf der Bewertungsseite unter <a href="%{link}" target="_blank">%{link}</a> mit meinem Geschlecht, meinem abgekürztem Namen, meiner Stadt sowie dem Datum der Abgabe des Fazits veröffentlicht wird. Diese Einwilligung kann ich jederzeit unter <a href="mailto:%{mail}">%{mail}</a> widerrufen. Das veröffentlichte Fazit wird dann gelöscht',
  'txtExample': 'Beispiel',
  'txtSkip': 'Überspringen',
  'txtPrivacyValidationHint': 'Ohne Zustimmung können wir den Text nicht verarbeiten',
  'btnDifferentTopic': 'Anderes Thema',
  'btnOK': 'OK'
});
// CONCATENATED MODULE: ./src/languages/en.js
/* harmony default export */ var en = ({
  'introThanks': 'Thank you for helping us improve by providing your feedback!',
  'customerFirstname': 'First name',
  'customerLastname': 'Last name',
  'customerEmail': 'E-mail',
  'customerTitle': 'Title',
  'visitFrom': 'Date of arrival',
  'visitTo': 'Date of departure',
  'visitRoom': 'Room number',
  'salutationOptionMr': 'Mr. ',
  'salutationOptionMrs': 'Ms. ',
  'salutationOptionFamily': 'Family',
  'btnStart': 'Start',
  'thanksTitle': 'Thank you!',
  'thanksTextFinish': 'Those in a hurry can now...',
  'thanksBtnFinish': 'Finish',
  'thanksTextContinue': '... the questionaire but if you still have a few minutes time, we would like to ask you a few more detailed questions.',
  'thanksBtnContinue': 'Further questions',
  'selectChooseOption': 'Please choose an option',
  'btnNext': 'Continue',
  'btnSkip': 'Skip',
  'btnFeedback': 'Comment',
  'selectorTextThanks': 'Great! Thanks for your help!',
  'selectorTextSelect': 'Which of the listed offers did you take advantage of?',
  'feedbackTitle': 'Your comment on this topic',
  'feedbackPositiveTitle': 'What was positive?',
  'feedbackNegativeTitle': 'What was negative?',
  'smileyVeryHappy': 'Very satisfied',
  'smileyHappy': 'Satisfied',
  'smileyMedium': 'OK',
  'smileyUnhappy': 'Unsatisfied',
  'smileyVeryUnhappy': 'Very unsatisfied',
  'smileyNotScored': 'Not rated',
  'validationMessageEmail': 'Please enter a valid e-mail address.',
  'validationMessageRequired': '"Mandatory field"',
  'txtAppStart': 'Load questionaire',
  'selectorTitle': 'Use of our offers',
  'finalThanksTitle': 'Thank you for your suggestions',
  'finalThanksHolidayCheckIntro': 'May we pass on part of your rating to HolidayCheck?<br />You would be doing us a big favor! On the next page we show you a summary of your data which we, with your permission, would transfer to HolidayCheck.<br /><br />It\'s just a few clicks & additions – then you\'re done.',
  'finalThanksHolidayCheckBtn': 'Show the HolidayCheck summary',
  'pickDate': 'Choose a date',
  'surveyFinishedTitle': 'Questionaire is finished',
  'surveyAlreadyDone': 'You have already participated in this survey, thank you!',
  'legendPrimerPositive': 'Completely satisfied',
  'legendPrimerNegative': 'Very unsatisfied',
  'hcTitle_recommendation': 'Would you recommend this hotel',
  'hcTitle_title': 'What is the title of your review?',
  'hcTitle_text': 'Describe the hotel in general.',
  'hcDescription_text': 'Describe your first impression of the hotel in 2-3 sentences. Was it suitable for your reason of travel, for example?',
  'hcFilledHint': 'Please fill out all the fields',
  'hcTitle_age': 'How old are you?',
  'hcTitle_traveledWith': 'With whom are you travelling?',
  'hcTitle_travelDuration': 'Length of stay',
  'hcOption_traveledWith_friends': 'Friends',
  'hcOption_traveledWith_family': 'Family',
  'hcOption_traveledWith_couple': 'Pair',
  'hcOption_traveledWith_single': 'Alone',
  'hcOption_children_no': 'none',
  'hcOption_children_one': '1',
  'hcOption_children_two': '2',
  'hcOption_children_three': '3',
  'hcOption_children_four': '4',
  'hcOption_children_more': 'more than 4',
  'hcOption_age_14-18': '16 - 18',
  'hcOption_age_19-25': '19 - 25',
  'hcOption_age_26-30': '26 - 30',
  'hcOption_age_31-35': '31 - 35',
  'hcOption_age_36-40': '36 - 40',
  'hcOption_age_41-45': '41 - 45',
  'hcOption_age_46-50': '46 - 50',
  'hcOption_age_51-55': '51 - 55',
  'hcOption_age_56-60': '56 - 60',
  'hcOption_age_61-65': '61 - 65',
  'hcOption_age_66-70': '66 - 70',
  'hcOption_age_70 >': '70+',
  'hcOption_ratingCostPerformance_poor': 'Very poor',
  'hcOption_ratingCostPerformance_bad': 'Rather poor',
  'hcOption_ratingCostPerformance_medium': 'Reasonable',
  'hcOption_ratingCostPerformance_good': 'Rather good',
  'hcOption_ratingCostPerformance_great': 'Very good',
  'hcOption_travelReason_business': 'Business',
  'hcOption_travelReason_city': 'City',
  'hcOption_travelReason_wellness': 'Spa',
  'hcOption_travelReason_winter': 'Winter',
  'hcOption_travelReason_other': 'Other',
  'hcOption_travelReason_beach': 'Beach',
  'hcOption_travelDuration_1-3 days': '1-3 days',
  'hcOption_travelDuration_3-5 days': '3-5 days',
  'hcOption_travelDuration_1 week': '1 week',
  'hcOption_travelDuration_2 weeks': '2 weeks',
  'hcOption_travelDuration_3 weeks': 'more than two weeks',
  'hcCardTitle': 'HolidayCheck rating transfer',
  'btnSubmit': 'Abschicken',
  'requiredField': 'Mandatory field',
  'hcPrivacyHint': 'Die Informationen zum Datenschutz gemäß Art. 13 und 14 DSGVO finden Sie hier <a href="https://www.holidaycheck.de/datenschutz" target="_blank">Link zum Datenschutz von HolidayCheck</a>.',
  'hcConsentHint': ' Ich erkläre mich damit einverstanden, dass meine angegebenen persönlichen Daten sowie die Bewertung zu HolidayCheck übertragen und veröffentlicht wird und akzeptiere die <a  target="_blank" href="https://www.holidaycheck.de/nutzungsbedingungen">Nutzungsbedingungen</a> von HolidayCheck',
  'topicTitle': 'Different topic?',
  'topicHint': 'Select the topic you want to comment on',
  'txtSuggestFeedback': 'Your comment would be great :-)',
  'txtFiguresPercent': 'Figures in percent',
  'txtImpress': 'Legal notice',
  'linkImpress': 'https://www.vioma.de/de/service/impressum/',
  'txtPrivacy': 'Privacy',
  'txtPrivacyConsent': 'I agree that my data from the survey will be collected and processed to improve the quality. The data will be deleted 24 months after the request. You may revoke your consent at any time by sending an email to <a href="mailto:%{mail}">%{mail}</a>. Detailed information on the handling of user data can be found in our <a href="%{link}" target="_blank">Privacy policy</a>.',
  'txtPrivacyHint': 'I agree that my summary will be published on the Company\'s website and on the review page at <a href="%{link}" target="_blank">%{link}</a> with my gender, abbreviated name, city and the date the conclusion was submitted. I can revoke this consent at any time at <a href="mailto:%{mail}">%{mail}</a> The published summary will then be deleted.',
  'txtExample': 'Example',
  'txtSkip': 'Skip',
  'txtPrivacyValidationHint': 'We cannot process the text without permission',
  'btnDifferentTopic': 'Different topic',
  'btnOK': 'OK'
});
// CONCATENATED MODULE: ./src/languages/fr.js
/* harmony default export */ var fr = ({
  'introThanks': 'Merci de nous laisser votre avis. Celui-ci nous permettra de nous améliorer !',
  'customerFirstname': 'Prénom',
  'customerLastname': 'Nom de famille',
  'customerEmail': 'E-mail',
  'customerTitle': 'Titre',
  'visitFrom': 'Date d\'arrivée',
  'visitTo': 'Date de départ',
  'visitRoom': 'Numéro de chambre',
  'salutationOptionMr': 'Monsieur',
  'salutationOptionMrs': 'Madame',
  'salutationOptionFamily': 'Famille',
  'btnStart': 'Début',
  'thanksTitle': 'Merci beaucoup !',
  'thanksTextFinish': 'Les personnes pressées peuvent remplir le questionnaire dès maintenant ...',
  'thanksBtnFinish': 'Terminer',
  'thanksTextContinue': '... mais si vous avez encore quelques minutes à nous accorder, nous vous serons reconnaissants de bien vouloir répondre à quelques questions supplémentaires.',
  'thanksBtnContinue': 'Autres questions',
  'selectChooseOption': 'Veuillez choisir une option',
  'btnNext': 'Continuer',
  'btnSkip': 'Sauter',
  'btnFeedback': 'Commentaire',
  'selectorTextThanks': 'Super ! Merci pour votre aide !',
  'selectorTextSelect': 'Quelles sont les offres dont vous avez profité ?',
  'feedbackTitle': 'Votre commentaire à propos de ce sujet',
  'feedbackPositiveTitle': 'Qu\'est-ce qui était positif ?',
  'feedbackNegativeTitle': 'Qu\'est-ce qui était négatif ?',
  'smileyVeryHappy': 'Très satisfait',
  'smileyHappy': 'Satisfait',
  'smileyMedium': 'OK',
  'smileyUnhappy': 'Insatisfait',
  'smileyVeryUnhappy': 'Très insatisfait',
  'smileyNotScored': 'Non évalué',
  'validationMessageEmail': 'Veuillez entrer une adresse e-mail valide.',
  'validationMessageRequired': '"Champs obligatoires"',
  'txtAppStart': 'Charger le questionnaire',
  'selectorTitle': 'Utilisation de nos offres',
  'finalThanksTitle': 'Merci pour vos suggestions',
  'finalThanksHolidayCheckIntro': 'Pouvons-nous transmettre une partir de vos appréciations à HolidayCheck ?<br />Vous nous feriez une grande faveur ! À la page suivante, nous vous montrerons un résumé de vos données, que nous transférons avec votre accord à HolidayCheck.<br /><br />Il nous vous reste plus que quelques clics & quelques choses à compléter – Ensuite, c\'est fini.',
  'finalThanksHolidayCheckBtn': 'Afficher le résumé HolidayCheck',
  'pickDate': 'Choisir une date',
  'surveyFinishedTitle': 'Le questionnaire est terminé',
  'surveyAlreadyDone': 'Vous avez déjà participé à cette enquête, merci !',
  'legendPrimerPositive': 'Entièrement satisfait',
  'legendPrimerNegative': 'Très insatisfait',
  'hcTitle_recommendation': 'Recommanderiez-vous cet hôtel ?',
  'hcTitle_title': 'Comment s\'intitule le titre de votre avis ?',
  'hcTitle_text': 'Décrivez l\'hôtel en général.',
  'hcDescription_text': 'Décrivez votre première impression de l\'hôtel en 2-3 phrases. Était-il adapté à vos attentes par exemple ?',
  'hcFilledHint': 'Veuillez remplir les champs suivants.',
  'hcTitle_age': 'Quel âge avez-vous ?',
  'hcTitle_traveledWith': 'Avec qui voyagez-vous ?',
  'hcTitle_travelDuration': 'Durée du séjour ?',
  'hcOption_traveledWith_friends': 'Amis',
  'hcOption_traveledWith_family': 'Famille',
  'hcOption_traveledWith_couple': 'Couple',
  'hcOption_traveledWith_single': 'Seul',
  'hcOption_children_no': 'Aucun',
  'hcOption_children_one': '1',
  'hcOption_children_two': '2',
  'hcOption_children_three': '3',
  'hcOption_children_four': '4',
  'hcOption_children_more': 'plus que 4',
  'hcOption_age_14-18': '16 - 18',
  'hcOption_age_19-25': '19 - 25',
  'hcOption_age_26-30': '26 - 30',
  'hcOption_age_31-35': '31 - 35',
  'hcOption_age_36-40': '36 - 40',
  'hcOption_age_41-45': '41 - 45',
  'hcOption_age_46-50': '46 - 50',
  'hcOption_age_51-55': '51 - 55',
  'hcOption_age_56-60': '56 - 60',
  'hcOption_age_61-65': '61 - 65',
  'hcOption_age_66-70': '66 - 70',
  'hcOption_age_70 >': '70+',
  'hcOption_ratingCostPerformance_poor': 'Très mauvais',
  'hcOption_ratingCostPerformance_bad': 'Plutôt mauvais',
  'hcOption_ratingCostPerformance_medium': 'Raisonnable',
  'hcOption_ratingCostPerformance_good': 'Plutôt bien',
  'hcOption_ratingCostPerformance_great': 'Très bien',
  'hcOption_travelReason_business': 'Travail',
  'hcOption_travelReason_city': 'Ville',
  'hcOption_travelReason_wellness': 'Spa',
  'hcOption_travelReason_winter': 'Hiver',
  'hcOption_travelReason_other': 'Autres',
  'hcOption_travelReason_beach': 'Plage',
  'hcOption_travelDuration_1-3 days': '1-3 jours',
  'hcOption_travelDuration_3-5 days': '3-5 jours',
  'hcOption_travelDuration_1 week': '1 semaine',
  'hcOption_travelDuration_2 weeks': '2 semaines',
  'hcOption_travelDuration_3 weeks': 'Plus que deux semaines',
  'hcCardTitle': 'Transfert de l\'avis à HolidayCheck',
  'hcPrivacyHint': 'Die Informationen zum Datenschutz gemäß Art. 13 und 14 DSGVO finden Sie hier <a href="https://www.holidaycheck.de/datenschutz" target="_blank">Link zum Datenschutz von HolidayCheck</a>.',
  'hcConsentHint': ' Ich erkläre mich damit einverstanden, dass meine angegebenen persönlichen Daten sowie die Bewertung zu HolidayCheck übertragen und veröffentlicht wird und akzeptiere die <a  target="_blank" href="https://www.holidaycheck.de/nutzungsbedingungen">Nutzungsbedingungen</a> von HolidayCheck',
  'btnSubmit': 'Expédier',
  'requiredField': 'Champs obligatoires',
  'topicTitle': 'Autre thème ?',
  'topicHint': 'Sélectionnez le thème concernant lequel vous souhaitez laisser un commentaire',
  'txtSuggestFeedback': 'Votre commentaire serait super :-)',
  'txtFiguresPercent': 'Données en pourcentage',
  'txtImpress': 'Mentions légales',
  'linkImpress': 'https://www.vioma.de/de/service/impressum/',
  'txtPrivacy': 'Politique de confidentialité',
  'txtPrivacyConsent': 'J\'accepte que mes données dans cette enquête soient collectées et traitées afin d\'améliorer la qualité. Les données seront effacées 24 mois après l\'enquête. Vous pouvez révoquer votre consentement à tout moment à l\'adresse suivante <a href="mailto:%{mail}">%{mail}</a>. Vous trouverez des informations détaillées sur le traitement des données des utilisateurs dans notre <a href="%{link}" target="_blank">Politique de confidentialité</a>.',
  'txtPrivacyHint': 'J\'accepte que mon avis soit publié sur le site internet de la société et sur la page des avis <a href="%{link}" target="_blank">%{link}</a> avec mon sexe, mon nom abrégé, ma ville et la date à laquelle l\'avis a été publié. Je peux révoquer ce consentement à tout moment à l\'adresse suivante <a href="mailto:%{mail}">%{mail}</a>. L\'avis publié est alors supprimé.',
  'txtExample': 'Exemple',
  'txtSkip': 'Suivant',
  'txtPrivacyValidationHint': 'Nous ne pouvons pas traiter le texte sans autorisation',
  'btnDifferentTopic': 'Autre thème',
  'btnOK': 'OK'
});
// CONCATENATED MODULE: ./src/languages/it.js
/* harmony default export */ var it = ({
  'introThanks': 'Grazie per il vostro feedback, è un aiuto a migliorarci!',
  'customerFirstname': 'Nome',
  'customerLastname': 'Cognome',
  'customerEmail': 'e-mail',
  'customerTitle': 'Titolo',
  'visitFrom': 'Data di arrivo',
  'visitTo': 'Data di partenza',
  'visitRoom': 'Numero della camera',
  'salutationOptionMr': 'Signor',
  'salutationOptionMrs': 'Signora',
  'salutationOptionFamily': 'Famiglia',
  'btnStart': 'Inizio',
  'thanksTitle': 'Grazie!',
  'thanksTextFinish': 'Coloro che hanno fretta possono compilare il questionario ora ...',
  'thanksBtnFinish': 'Chiudi',
  'thanksTextContinue': '...ma se avete ancora qualche minuto di tempo, vorremmo farvi alcune domande più dettagliate',
  'thanksBtnContinue': 'Ulteriori domande',
  'selectChooseOption': 'Per cortesia, scegliete un\'opzione',
  'btnNext': 'Continua',
  'btnSkip': 'Salta',
  'btnFeedback': 'Commento',
  'selectorTextThanks': 'Grazie per il vostro aiuto!',
  'selectorTextSelect': 'Di quale offerta avete usufruito?',
  'feedbackTitle': 'Il vostro commento su questo argomento',
  'feedbackPositiveTitle': 'Cosa è stato positivo?',
  'feedbackNegativeTitle': 'Cosa è stato negativo?',
  'smileyVeryHappy': 'Molto soddisfatto',
  'smileyHappy': 'Soddisfatto',
  'smileyMedium': 'Nella media',
  'smileyUnhappy': 'Insoddisfatto',
  'smileyVeryUnhappy': 'Molto insoddisfatto',
  'smileyNotScored': 'Non valutato',
  'validationMessageEmail': 'Per cortesia, inserire un indirizzo e-mail valido',
  'validationMessageRequired': '"Campi obbligatori"',
  'txtAppStart': 'Carica il questionario...',
  'selectorTitle': 'Utilizzo delle nostre offerte',
  'finalThanksTitle': 'Grazie per i vostri suggerimanti',
  'finalThanksHolidayCheckIntro': 'Possiamo trasmettere parte della vostra valutazione a HolidayCheck?<br />Ci sarebbe di grande aiuto! Nella pagina seguente mostriamo un riepilogo dei vostri dati che noi, con il vostro consenso, trasferiremo a HolidayCheck.<br /><br />Si tratta di pochi click & integrazioni - e abbiamo finito...',
  'finalThanksHolidayCheckBtn': 'Mostra il riepilogo di HolidayCheck',
  'pickDate': 'Scegliete una data',
  'surveyFinishedTitle': 'Il questionario è terminato',
  'surveyAlreadyDone': 'Hai già partecipato a questo sondaggio, grazie!',
  'legendPrimerPositive': 'Completamente soddisfatto',
  'legendPrimerNegative': 'Molto insoddisfatto',
  'hcTitle_recommendation': 'Raccomandereste questo hotel?',
  'hcTitle_title': 'Qual è il titolo della vostra valutazione?',
  'hcTitle_text': 'Descrivete l\'hotel in generale',
  'hcDescription_text': 'Descrivete la vostra prima impressione dell\'hotel in 2-3 frasi. Era adatto, ad esempio, per il motivo del vostro viaggio?',
  'hcFilledHint': 'Per cortesia, compilare tutti i campi',
  'hcTitle_age': 'Quanti anni ha?',
  'hcTitle_traveledWith': 'Con chi ha viaggiato?',
  'hcTitle_travelDuration': 'Durata del soggiorno',
  'hcOption_traveledWith_friends': 'Amici',
  'hcOption_traveledWith_family': 'Famiglia',
  'hcOption_traveledWith_couple': 'Coppia',
  'hcOption_traveledWith_single': 'Da solo',
  'hcOption_children_no': 'Nessuno',
  'hcOption_children_one': '1',
  'hcOption_children_two': '2',
  'hcOption_children_three': '3',
  'hcOption_children_four': '4',
  'hcOption_children_more': 'più di 4',
  'hcOption_age_14-18': '16 - 18',
  'hcOption_age_19-25': '19 - 25',
  'hcOption_age_26-30': '26 - 30',
  'hcOption_age_31-35': '31 - 35',
  'hcOption_age_36-40': '36 - 40',
  'hcOption_age_41-45': '41 - 45',
  'hcOption_age_46-50': '46 - 50',
  'hcOption_age_51-55': '51 - 55',
  'hcOption_age_56-60': '56 - 60',
  'hcOption_age_61-65': '61 - 65',
  'hcOption_age_66-70': '66 - 70',
  'hcOption_age_70 >': '70+',
  'hcOption_ratingCostPerformance_poor': 'Molto male',
  'hcOption_ratingCostPerformance_bad': 'Piuttosto male',
  'hcOption_ratingCostPerformance_medium': 'Adeguato',
  'hcOption_ratingCostPerformance_good': 'Bene',
  'hcOption_ratingCostPerformance_great': 'Molto bene',
  'hcOption_travelReason_business': 'Lavoro',
  'hcOption_travelReason_city': 'Cittá',
  'hcOption_travelReason_wellness': 'Benessere',
  'hcOption_travelReason_winter': 'Inverno',
  'hcOption_travelReason_other': 'Altro',
  'hcOption_travelReason_beach': 'Spiaggia',
  'hcOption_travelDuration_1-3 days': '1-3 giorni',
  'hcOption_travelDuration_3-5 days': '3-5 giorni',
  'hcOption_travelDuration_1 week': '1 settimana',
  'hcOption_travelDuration_2 weeks': '2 settimane',
  'hcOption_travelDuration_3 weeks': 'Più di 2 settimane',
  'hcCardTitle': 'Trasferimento della valutazione di Holidaycheck',
  'hcPrivacyHint': 'Die Informationen zum Datenschutz gemäß Art. 13 und 14 DSGVO finden Sie hier <a href="https://www.holidaycheck.de/datenschutz" target="_blank">Link zum Datenschutz von HolidayCheck</a>.',
  'hcConsentHint': ' Ich erkläre mich damit einverstanden, dass meine angegebenen persönlichen Daten sowie die Bewertung zu HolidayCheck übertragen und veröffentlicht wird und akzeptiere die <a  target="_blank" href="https://www.holidaycheck.de/nutzungsbedingungen">Nutzungsbedingungen</a> von HolidayCheck',
  'btnSubmit': 'Inviare',
  'requiredField': 'Campi obbligatori',
  'topicTitle': 'Un altro argomento?',
  'topicHint': 'Selezionare l\'argomento per il quale si desidera lasciare un commento',
  'txtSuggestFeedback': 'Avere un suo commento sarebbe fantastico :-)',
  'txtFiguresPercent': 'Dati in percentuale',
  'txtImpress': 'Nota legale',
  'linkImpress': 'https://www.vioma.de/de/service/impressum/',
  'txtPrivacy': 'Informativa sulla privacy',
  'txtPrivacyConsent': 'Acconsento che i miei dati in questo sondaggio possano essere raccolti ed elaborati al fine di migliorarne la qualità. I dati verranno cancellati 24 mesi dopo il sondaggio. È possibile revocare il consenso in qualsiasi momento al seguente indirizzo e-mail <a href="mailto:%{mail}">%{mail}</a>. Troverete informazioni dettagliate sul trattamento dei dati degli utenti nel nostro <a href="%{link}" target="_blank">Informazioni sulla privacy</a>.',
  'txtPrivacyHint': 'Accetto che il mio parere sia pubblicato sul sito web della società e sulla pagina di recensioni <a href="%{link}" target="_blank">%{link}</a> con il mio sesso, il nome abbreviato, la città e la data di presentazione del commento. Posso revocare questo consenso in qualsiasi momento all\'indirizzo <a href="mailto:%{mail}">%{mail}</a> I commenti pubblicati verranno quindi cancellati.',
  'txtExample': 'Esempio',
  'txtSkip': 'Passa oltre',
  'txtPrivacyValidationHint': 'Non possiamo elaborare il testo senza autorizzazione.',
  'btnDifferentTopic': 'Altro argomento'
});
// CONCATENATED MODULE: ./src/languages/es.js
/* harmony default export */ var es = ({
  'introThanks': '¡Gracias por su colaboración, sus comentarios nos ayudan a mejorar!',
  'customerFirstname': 'Nombre',
  'customerLastname': 'Apellido',
  'customerEmail': 'E-Mail',
  'customerTitle': 'Título',
  'visitFrom': 'Día de llegada',
  'visitTo': 'Día de salida',
  'visitRoom': 'Número de habitación',
  'salutationOptionMr': 'Señor',
  'salutationOptionMrs': 'Señora',
  'salutationOptionFamily': 'Familia',
  'btnStart': 'Empezar',
  'thanksTitle': '¡Muchas gracias!',
  'thanksTextFinish': 'El cuestionario, si tiene prisa, ahora lo puede ...',
  'thanksBtnFinish': 'Finalizar',
  'thanksTextContinue': '... pero si le quedan unos minutos de tiempo, nos gustaría hacerle unas preguntas más detalladas',
  'thanksBtnContinue': 'Más preguntas',
  'selectChooseOption': 'Por favor seleccione una opción',
  'btnNext': 'Continuar',
  'btnSkip': 'Saltar',
  'btnFeedback': 'Comentario',
  'selectorTextThanks': '¡Genial, muchas gracias por su ayuda!',
  'selectorTextSelect': '¿Cuál de las ofertas citadas a continuación usó?',
  'feedbackTitle': 'Sus comentarios en relación con el tema',
  'feedbackPositiveTitle': '¿Qué era positivio?',
  'feedbackNegativeTitle': '¿Qué era negativo?',
  'smileyVeryHappy': 'Muy bien',
  'smileyHappy': 'Bien',
  'smileyMedium': 'Normal',
  'smileyUnhappy': 'Mal',
  'smileyVeryUnhappy': 'Muy mal',
  'smileyNotScored': 'Sin valorar',
  'validationMessageEmail': 'Por favor introduzca una cuenta de correo válida',
  'validationMessageRequired': '"Campo obligatorio"',
  'txtAppStart': 'Cargando cuestionario...',
  'selectorTitle': 'Uso de nuestras ofertas',
  'finalThanksTitle': 'Gracias por sus sugerencias',
  'finalThanksHolidayCheckIntro': '¿Nos permite compartir parte de sus valoraciones con HolidayCheck?<br />¡Nos haría un gran favor! En la siguiente página le mostraremos un resumen de sus datos, que, solamente con su permiso, transferiríamos a HolidayCheck.<br /><br />Sólo son unos pocos clics y revisiones - entonces habrá finalizado.',
  'finalThanksHolidayCheckBtn': 'HolidayCheck – Mostrar resumen',
  'pickDate': 'Seleccionar fecha',
  'surveyFinishedTitle': 'Cuestionario terminado',
  'surveyAlreadyDone': '¡Ya participó en esta encuesta, muchas gracias!',
  'legendPrimerPositive': 'completamente satisfecho',
  'legendPrimerNegative': 'muy insatisfecho',
  'hcTitle_recommendation': 'Empfehlen Sie das Hotel weiter?',
  'hcTitle_title': '¿Cuál es el título de su cuestionario?',
  'hcTitle_text': 'Describa el hotel en general',
  'hcDescription_text': 'Describa en 2 a 3 párrafos su primera impresión del hotel. Por ejemplo, ¿fue adecuado para su motivo del viaje?',
  'hcFilledHint': 'Por favor rellene todos los campos',
  'hcTitle_age': '¿Cuántos años tiene?',
  'hcTitle_traveledWith': '¿Con quién a viajado?',
  'hcTitle_travelDuration': 'Duración de la estancia',
  'hcOption_traveledWith_friends': 'Amigos',
  'hcOption_traveledWith_family': 'Familia',
  'hcOption_traveledWith_couple': 'Pareja',
  'hcOption_traveledWith_single': 'Solo',
  'hcOption_children_no': 'ninguno',
  'hcOption_children_one': '1',
  'hcOption_children_two': '2',
  'hcOption_children_three': '3',
  'hcOption_children_four': '4',
  'hcOption_children_more': 'más de 4',
  'hcOption_age_14-18': '16 - 18',
  'hcOption_age_19-25': '19 - 25',
  'hcOption_age_26-30': '26 - 30',
  'hcOption_age_31-35': '31 - 35',
  'hcOption_age_36-40': '36 - 40',
  'hcOption_age_41-45': '41 - 45',
  'hcOption_age_46-50': '46 - 50',
  'hcOption_age_51-55': '51 - 55',
  'hcOption_age_56-60': '56 - 60',
  'hcOption_age_61-65': '61 - 65',
  'hcOption_age_66-70': '66 - 70',
  'hcOption_age_70 >': '70+',
  'hcOption_ratingCostPerformance_poor': 'Muy mal',
  'hcOption_ratingCostPerformance_bad': 'Más bien mal',
  'hcOption_ratingCostPerformance_medium': 'Razonable',
  'hcOption_ratingCostPerformance_good': 'Bien',
  'hcOption_ratingCostPerformance_great': 'Muy bien',
  'hcOption_travelReason_business': 'Negocio',
  'hcOption_travelReason_city': 'Ciudad',
  'hcOption_travelReason_wellness': 'Bienestar',
  'hcOption_travelReason_winter': 'Invierno',
  'hcOption_travelReason_other': 'Otros',
  'hcOption_travelReason_beach': 'Playa',
  'hcOption_travelDuration_1-3 days': '1-3 días',
  'hcOption_travelDuration_3-5 days': '3-5 días',
  'hcOption_travelDuration_1 week': '1 semana',
  'hcOption_travelDuration_2 weeks': '2 semanas',
  'hcOption_travelDuration_3 weeks': 'Más de 2 semanas',
  'hcCardTitle': 'Transferencia de valoración a Holidaycheck',
  'btnSubmit': 'Remitir',
  'requiredField': 'Campo obligatorio',
  'topicTitle': '¿Tema diferente?',
  'topicHint': 'Seleccione el tema del que desea escribir un comentario',
  'txtSuggestFeedback': 'Su comentario al respecto sería genial :-)',
  'txtFiguresPercent': 'Cifras en porcentajes',
  'txtImpress': 'Aviso legal',
  'linkImpress': 'https://www.vioma.de/de/service/impressum/',
  'txtPrivacy': 'Política de privacidad',
  'txtPrivacyConsent': 'Acepto que lo datos de la encuesta sean guardados y procesados para mejorar la calidad. Los datos serán eliminados pasados los 24 meses desde la encuesta. Puede revocar el permiso en cualquier momento con un correo electrónico a <a href="mailto:%{mail}">%{mail}</a>. Información detallada sobre el procesamiento de datos de usuario se encuentra en nuestra <a href="%{link}" target="_blank">política de privacidad</a>.',
  'txtPrivacyHint': 'Acepto que mi reseña sea publicada en las páginas web del negocio y en la página de reseñas <a href="%{link}" target="_blank">%{link}</a>, junto con mi sexo, mi nombre abreviado, mi localidad y la fecha de publicación de la misma. Este consentimiento puedo revocarlo en cualquier momento en <a href="mailto:%{mail}">%{mail}</a> y se procederá a eliminar dicha reseña.',
  'txtExample': 'Ejemplo',
  'txtSkip': 'Saltar',
  'txtPrivacyValidationHint': 'Sin su consentimiento no podemos tramitar el texto',
  'btnDifferentTopic': 'Tema diferente'
});
// CONCATENATED MODULE: ./src/components/i18n.js








vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);

var messages = {
  de: de,
  en: en,
  fr: fr,
  it: it,
  es: es
};

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: 'en',
  messages: messages });

// CONCATENATED MODULE: ./src/utils.js

function invert(data) {
  return keys_default()(data).reduce(function (obj, key) {
    obj[data[key]] = key;
    return obj;
  }, {});
}

function generateRGBAStr(r, g, b, transparency) {
  return 'rgba(' + r + ',' + g + ',' + b + ',' + transparency + ')';
}

function extractRGBfromStr(strRGB) {
  var values = /rgb\((.*?),(.*?),(.*?)\)+/g.exec(strRGB);
  return values.slice(1).map(function (v) {
    return v.trim();
  });
}

function generateStyleString(cssValues) {
  return keys_default()(cssValues).map(function (key) {
    return [key, cssValues[key]].join(': ');
  }).join(';');
}
// CONCATENATED MODULE: ./src/components/CstSurvey.js











function CstSurvey() {
  var self = this;

  var answers = [];

  var reviews = {};

  var base_url = 'https://hotel-barometer.com/survey-endpoint.php';

  var survey_base_url = 'https://hotel-barometer.com/survey';


  var current_card_position = 0;

  var survey_id = '0';

  var survey_key = 'abc';

  var hotel_id = 0;

  var loaded_extended_questionaire = false;

  var decks = [];
  var cards = [];
  var current_deck_index = 0;

  var external_questionaires = {};

  var is_first_survey_load = true;
  var is_survey_data_loaded = false;
  var is_first_hotel_data_load = true;

  var language_lookup = {
    1: 'de',
    2: 'en',
    3: 'it',
    5: 'fr',
    8: 'es'
  };

  var locale = 'en';

  var usable_languages = ['de', 'en', 'it', 'fr', 'es'];

  var addDeck = function addDeck(deck) {
    decks.push(deck);
    current_deck_index++;
  };

  var getBrowserLanguage = function getBrowserLanguage() {
    var languages = window.navigator.languages || [window.navigator.language || window.navigator.userLanguage];
    for (var l in languages) {
      var language = languages[l].split('-')[0];
      if (usable_languages.indexOf(language) !== -1) {
        return language;
      }
    }
    return false;
  };

  var updateSurveyLanguage = function updateSurveyLanguage(locale) {
    return new promise_default.a(function (resolve, reject) {
      axios_default.a.get(base_url, {
        params: {
          type: 'survey_set_language',
          survey_id: components_store.state.surveyId,
          survey_key: components_store.state.surveyKey,
          language: locale
        }
      }).then(function (response) {
        resolve();
      });
    });
  };

  var setLocale = function setLocale(localeNew) {
    i18n.locale = localeNew;
    locale = localeNew;
    if (components_store) {
      components_store.commit('setLocale', localeNew);
    }
  };

  var changeLocale = function changeLocale(localeNew) {
    return new promise_default.a(function (resolve, reject) {
      setLocale(localeNew);
      var actions = [getHotelData()];
      for (var d in decks) {
        var deck = decks[d];
        actions.push(deck.changeLocale(localeNew));
      }
      promise_default.a.all(actions).then(function () {
        return resolve();
      });
    });
  };

  var init = function init() {
    var browserLocale = getBrowserLanguage();
    if (browserLocale) {
      setLocale(browserLocale);
    }
    hotel_id = getHotelIdFromUrl();
    eventHub.$on('deck-add', addDeck);
    self.answerQuestion = answerQuestion;
    self.loadSurvey = loadSurvey;
    self.loadExtendedSurvey = loadExtendedSurvey;
    self.loadedExtendedQuestionaire = loaded_extended_questionaire;
    self.updateSurveyLanguage = updateSurveyLanguage;
    self.current_card = function () {
      return components_store.state.cards[components_store.state.current_card_position];
    };
  };
  var hotel_data = {
    images: {
      logo: '',
      header: ''
    },
    hotel: {
      languages: [],
      urls: {}
    }
  };

  var submitExternalSurvey = function submitExternalSurvey(surveyData) {
    return new promise_default.a(function (resolve, reject) {
      var data_struct = {
        answers: {},
        hotel: surveyData.hotel
      };
      for (var x in surveyData.answers) {
        var entry = surveyData.answers[x];
        if (entry.value != null) {
          data_struct.answers[entry.field_name] = entry.value;
        }
      }
      for (var key in surveyData.mappedValues) {
        if (!data_struct.answers[key]) {
          data_struct.answers[key] = surveyData.mappedValues[key];
        }
      }
      axios_default.a.request(base_url, {
        method: 'post',
        params: {
          type: 'survey_submit_external',
          survey_id: components_store.state.surveyId,
          survey_key: components_store.state.surveyKey,
          survey_type: surveyData.surveyType
        },
        data: data_struct
      }).then(function (response) {
        resolve(response.data);
      });
    });
  };

  var loadSurvey = function loadSurvey(survey_id, survey_key, language) {
    return new promise_default.a(function (resolve, reject) {
      axios_default.a.get(base_url, {
        params: {
          type: 'survey_get',
          survey_id: survey_id,
          survey_key: survey_key,
          language: language
        }
      }).then(function (response) {
        initSurveyData(response.data);

        if (is_first_survey_load && language_lookup[response.data.survey.survey_language * 1] !== locale) {
          setLocale(language_lookup[response.data.survey.survey_language * 1]);
        }

        if (decks.length) {
          decks[0].mergeDeck(response.data.questionaire);
        } else {
          var survey_deck = new CstSurveyBaseDeck(self, response.data);
          decks.push(survey_deck);
        }
        is_survey_data_loaded = true;
        is_first_survey_load = false;
        resolve();
      });
    });
  };

  var initSurveyData = function initSurveyData(data) {
    components_store.state.answers = data.answers;
    components_store.state.customer = data.customer;
    components_store.state.visit = data.visit;
    components_store.state.visit_modules = data.visit_modules;
    components_store.state.selectedModules = data.visit_modules;
    components_store.state.reviews = data.reviews;
    components_store.state.surveyId = data.survey.survey_id;
    components_store.state.surveyKey = data.survey.survey_key;
    components_store.state.questionaire = data.questionaire;
  };

  var answerQuestion = function answerQuestion(answer) {
    var answer_out = {
      answer: {
        question: answer.questionId,
        value: answer.answerValue,
        id: answer.answerId,
        score: answer.answerScore,
        text: answer.answerText
      }
    };

    return new promise_default.a(function (resolve, reject) {
      axios_default.a.request(base_url, {
        method: 'post',
        params: {
          type: 'survey_answer',
          survey_id: components_store.state.surveyId,
          survey_key: components_store.state.surveyKey
        },
        data: answer_out
      }).then(function (response) {
        resolve();
      });
    });
  };

  var createSurvey = function createSurvey(customer, visit) {
    var customer_out = {
      language: this.languageLookupReverse[this.locale]
    };
    var visit_out = {};

    for (var cKey in customer) {
      customer_out[cKey] = customer[cKey].value || '';
    }

    for (var vKey in visit) {
      visit_out[vKey] = visit[vKey].value || '';
    }

    return new promise_default.a(function (resolve, reject) {
      axios_default.a.request(base_url, {
        method: 'post',
        params: {
          type: 'hotel_survey_create',
          hotel_id: components_store.state.hotelId,
          language: components_store.state.locale
        },
        data: {
          customer: customer_out,
          visit: visit_out
        }
      }).then(function (response) {
        var survey_url = survey_base_url + '/hotel/' + components_store.state.hotelId + '/survey/' + response.data.survey_id + '/' + response.data.survey_key;
        window.location.replace(survey_url);
      });
    });
  };

  var startSurvey = function startSurvey() {
    return axios_default.a.get(base_url, {
      params: {
        type: 'survey_start',
        survey_id: components_store.state.surveyId,
        survey_key: components_store.state.surveyKey
      }
    });
  };

  var finishSurvey = function finishSurvey() {
    if (components_store.state.is_survey_finished) {
      promise_default.a.resolve();
    }
    return new promise_default.a(function (resolve, reject) {
      axios_default.a.get(base_url, {
        params: {
          type: 'survey_finish',
          survey_id: components_store.state.surveyId,
          survey_key: components_store.state.surveyKey
        }
      }).then(function (response) {
        components_store.state.is_survey_finished = true;
        resolve();
      });
    });
  };

  var loadExtendedSurvey = function loadExtendedSurvey(filters) {
    var merge_into_current_deck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return new promise_default.a(function (resolve, reject) {
      axios_default.a.get(base_url, {
        params: {
          type: 'survey_load_extended',
          survey_id: components_store.state.surveyId,
          survey_key: components_store.state.surveyKey,
          language: components_store.state.locale,
          hotel: components_store.state.hotelId,
          filters: filters
        }
      }).then(function (response) {
        if (merge_into_current_deck) {
          decks[0].mergeDeck(response.data);
        } else {
          var survey_deck = new CstSurveyBaseDeck(self, { questionaire: response.data });
          decks.push(survey_deck);
        }
        components_store.state.loadedExtendedQuestionaire = true;
        resolve();
      });
    });
  };

  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  var updateLayout = function updateLayout(layout) {
    updateStyles(layout.theme);
  };

  var updateStyles = function updateStyles(styles) {
    var placeHolderMapping = {
      'main-button-color': '#9F9E9D',
      'arrow-color': '#9D9F9E'
    };

    var rgbLookup = {};

    for (var placeholder in placeHolderMapping) {
      var placeHolderValue = placeHolderMapping[placeholder];
      rgbLookup[placeHolderValue] = styles[placeholder].color;
    }
    for (var sheetIndex in window.document.styleSheets) {
      var sheet = window.document.styleSheets[sheetIndex];
      try {
        for (var x = 0; x < sheet.cssRules.length; x++) {
          var rule = sheet.cssRules[x];
          try {
            for (var y = 0; y < rule.style.length; y++) {
              var attrKey = rule.style[y];
              var styleContent = rule.style[attrKey];
              for (var ph in rgbLookup) {
                var rgb = hexToRgb(ph);
                var rgbStr = 'rgb(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ')';
                var rgbaStr = 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ',';
                if (styleContent.indexOf(rgbStr) === 0) {
                  rule.style[attrKey] = rgbLookup[ph];
                } else if (styleContent.toLowerCase() === ph.toLowerCase()) {
                  rule.style[attrKey] = rgbLookup[ph];
                } else if (styleContent.indexOf(rgbaStr) === 0) {
                  var currentAlpha = styleContent.slice(1, -1).split(',')[3];
                  var rgbNew = hexToRgb(rgbLookup[ph]);
                  var rgbaReplace = 'rgba(' + rgbNew.r + ', ' + rgbNew.g + ', ' + rgbNew.b + ',' + currentAlpha + ')';
                  rule.style[attrKey] = rgbaReplace;
                }
              }
            }
          } catch (e) {}
        }
      } catch (e) {}
    }
  };

  var getHotelData = function getHotelData(hotel_id_in) {
    return new promise_default.a(function (resolve, reject) {
      axios_default.a.get(base_url, {
        params: {
          type: 'hotel_data',
          hotel_id: hotel_id,
          language: locale
        }
      }).then(function (response) {
        usable_languages = response.data.hotel.languages;
        if (is_first_hotel_data_load) {
          window.setTimeout(function () {
            updateLayout(response.data.layout);
          }, 1);
          if (!is_survey_data_loaded) {
            var browserLanguage = getBrowserLanguage();

            if (browserLanguage && locale !== browserLanguage) {
              changeLocale(browserLanguage);
            } else if (!browserLanguage && usable_languages.indexOf(locale) === -1) {
              changeLocale(usable_languages[0]);
            }
          }
        }
        is_first_hotel_data_load = false;
        components_store.commit('setHotelData', response.data);
        resolve();
      });
    });
  };

  var initSurvey = function initSurvey() {
    var surveyUrlData = getSurveyTypefromUrl();
    if (surveyUrlData.type === 'survey-existing') {
      return loadSurvey(surveyUrlData.id, surveyUrlData.key).then(function () {
        components_store.dispatch('getHotelData').then(startSurvey);
      });
    } else if (surveyUrlData.type === 'survey-new') {
      return new promise_default.a(function (resolve, reject) {
        components_store.dispatch('getHotelData').then(function () {
          var customer_deck = new CstCustomerDataDeck(self, components_store.state.hotelData);
          vue_esm["a" /* default */].set(decks, 0, customer_deck);
          resolve();
        });
      });
    }
  };

  var getSurveyTypefromUrl = function getSurveyTypefromUrl() {
    var path_parts = window.location.pathname.split('/').filter(function (x) {
      return x !== '';
    });
    if (path_parts[3] === 'survey') {
      if (path_parts.length === 6) {
        return {
          type: 'survey-existing',
          id: path_parts[4],
          key: path_parts[5]
        };
      } else {
        return {
          type: 'survey-new'
        };
      }
    }
    return false;
  };

  var getHotelIdFromUrl = function getHotelIdFromUrl() {
    var path_parts = window.location.pathname.split('/').filter(function (x) {
      return x !== '';
    });
    if (path_parts[1] === 'hotel') {
      return path_parts[2];
    }
  };

  var insertNamedCard = function insertNamedCard(name) {
    return new promise_default.a(function (resolve, reject) {
      var card = {
        type: 'card-' + name, id: 0
      };
      components_store.dispatch('addCard', card).then(function (card_index) {
        return resolve(card_index);
      });
    });
  };

  var gotoNamedCard = function gotoNamedCard(name) {
    return new promise_default.a(function (resolve, reject) {
      var existing_card_index = findNamedCard(name);
      if (existing_card_index === false) {
        insertNamedCard(name).then(function (card_index) {
          return resolve(card_index);
        });
      } else {
        resolve(existing_card_index);
      }
    });
  };

  var findNamedCard = function findNamedCard(name) {
    for (var c in cards) {
      var card = cards[c];
      if (card.type === 'card-' + name) {
        return c;
      }
    }
    return false;
  };

  var getRemainingCardCount = function getRemainingCardCount() {
    return decks[current_deck_index].getRemainingCardCount();
  };

  var loadExternalSurvey = function loadExternalSurvey(surveyType) {
    return new promise_default.a(function (resolve, reject) {
      axios_default.a.get(base_url, {
        params: {
          type: 'survey_load_external',
          survey_id: components_store.state.surveyId,
          survey_key: components_store.state.surveyKey,
          survey_type: surveyType
        }
      }).then(function (response) {
        vue_esm["a" /* default */].set(components_store.state.external_questionaires, surveyType, response.data);
        resolve(response.data);
      });
    });
  };

  var updateSurveyProgress = function updateSurveyProgress(progress_pct) {
    axios_default.a.get(base_url, {
      params: {
        type: 'survey_set_progress',
        survey_id: components_store.state.surveyId,
        survey_key: components_store.state.surveyKey,
        progress: Math.round(progress_pct)
      } });
  };

  var setReview = function setReview(reviewData) {
    return new promise_default.a(function (resolve, reject) {
      axios_default.a.get(base_url, {
        params: {
          type: 'survey_set_review',
          survey_id: components_store.state.surveyId,
          survey_key: components_store.state.surveyKey,
          review: reviewData
        }
      }).then(function (response) {
        components_store.state.reviews[reviewData.groupId] = [{ id: reviewData.groupId, type: 1, text: reviewData.feedbackPositive }, { id: reviewData.groupId, type: 2, text: reviewData.feedbackNegative }];
        resolve();
      });
    });
  };

  init();

  return {
    submitExternalSurvey: submitExternalSurvey,
    loadExternalSurvey: loadExternalSurvey,
    updateSurveyLanguage: updateSurveyLanguage,
    updateSurveyProgress: updateSurveyProgress,
    loadedExtendedQuestionaire: loaded_extended_questionaire,
    changeLocale: changeLocale,
    locale: locale,
    currentProgressPct: 0,
    maxProgressPct: 0,
    hotelId: hotel_id,
    selectedModules: [],
    customer: {},
    visit: {},
    reviews: reviews,
    external_questionaires: external_questionaires,
    loadingOverlay: false,
    surveyId: survey_id,
    surveyKey: survey_key,
    is_survey_finished: false,

    hotelData: hotel_data,

    decks: decks,
    mode: 'survey-creation',

    current_deck_index: current_deck_index,
    loadSurvey: loadSurvey,
    initSurvey: initSurvey,
    createSurvey: createSurvey,
    finishSurvey: finishSurvey,
    loadExtendedSurvey: loadExtendedSurvey,
    gotoNamedCard: gotoNamedCard,
    getHotelData: getHotelData,
    getRemainingCardCount: getRemainingCardCount,
    setReview: setReview,
    answerQuestion: answerQuestion,
    answer_question: function answer_question(answer) {
      answers.push(answer);
      window.eventHub.$emit('card-next');
    },
    insertNamedCard: insertNamedCard,
    transition: 'slide',
    get_next_card_id: function get_next_card_id() {
      var card_index = this.setNextCard();
      return card_index;
    },
    getNextCard: function getNextCard() {

      var card = this.decks[this.current_deck_index].getNextCard();
      if (!card) {
        this.current_deck_index++;
        return this.getNextCard();
      }
      return card;
    },
    setNextCard: function setNextCard() {
      var card = this.getNextCard();

      components_store.commit('addCard', card);
      return this.cards.length - 1;
    },
    hasNextCard: function hasNextCard() {
      var current_deck_has_card = this.decks[current_deck_index].hasNextCard();
      if (current_deck_has_card) {
        return true;
      } else {
        return this.decks[current_deck_index + 1].hasNextCard();
      }
    },
    removeCard: function removeCard(card) {
      this.decks[this.current_deck_index].removeCard(card);
    },
    current_card_position: current_card_position,
    cards: cards,
    needsOverflow: false,
    languageLookup: language_lookup,
    languageLookupReverse: invert(language_lookup)
  };
}
// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.minimal.esm.js
var vee_validate_minimal_esm = __webpack_require__("Evi3");

// CONCATENATED MODULE: ./src/components/store.js








vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var cst_survey_obj = new CstSurvey();

var store = new vuex_esm["a" /* default */].Store({
  state: cst_survey_obj,
  getters: {
    getCardById: function getCardById(state) {
      return function (card_id) {
        return store.state.decks[0].cards[card_id - 1];
      };
    },
    getNextCard: function getNextCard() {
      var card = store.state.getNextCard();

      if (!card) {
        this.current_deck_index++;
        return this.getNextCard();
      }
      return card;
    }
  },
  computed: {
    count: function count() {
      return store.state.current_card_index;
    }
  },
  mutations: {
    startLoading: function startLoading(state, overlayData) {
      state.loadingOverlay = overlayData;
    },
    endLoading: function endLoading(state) {
      state.loadingOverlay = false;
    },
    setCustomer: function setCustomer(state) {},
    addCard: function addCard(state, card) {
      state.cards.push(card);
      if (card.needsOverflow) {
        state.needsOverflow = true;
      } else {
        state.needsOverflow = false;
      }
    },
    removeCard: function removeCard(state) {
      state.cards.splice(-1, 1);
    },
    setHotelData: function setHotelData(state, hotelData) {
      state.hotelData = hotelData;
    },
    setSelectedModules: function setSelectedModules(state, selectedModules) {
      state.selectedModules = selectedModules;
    },
    setLocale: function setLocale(state, locale) {
      state.locale = locale;
      i18n.locale = locale;
      vee_validate_minimal_esm["a" /* Validator */].localize(locale);
    },
    setTransition: function setTransition(state, transitionName) {
      state.transition = transitionName;
    },
    setCardIndex: function setCardIndex(state, newIndex) {
      state.current_card_position = newIndex * 1;
    },
    setOverflow: function setOverflow(state, overFlow) {
      state.needsOverflow = overFlow;
    }
  },
  actions: {
    postData: function postData(context, url, _postData) {
      context.commit('startLoading', { text: 'Loading...' });
      return new promise_default.a(function (resolve, reject) {
        axios_default.a.post(url, _postData).then(function (response) {
          context.commit('endLoading');
          resolve(response.data);
        }).catch(function (error) {
          context.commit('endLoading');
          reject(error);
        });
      });
    },
    getData: function getData(context, url, overlayData) {
      context.commit('startLoading', { text: 'Loading...' });
      return new promise_default.a(function (resolve, reject) {
        axios_default.a.get(url).then(function (response) {
          context.commit('endLoading');
          resolve(response.data);
        }).catch(function (error) {
          context.commit('endLoading');
          reject(error);
        });
      });
    },
    setLocale: function setLocale(context, locale) {
      context.commit('startLoading', { text: 'Loading...' });
      context.commit('setLocale', locale);

      return context.state.changeLocale(locale).then(function () {
        return context.commit('endLoading');
      });
    },
    getSurvey: function getSurvey(context, surveyData) {
      context.commit('startLoading', { text: 'Loading...' });
      return context.state.loadSurvey(surveyData.surveyId, surveyData.surveyKey, surveyData.language).then(function () {
        return context.commit('endLoading');
      });
    },
    createSurvey: function createSurvey(context, customerVisitData) {
      customerVisitData.visit.from.value = customerVisitData.visit.from.value.toISOString().split('T')[0];
      customerVisitData.visit.to.value = customerVisitData.visit.to.value.toISOString().split('T')[0];

      context.commit('startLoading', { text: 'Loading...' });
      return context.state.createSurvey(customerVisitData.customer, customerVisitData.visit).then(function () {
        return context.commit('endLoading');
      });
    },
    initSurvey: function initSurvey(context) {
      context.commit('startLoading', { text: 'Loading...' });
      return context.state.initSurvey().then(function () {
        return context.commit('endLoading');
      });
    },
    getHotelData: function getHotelData(context) {
      context.commit('startLoading', { text: 'Loading...' });
      return context.state.getHotelData(store.state.hotel_id).then(function () {
        return context.commit('endLoading');
      });
    },
    finishSurvey: function finishSurvey(context) {
      return context.state.finishSurvey();
    },
    loadExtendedSurvey: function loadExtendedSurvey(context, selectedFilters) {
      context.commit('startLoading', { text: 'Loading...' });
      return context.state.loadExtendedSurvey(selectedFilters).then(function () {
        return context.commit('endLoading');
      });
    },
    loadExternalSurvey: function loadExternalSurvey(context, surveyType) {
      context.commit('startLoading', { text: 'Loading...' });
      return context.state.loadExternalSurvey(surveyType).then(function () {
        return context.commit('endLoading');
      });
    },
    submitExternalSurvey: function submitExternalSurvey(context, surveyData) {
      context.commit('startLoading', { text: 'Loading...' });
      return context.state.submitExternalSurvey(surveyData).then(function (data) {
        context.commit('endLoading');return data;
      });
    },
    setReview: function setReview(context, reviewData) {
      return context.state.setReview(reviewData);
    },
    gotoNamedCard: function gotoNamedCard(context, cardName) {
      context.state.gotoNamedCard(cardName).then(function (card_index) {
        router.push({ name: 'card', params: { cardId: card_index } });
      });
    },
    addCard: function addCard(context, card) {
      context.commit('addCard', card);
      return context.state.cards.length - 1;
    },
    removeCard: function removeCard(context) {
      context.state.removeCard(context.state.cards.slice(-1)[0]);
      context.commit('removeCard');
    },
    updateProgress: function updateProgress(context) {
      if (context.state.surveyId * 1 === 0) {
        return;
      }

      var allCardCount = context.state.cards.length - 1 + context.state.getRemainingCardCount();
      var progressPosition = context.state.current_card_position;
      var progressPct = progressPosition / allCardCount * 100;
      progressPct = Math.round(progressPct * 10) / 10;
      if (progressPct > context.state.maxProgressPct) {
        context.state.updateSurveyProgress(progressPct);
      }
      if (progressPct !== context.state.currentProgressPct) {
        context.state.currentProgressPct = progressPct;
      }
      context.state.maxProgressPct = Math.max(context.state.maxProgressPct, progressPct);
    }
  }
});

/* harmony default export */ var components_store = (store);
// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    component: src_components_AppInit
  }, { path: '/card/:cardId',
    name: 'card',
    component: src_components_AppContent,
    props: function props(route) {
      return { card: components_store.state.cards[route.params.cardId] };
    },
    beforeEnter: function beforeEnter(to, from, next) {
      next();
    }
  }]
}));
// EXTERNAL MODULE: ./src/components/ArrowLeft.vue
var ArrowLeft = __webpack_require__("JPJ5");

// EXTERNAL MODULE: ./src/components/ArrowRight.vue
var ArrowRight = __webpack_require__("OVAW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppNavBar.vue




/* harmony default export */ var AppNavBar = ({
  props: ['card_next', 'card_prev', 'has_next_card', 'has_previous_card', 'is_finished'],
  data: function data() {
    return {
      title: 'TITLE IN NAVBAR'
    };
  },
  methods: {
    set_title: function set_title(title) {
      this.title = title;
    }
  },
  created: function created() {
    eventHub.$on('set-title', this.set_title);
  },
  components: {
    ArrowLeft: ArrowLeft["default"], ArrowRight: ArrowRight["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33f1326a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppNavBar.vue
var AppNavBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-title-bar"},[(_vm.has_previous_card && !_vm.is_finished)?_c('div',{staticClass:"cst-survey-nav-container nav-left"},[_c('a',{staticClass:"nav nav-left",on:{"click":_vm.card_prev}},[_c('arrow-left')],1)]):_vm._e(),_vm._v(" "),_c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.has_next_card)?_c('div',{staticClass:"cst-survey-nav-container nav-right"},[_c('a',{staticClass:"nav nav-right",on:{"click":_vm.card_next}},[_c('arrow-right')],1)]):_vm._e()])}
var AppNavBar_staticRenderFns = []
var AppNavBar_esExports = { render: AppNavBar_render, staticRenderFns: AppNavBar_staticRenderFns }
/* harmony default export */ var components_AppNavBar = (AppNavBar_esExports);
// CONCATENATED MODULE: ./src/components/AppNavBar.vue
function AppNavBar_injectStyle (ssrContext) {
  __webpack_require__("YVFG")
  __webpack_require__("C0yJ")
}
var AppNavBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppNavBar___vue_template_functional__ = false
/* styles */
var AppNavBar___vue_styles__ = AppNavBar_injectStyle
/* scopeId */
var AppNavBar___vue_scopeId__ = "data-v-33f1326a"
/* moduleIdentifier (server only) */
var AppNavBar___vue_module_identifier__ = null
var AppNavBar_Component = AppNavBar_normalizeComponent(
  AppNavBar,
  components_AppNavBar,
  AppNavBar___vue_template_functional__,
  AppNavBar___vue_styles__,
  AppNavBar___vue_scopeId__,
  AppNavBar___vue_module_identifier__
)

/* harmony default export */ var src_components_AppNavBar = (AppNavBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppProgressBar.vue


/* harmony default export */ var AppProgressBar = ({
  props: ['currentProgressPct']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d36b17","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppProgressBar.vue
var AppProgressBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-progress-bar"},[_c('div',{staticClass:"cst-survey-progress-bar-bar",style:({ transform: 'translateX(' +  _vm.currentProgressPct + '%)' })})])}
var AppProgressBar_staticRenderFns = []
var AppProgressBar_esExports = { render: AppProgressBar_render, staticRenderFns: AppProgressBar_staticRenderFns }
/* harmony default export */ var components_AppProgressBar = (AppProgressBar_esExports);
// CONCATENATED MODULE: ./src/components/AppProgressBar.vue
function AppProgressBar_injectStyle (ssrContext) {
  __webpack_require__("CiIe")
}
var AppProgressBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppProgressBar___vue_template_functional__ = false
/* styles */
var AppProgressBar___vue_styles__ = AppProgressBar_injectStyle
/* scopeId */
var AppProgressBar___vue_scopeId__ = "data-v-00d36b17"
/* moduleIdentifier (server only) */
var AppProgressBar___vue_module_identifier__ = null
var AppProgressBar_Component = AppProgressBar_normalizeComponent(
  AppProgressBar,
  components_AppProgressBar,
  AppProgressBar___vue_template_functional__,
  AppProgressBar___vue_styles__,
  AppProgressBar___vue_scopeId__,
  AppProgressBar___vue_module_identifier__
)

/* harmony default export */ var src_components_AppProgressBar = (AppProgressBar_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppLngSwitch.vue


/* harmony default export */ var AppLngSwitch = ({
  data: function data() {
    return {};
  },
  computed: {
    currentLocale: function currentLocale() {
      return this.$store.state.locale;
    },
    availableLanguages: function availableLanguages() {
      return this.$store.state.hotelData.hotel.languages;
    }
  },
  methods: {
    setLocale: function setLocale(locale) {
      this.$store.dispatch('setLocale', locale);
    }
  },
  filters: {
    uppercase: function uppercase(value) {
      return value.toUpperCase();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ab0777b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLngSwitch.vue
var AppLngSwitch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-lng-switch"},_vm._l((_vm.availableLanguages),function(entry,i){return _c('div',{key:entry,class:{ selected: entry==_vm.currentLocale }},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setLocale(entry)}}},[_vm._v("\n          "+_vm._s(_vm._f("uppercase")(entry))+"\n        ")]),_vm._v(" "),(i < _vm.availableLanguages.length -1)?_c('span',[_vm._v("|")]):_vm._e()])}),0)}
var AppLngSwitch_staticRenderFns = []
var AppLngSwitch_esExports = { render: AppLngSwitch_render, staticRenderFns: AppLngSwitch_staticRenderFns }
/* harmony default export */ var components_AppLngSwitch = (AppLngSwitch_esExports);
// CONCATENATED MODULE: ./src/components/AppLngSwitch.vue
function AppLngSwitch_injectStyle (ssrContext) {
  __webpack_require__("OJBG")
}
var AppLngSwitch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppLngSwitch___vue_template_functional__ = false
/* styles */
var AppLngSwitch___vue_styles__ = AppLngSwitch_injectStyle
/* scopeId */
var AppLngSwitch___vue_scopeId__ = "data-v-1ab0777b"
/* moduleIdentifier (server only) */
var AppLngSwitch___vue_module_identifier__ = null
var AppLngSwitch_Component = AppLngSwitch_normalizeComponent(
  AppLngSwitch,
  components_AppLngSwitch,
  AppLngSwitch___vue_template_functional__,
  AppLngSwitch___vue_styles__,
  AppLngSwitch___vue_scopeId__,
  AppLngSwitch___vue_module_identifier__
)

/* harmony default export */ var src_components_AppLngSwitch = (AppLngSwitch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppHeader.vue





/* harmony default export */ var AppHeader = ({
  props: ['logo', 'image'],
  computed: {
    logoBoxLayout: function logoBoxLayout() {
      var cssValues = {};
      if (this.$store.state.hotelData.layout) {
        var layout = this.$store.state.hotelData.layout.logo;
        if (!layout['visible']) {
          cssValues['display'] = 'none';
        }
        if (!layout['padded-box']) {
          cssValues['padding'] = 0;
        }
        if (layout.transparency) {
          cssValues['background-color'] = generateRGBAStr.apply(undefined, toConsumableArray_default()(extractRGBfromStr(layout['background-color'])).concat([0.8]));
        } else {
          cssValues['background-color'] = layout['background-color'];
        }
      }
      return cssValues;
    }
  },
  components: {
    AppLngSwitch: src_components_AppLngSwitch
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4e361aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
var AppHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-header",style:({ backgroundImage: ("url('" + _vm.image + "')") })},[_c('div',{staticClass:"cst-survey-logo",style:(_vm.logoBoxLayout)},[_c('img',{attrs:{"src":_vm.logo}})])])}
var AppHeader_staticRenderFns = []
var AppHeader_esExports = { render: AppHeader_render, staticRenderFns: AppHeader_staticRenderFns }
/* harmony default export */ var components_AppHeader = (AppHeader_esExports);
// CONCATENATED MODULE: ./src/components/AppHeader.vue
function AppHeader_injectStyle (ssrContext) {
  __webpack_require__("4mX6")
}
var AppHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppHeader___vue_template_functional__ = false
/* styles */
var AppHeader___vue_styles__ = AppHeader_injectStyle
/* scopeId */
var AppHeader___vue_scopeId__ = "data-v-e4e361aa"
/* moduleIdentifier (server only) */
var AppHeader___vue_module_identifier__ = null
var AppHeader_Component = AppHeader_normalizeComponent(
  AppHeader,
  components_AppHeader,
  AppHeader___vue_template_functional__,
  AppHeader___vue_styles__,
  AppHeader___vue_scopeId__,
  AppHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_AppHeader = (AppHeader_Component.exports);

// EXTERNAL MODULE: ./src/components/TopicBubble.vue
var TopicBubble = __webpack_require__("GCsD");

// EXTERNAL MODULE: ./src/components/BtnCancel.vue
var BtnCancel = __webpack_require__("zooF");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardFeedbackTopic.vue





/* harmony default export */ var CardFeedbackTopic = ({
  props: ['content'],
  data: function data() {
    return {};
  },
  created: function created() {},
  methods: {
    close: function close() {
      eventHub.$emit('close-modal');
    },
    back: function back() {
      var c = this.$store.state.cards[this.$store.state.current_card_position].content;
      eventHub.$emit('show-modal', { type: 'card-feedback-comment', id: 7, content: { title: c.group_title, group_id: c.group_id } });
    },
    setTopic: function setTopic(questionGroup) {
      eventHub.$emit('show-modal', { type: 'card-feedback-comment', id: 8, content: { title: questionGroup.title, group_id: questionGroup.id } });
    },
    hasContent: function hasContent(topic) {
      return !!this.$store.state.reviews[topic.id * 1];
    }
  },
  computed: {
    availableTopics: function availableTopics() {
      var availableTopics = [];
      for (var x in this.$store.state.questionaire.question_groups) {
        var group = this.$store.state.questionaire.question_groups[x];
        if (group.review * 1) {
          availableTopics.push(group);
        }
      }
      return availableTopics;
    }
  },
  components: {
    TopicBubble: TopicBubble["default"], ArrowLeft: ArrowLeft["default"], BtnCancel: BtnCancel["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b862fba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardFeedbackTopic.vue
var CardFeedbackTopic_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-feedback-topic"},[_c('h1',[_vm._v(_vm._s(_vm.$t('topicTitle')))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.$t('topicHint')))]),_vm._v(" "),_c('div',{staticClass:"cst-survey-feedback-topics"},_vm._l((_vm.availableTopics),function(topic){return _c('div',{key:topic.id,staticClass:"feedback-topic",on:{"click":function($event){return _vm.setTopic(topic)}}},[_c('span',{staticClass:"name",domProps:{"innerHTML":_vm._s(topic.name)}}),_vm._v(" "),(_vm.hasContent(topic))?_c('span',{staticClass:"filled-topic"},[_c('topic-bubble')],1):_vm._e()])}),0),_vm._v(" "),_c('a',{staticClass:"btn-back",on:{"click":_vm.back}},[_c('arrow-left')],1),_vm._v(" "),_c('a',{staticClass:"btn-close",on:{"click":_vm.close}},[_c('btn-cancel')],1)])}
var CardFeedbackTopic_staticRenderFns = []
var CardFeedbackTopic_esExports = { render: CardFeedbackTopic_render, staticRenderFns: CardFeedbackTopic_staticRenderFns }
/* harmony default export */ var components_CardFeedbackTopic = (CardFeedbackTopic_esExports);
// CONCATENATED MODULE: ./src/components/CardFeedbackTopic.vue
function CardFeedbackTopic_injectStyle (ssrContext) {
  __webpack_require__("yqBy")
}
var CardFeedbackTopic_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardFeedbackTopic___vue_template_functional__ = false
/* styles */
var CardFeedbackTopic___vue_styles__ = CardFeedbackTopic_injectStyle
/* scopeId */
var CardFeedbackTopic___vue_scopeId__ = "data-v-3b862fba"
/* moduleIdentifier (server only) */
var CardFeedbackTopic___vue_module_identifier__ = null
var CardFeedbackTopic_Component = CardFeedbackTopic_normalizeComponent(
  CardFeedbackTopic,
  components_CardFeedbackTopic,
  CardFeedbackTopic___vue_template_functional__,
  CardFeedbackTopic___vue_styles__,
  CardFeedbackTopic___vue_scopeId__,
  CardFeedbackTopic___vue_module_identifier__
)

/* harmony default export */ var src_components_CardFeedbackTopic = (CardFeedbackTopic_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardFeedbackComment.vue




/* harmony default export */ var CardFeedbackComment = ({
  props: ['content'],
  data: function data() {
    return {
      feedbackPositive: '',
      feedbackNegative: ''
    };
  },
  created: function created() {
    var texts = this.getCurrentFeedbackTexts();
    this.feedbackPositive = texts['positive'];
    this.feedbackNegative = texts['negative'];
  },
  methods: {
    getCurrentFeedbackTexts: function getCurrentFeedbackTexts() {
      var reviews_struct = this.$store.state.reviews;
      var positiveText = '';
      var negativeText = '';
      if (reviews_struct[this.content.group_id]) {
        for (var entry_id in reviews_struct[this.content.group_id]) {
          var entry = reviews_struct[this.content.group_id][entry_id];
          if (entry['type'] === 1) {
            positiveText = entry['text'];
          } else if (entry['type'] === 2) {
            negativeText = entry['text'];
          }
        }
      }
      return {
        'positive': positiveText,
        'negative': negativeText
      };
    },
    addComments: function addComments() {
      var texts = this.getCurrentFeedbackTexts();

      if (this.feedbackPositive !== '' || texts['positive'] !== '' || this.feedbackNegative !== '' || texts['negative'] !== '') {
        this.$store.dispatch('setReview', { groupId: this.content.group_id, feedbackPositive: this.feedbackPositive, feedbackNegative: this.feedbackNegative });
      }
    },
    selectTopic: function selectTopic() {
      eventHub.$emit('show-modal', { type: 'card-feedback-topic', id: 9, content: {} });
    },
    close: function close() {
      eventHub.$emit('close-modal');
    }
  },
  components: {
    CardFeedbackTopic: src_components_CardFeedbackTopic, BtnCancel: BtnCancel["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f475908","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardFeedbackComment.vue
var CardFeedbackComment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-comments"},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.$t('feedbackTitle'))}}),_vm._v(" "),_c('h2',{domProps:{"innerHTML":_vm._s(_vm.content.title)}}),_vm._v(" "),_c('div',{staticClass:"cst-survey-comment cst-survey-comment-positive"},[_c('h3',{staticClass:"feedback"},[_vm._v(_vm._s(_vm.$t("feedbackPositiveTitle")))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.feedbackPositive),expression:"feedbackPositive"}],domProps:{"value":(_vm.feedbackPositive)},on:{"blur":_vm.addComments,"input":function($event){if($event.target.composing){ return; }_vm.feedbackPositive=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cst-survey-comment cst-survey-comment-negative"},[_c('h3',{staticClass:"feedback"},[_vm._v(_vm._s(_vm.$t("feedbackNegativeTitle")))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.feedbackNegative),expression:"feedbackNegative"}],domProps:{"value":(_vm.feedbackNegative)},on:{"blur":_vm.addComments,"input":function($event){if($event.target.composing){ return; }_vm.feedbackNegative=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"button-bottom"},[_c('a',{staticClass:"link",on:{"click":_vm.selectTopic}},[_vm._v(_vm._s(_vm.$t("btnDifferentTopic" )))]),_vm._v(" "),_c('button',{staticClass:"btn-ok",on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t("btnOK" )))])]),_vm._v(" "),_c('a',{staticClass:"btn-close",on:{"click":_vm.close}},[_c('btn-cancel')],1)])}
var CardFeedbackComment_staticRenderFns = []
var CardFeedbackComment_esExports = { render: CardFeedbackComment_render, staticRenderFns: CardFeedbackComment_staticRenderFns }
/* harmony default export */ var components_CardFeedbackComment = (CardFeedbackComment_esExports);
// CONCATENATED MODULE: ./src/components/CardFeedbackComment.vue
function CardFeedbackComment_injectStyle (ssrContext) {
  __webpack_require__("bgOV")
}
var CardFeedbackComment_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CardFeedbackComment___vue_template_functional__ = false
/* styles */
var CardFeedbackComment___vue_styles__ = CardFeedbackComment_injectStyle
/* scopeId */
var CardFeedbackComment___vue_scopeId__ = "data-v-0f475908"
/* moduleIdentifier (server only) */
var CardFeedbackComment___vue_module_identifier__ = null
var CardFeedbackComment_Component = CardFeedbackComment_normalizeComponent(
  CardFeedbackComment,
  components_CardFeedbackComment,
  CardFeedbackComment___vue_template_functional__,
  CardFeedbackComment___vue_styles__,
  CardFeedbackComment___vue_scopeId__,
  CardFeedbackComment___vue_module_identifier__
)

/* harmony default export */ var src_components_CardFeedbackComment = (CardFeedbackComment_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppModal.vue





/* harmony default export */ var AppModal = ({
  data: function data() {
    return {
      card: false
    };
  },

  components: {
    CardFeedbackComment: src_components_CardFeedbackComment, CardFeedbackTopic: src_components_CardFeedbackTopic
  },
  created: function created() {
    eventHub.$on('close-modal', this.hideModal);
    eventHub.$on('show-modal', this.showModal);
  },

  methods: {
    showModal: function showModal(modalData) {
      if (!this.card) {
        this.$refs.dialog.showModal();
      }
      this.card = modalData;
    },
    hideModal: function hideModal() {
      this.$refs.dialog.close();
    },
    closeModal: function closeModal() {
      this.card = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6922a941","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppModal.vue
var AppModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog',{key:"card.id",ref:"dialog",attrs:{"id":"cst-survey-modal"},on:{"close":_vm.closeModal}},[_c(_vm.card.type,{key:"card.id",tag:"component",attrs:{"content":_vm.card.content}})],1)}
var AppModal_staticRenderFns = []
var AppModal_esExports = { render: AppModal_render, staticRenderFns: AppModal_staticRenderFns }
/* harmony default export */ var components_AppModal = (AppModal_esExports);
// CONCATENATED MODULE: ./src/components/AppModal.vue
function AppModal_injectStyle (ssrContext) {
  __webpack_require__("GCfW")
}
var AppModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppModal___vue_template_functional__ = false
/* styles */
var AppModal___vue_styles__ = AppModal_injectStyle
/* scopeId */
var AppModal___vue_scopeId__ = "data-v-6922a941"
/* moduleIdentifier (server only) */
var AppModal___vue_module_identifier__ = null
var AppModal_Component = AppModal_normalizeComponent(
  AppModal,
  components_AppModal,
  AppModal___vue_template_functional__,
  AppModal___vue_styles__,
  AppModal___vue_scopeId__,
  AppModal___vue_module_identifier__
)

/* harmony default export */ var src_components_AppModal = (AppModal_Component.exports);

// EXTERNAL MODULE: ./src/components/AppLoadingOverlay.vue
var AppLoadingOverlay = __webpack_require__("uAot");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppFooter.vue




/* harmony default export */ var AppFooter = ({
  computed: {
    privacyLink: function privacyLink() {
      return this.$store.state.hotelData.hotel.urls.privacy;
    }
  },
  components: {
    AppLngSwitch: src_components_AppLngSwitch
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db7301f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
var AppFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"link-box"},[_c('a',{attrs:{"href":_vm.privacyLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('txtPrivacy')))]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.$t('linkImpress'),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('txtImpress')))])]),_vm._v(" "),_c('app-lng-switch')],1)}
var AppFooter_staticRenderFns = []
var AppFooter_esExports = { render: AppFooter_render, staticRenderFns: AppFooter_staticRenderFns }
/* harmony default export */ var components_AppFooter = (AppFooter_esExports);
// CONCATENATED MODULE: ./src/components/AppFooter.vue
function AppFooter_injectStyle (ssrContext) {
  __webpack_require__("Fctk")
}
var AppFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppFooter___vue_template_functional__ = false
/* styles */
var AppFooter___vue_styles__ = AppFooter_injectStyle
/* scopeId */
var AppFooter___vue_scopeId__ = "data-v-db7301f0"
/* moduleIdentifier (server only) */
var AppFooter___vue_module_identifier__ = null
var AppFooter_Component = AppFooter_normalizeComponent(
  AppFooter,
  components_AppFooter,
  AppFooter___vue_template_functional__,
  AppFooter___vue_styles__,
  AppFooter___vue_scopeId__,
  AppFooter___vue_module_identifier__
)

/* harmony default export */ var src_components_AppFooter = (AppFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Survey.vue

















/* harmony default export */ var Survey = ({
  name: 'survey',
  data: function data() {
    return {
      prechangeCBs: []
    };
  },
  computed: {
    current_card: function current_card() {
      return this.$store.state.cards[this.$store.state.current_card_position];
    },
    has_next_card: function has_next_card() {
      if (this.current_card && (this.current_card.skippable && this.current_card.skippable() || this.current_card.content && this.current_card.content.skippable && this.current_card.content.skippable()) || this.$store.state.current_card_position + 1 < this.$store.state.cards.length) {
        return true;
      }
      return false;
    },
    has_previous_card: function has_previous_card() {
      if (this.$store.state.current_card_position > 0) {
        return true;
      }
      return false;
    },
    is_finished: function is_finished() {
      return this.$store.state.is_survey_finished;
    },
    hotelData: function hotelData() {
      return components_store.state.hotelData;
    },
    loadingOverlay: function loadingOverlay() {
      return components_store.state.loadingOverlay;
    },
    currentProgressPct: function currentProgressPct() {
      if (components_store.state.is_survey_finished) {
        return 100;
      }
      return components_store.state.currentProgressPct;
    },
    layoutComputed: function layoutComputed() {
      if (this.$store.state.hotelData.layout) {
        var cssValues = {};
        var layout = this.$store.state.hotelData.layout;
        if (layout.background.color) {
          cssValues['background-color'] = layout.background.color.color;
        } else if (layout.background.image) {
          cssValues['background-image'] = 'url(' + layout.background.image + ')';
          if (layout.background.position === 'scale') {
            cssValues['background-size'] = 'cover';
          }
          if (layout.background.position === 'tiling') {
            cssValues['background-repeat'] = 'repeat';
          }
          if (layout.background.position === 'center') {
            cssValues['background-position'] = 'top center';
            cssValues['background-repeat'] = 'no-repeat';
          }
        }
        return generateStyleString(cssValues);
      }
      return '';
    },
    needsOverflow: function needsOverflow() {
      return components_store.state.needsOverflow;
    },
    surveyClass: function surveyClass() {
      var obj = {
        'needs-overflow': this.needsOverflow
      };
      obj['cst-hotel-' + this.$store.state.hotelId] = 1;
      return obj;
    }
  },
  methods: {
    validateProgress: function validateProgress() {
      if (this.current_card && this.current_card.validate && !this.current_card.validate()) {
        return false;
      }
      return true;
    },
    setLocale: function setLocale(locale_str) {
      i18n.locale = locale_str;
    },
    swipeLeft: function swipeLeft() {
      if (this.has_next_card) {
        this.card_next();
      }
    },
    swipeRight: function swipeRight() {
      if (this.has_previous_card) {
        this.card_prev();
      }
    },
    card_next: function card_next() {
      this.$store.commit('setTransition', 'slide');
      eventHub.$emit('card-next');
    },
    card_prev: function card_prev() {
      var _this = this;

      this.$store.commit('setTransition', 'reverseslide');
      this.$store.dispatch('removeCard').then(function () {
        _this.$router.push({ name: 'card', params: { cardId: _this.$store.state.current_card_position - 1 } });
      });
    },
    progress: function progress() {
      var _this2 = this;

      var replace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.validateProgress()) {
        return;
      }
      this.executePreChange().then(function (_) {
        _this2.$store.commit('setTransition', 'slide');
        if (_this2.$store.state.current_card_position + 1 < _this2.$store.state.cards.length) {
          _this2.$router.push({ name: 'card', params: { cardId: _this2.$store.state.current_card_position + 1 } });
        } else {
          if (_this2.$store.state.hasNextCard()) {
            var card_index = _this2.$store.state.setNextCard();

            _this2.$router.push({ name: 'card', params: { cardId: card_index } });
          }
        }
      });
      this.$store.dispatch('updateProgress');
    },
    postData: function postData(url, _postData, overlayData, cb) {
      var _this3 = this;

      this.loadingOverlay = overlayData;
      this.$store.dispatch('postData', _postData).then(function (response) {
        cb(response);
        _this3.loadingOverlay = false;
      }, function (error) {
        cb(error);
        _this3.loadingOverlay = false;
      });
    },
    registerPreChange: function registerPreChange(cb) {
      this.prechangeCBs.push(cb);
    },
    executePreChange: function executePreChange() {
      var _this4 = this;

      if (this.prechangeCBs.length) {
        return promise_default.a.all([this.prechangeCBs[0]()]).then(function (_) {
          _this4.prechangeCBs = [];
        });
      } else {
        return promise_default.a.all([]);
      }
    }
  },
  created: function created() {
    var _this5 = this;

    eventHub.$on('card-next', this.progress);
    eventHub.$on('post-data', this.postData);
    eventHub.$on('pre-change-register', this.registerPreChange);

    this.$store.dispatch('initSurvey').then(function () {
      _this5.progress(true);
    });
  },
  components: {
    AppHeader: src_components_AppHeader, AppProgressBar: src_components_AppProgressBar, AppContent: src_components_AppContent, AppNavBar: src_components_AppNavBar, AppModal: src_components_AppModal, AppLoadingOverlay: AppLoadingOverlay["default"], AppInit: src_components_AppInit, ArrowLeft: ArrowLeft["default"], ArrowRight: ArrowRight["default"], AppFooter: src_components_AppFooter
  },
  watch: {
    '$route': function $route(route) {
      if (route.name === 'card') {
        this.$store.commit('setCardIndex', route.params.cardId * 1);
        this.$store.dispatch('updateProgress');
      }
    },
    'layoutComputed': function layoutComputed() {
      document.body.style.cssText = this.layoutComputed;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0563589f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","svg":"xlink:href","use":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Survey.vue
var Survey_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"touch",rawName:"v-touch:swipe.left",value:(_vm.swipeLeft),expression:"swipeLeft",arg:"swipe",modifiers:{"left":true}},{name:"touch",rawName:"v-touch:swipe.right",value:(_vm.swipeRight),expression:"swipeRight",arg:"swipe",modifiers:{"right":true}}],class:_vm.surveyClass,attrs:{"id":"cst-survey"}},[(_vm.loadingOverlay)?_c('app-loading-overlay'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cst-survey-content-container"},[_c('div',{class:_vm.surveyClass,attrs:{"id":"cst-survey-content"}},[_c('app-header',{attrs:{"logo":_vm.hotelData.images.logo,"image":_vm.hotelData.images.header}}),_vm._v(" "),_c('app-modal'),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_c('app-progress-bar',{attrs:{"currentProgressPct":_vm.currentProgressPct}}),_vm._v(" "),_c('app-nav-bar',{attrs:{"card_next":_vm.card_next,"card_prev":_vm.card_prev,"has_next_card":_vm.has_next_card,"has_previous_card":_vm.has_previous_card,"is_finished":_vm.is_finished}}),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('app-footer')],1)])],1)}
var Survey_staticRenderFns = []
var Survey_esExports = { render: Survey_render, staticRenderFns: Survey_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_Survey = (Survey_esExports);
// CONCATENATED MODULE: ./src/Survey.vue
function Survey_injectStyle (ssrContext) {
  __webpack_require__("lpkU")
  __webpack_require__("QxKq")
}
var Survey_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Survey___vue_template_functional__ = false
/* styles */
var Survey___vue_styles__ = Survey_injectStyle
/* scopeId */
var Survey___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Survey___vue_module_identifier__ = null
var Survey_Component = Survey_normalizeComponent(
  Survey,
  selectortype_template_index_0_src_Survey,
  Survey___vue_template_functional__,
  Survey___vue_styles__,
  Survey___vue_scopeId__,
  Survey___vue_module_identifier__
)

/* harmony default export */ var src_Survey = (Survey_Component.exports);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/rules.esm.js
var rules_esm = __webpack_require__("DYsM");

// EXTERNAL MODULE: ./node_modules/vue2-touch-events/index.js
var vue2_touch_events = __webpack_require__("ufW0");
var vue2_touch_events_default = /*#__PURE__*/__webpack_require__.n(vue2_touch_events);

// CONCATENATED MODULE: ./src/languages/test.js


var test_messages = {
  _default: function _default(field) {
    return 'The ' + field + ' value is not valid.';
  },
  email: function email(field) {
    return i18n.tc('validationMessageEmail');
  },
  required: function required(field) {
    return i18n.tc('validationMessageRequired');
  }
};

var test_getAttributeNames = function getAttributeNames() {
  var attributeList = {};
  var attributes = ['customerTitle', 'customerFirstname', 'customerLastname', 'customerEmail', 'visitFrom', 'visitTo', 'visitRoom'];
  for (var index in attributes) {
    var attribute = attributes[index];
    attributeList[attribute] = i18n.tc(attribute);
  }
  return attributeList;
};

var test_attributes = test_getAttributeNames();

var test_locale = {
  messages: test_messages,
  attributes: test_attributes
};

/* harmony default export */ var test = (test_locale);
// CONCATENATED MODULE: ./src/main.js



















vee_validate_minimal_esm["a" /* Validator */].extend('required', rules_esm["b" /* required */]);
vee_validate_minimal_esm["a" /* Validator */].extend('email', rules_esm["a" /* email */]);
vue_esm["a" /* default */].use(vee_validate_minimal_esm["b" /* install */], {
  locale: 'en',
  dictionary: {
    en: test,
    de: test,
    fr: test
  },
  events: 'change'
});


vue_esm["a" /* default */].use(vue2_touch_events_default.a, {
  longTapTimeInterval: 100
});
vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);

vue_esm["a" /* default */].config.productionTip = false;

new vue_esm["a" /* default */]({
  i18n: i18n,
  store: components_store,
  router: router,
  el: '#app',
  template: '<survey/>',
  components: { Survey: src_Survey, AppContent: src_components_AppContent }
});

/***/ }),

/***/ "OJBG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ORkm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OVAW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowRight_vue__ = __webpack_require__("PxuY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowRight_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowRight_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e609058_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_svg_xlink_href_use_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowRight_vue__ = __webpack_require__("HYY/");
function injectStyle (ssrContext) {
  __webpack_require__("vem3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e609058"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowRight_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e609058_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_svg_xlink_href_use_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowRight_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PxuY":
/***/ (function(module, exports) {



/***/ }),

/***/ "PyJZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QxKq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Si4L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SieH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0ic21pbGV5IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MiIgaGVpZ2h0PSI1NyIgdmlld0JveD0iMCAwIDYyIDU3Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgICAvKiBEZWZhdWx0ICovCiAgICAgICAgI2JhY2tncm91bmR7ZmlsbDogI2ZmZjt9CiAgICAgICAgLmZhY2Uge2ZpbGw6ICMwMDA7fQogICAgICAgICNoZWFkLWJvcmRlcntmaWxsOiAjMDAwO30KICAgICAgICAKICAgICAgICAvKiBBY3RpdmUgKi8KICAgICAgICAvKgogICAgICAgICNiYWNrZ3JvdW5ke2ZpbGw6ICMwZGEwZGY7fQogICAgICAgIC5mYWNlIHtmaWxsOiAjMGRhMGRmO30KICAgICAgICAjaGVhZC1ib3JkZXJ7ZmlsbDogI2ZmZjt9CiAgICAgICAgKi8KCiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+aWNvbl9zdXJ2ZXlfc21pbGV5PC90aXRsZT4KICA8cGF0aCBpZD0iYmFja2dyb3VuZCIgZD0iTTU3Ljg4NywwSDQuMTEzQTQuMTE0LDQuMTE0LDAsMCwwLDAsNC4xMTNWNTIuODg3QTQuMTE0LDQuMTE0LDAsMCwwLDQuMTEzLDU3SDU3Ljg4N0E0LjExNCw0LjExNCwwLDAsMCw2Miw1Mi44ODdWNC4xMTNBNC4xMTQsNC4xMTQsMCwwLDAsNTcuODg3LDBaTTMxLDQ4LjVhMjAsMjAsMCwxLDEsMjAtMjBBMjAsMjAsMCwwLDEsMzEsNDguNVoiLz4KICA8Y2lyY2xlIGlkPSJoZWFkIiBzdHlsZT0iZmlsbDogI2ZmZjsiIGN4PSIzMSIgY3k9IjI4LjUiIHI9IjE2LjY2NyIvPgogIDxwYXRoIGlkPSJoZWFkLWJvcmRlciIgZD0iTTMxLDguNWEyMCwyMCwwLDEsMCwyMCwyMEEyMCwyMCwwLDAsMCwzMSw4LjVabTAsMzYuNjY3QTE2LjY2NywxNi42NjcsMCwxLDEsNDcuNjY3LDI4LjUsMTYuNjgyLDE2LjY4MiwwLDAsMSwzMSw0NS4xNjdaIi8+CiAgPGVsbGlwc2UgaWQ9ImxlZnQtZXllIiBjbGFzcz0iZmFjZSIgY3g9IjI0LjUiIGN5PSIyMS44MzMiIHJ4PSIzLjUiIHJ5PSIzLjMzMyIvPgogIDxwYXRoIGlkPSJtb3V0aC1oYXBweSIgY2xhc3M9ImZhY2UiIGQ9Ik0zMSw0MC4xNjdhOS45MjMsOS45MjMsMCwwLDEtOS41MzEtNy4wMDYsMS42NjQsMS42NjQsMCwxLDEsMy4xNzctLjk4OSw2LjY2MSw2LjY2MSwwLDAsMCwxMi43MDgsMCwxLjY3NywxLjY3NywwLDAsMSwyLjEwOS0xLjA5NCwxLjY1NSwxLjY1NSwwLDAsMSwxLjA2OCwyLjA4M0E5LjkyMyw5LjkyMywwLDAsMSwzMSw0MC4xNjdaIi8+CiAgPGNpcmNsZSBpZD0icmlnaHQtZXllIiBjbGFzcz0iZmFjZSIgY3g9IjM3LjY2NyIgY3k9IjIxLjgzMyIgcj0iMy4zMzMiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "T5Mi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VRK6":
/***/ (function(module, exports) {



/***/ }),

/***/ "XTCd":
/***/ (function(module, exports) {



/***/ }),

/***/ "YVFG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aZ9g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bgOV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cPK8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eqAT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gh8i":
/***/ (function(module, exports) {



/***/ }),

/***/ "goWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-survey-loading-overlay"},[_c('img',{attrs:{"alt":"","src":"data:image/svg+xml;base64,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"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gw6/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjkuMiAzMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjkuMiAzMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBzdHlsZT0iZmlsbDojOTA5MDkwOyIgZD0iTTI5LjEsMjAuNmMwLTAuNi0wLjEtMS4zLTAuMS0xLjljMC0wLjQsMC4yLTEuNywwLTEuOWMtMC40LTAuNC0xLjUsMC0xLjYsMC40Yy0wLjIsMC41LTAuMSwxLjMtMC4xLDEuOGMtMC4xLDIuOC0wLjMsNS41LTAuNyw4LjNjLTAuOC0xLjctMS4yLTMuNS0yLTUuMmMtMC44LTEuOC0xLjYtMy40LTIuNy01Yy0yLTMuMi00LjUtNi03LjItOC42QzExLDUsNi42LDIuMywxLjgsMC41QzEuNCwwLjMsMC44LDAsMC41LDAuMWMtMC42LDAuMi0wLjYsMS4yLTAuMiwxLjVjMC42LDAuNSwxLjYsMC43LDIuMywxQzMuOCwzLjEsNC45LDMuNyw2LDQuM2MxLjcsMSwzLjUsMi4xLDUsMy40YzMsMi41LDUuNyw1LjMsOC4xLDguNGMzLjIsNC4yLDUuMSw4LjksNi42LDEzLjljLTEuOS0wLjEtMy43LTAuOC01LjQtMS40Yy0wLjktMC4zLTEuNi0wLjctMi41LTFjLTAuNC0wLjItMC43LTAuNC0xLjEtMC4zYy0wLjMsMC4xLTAuOSwwLjctMS4yLDFjMS4zLDEsMywxLjYsNC42LDIuMWMxLjgsMC42LDMuNywxLjQsNS42LDEuNWMwLjQsMCwxLjMsMCwxLjgtMC40YzAuOS0wLjgsMC44LTIuOCwwLjktMy45QzI4LjksMjUuMywyOS4yLDIzLDI5LjEsMjAuNnoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "h/qv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"arrow-left","data-name":"arrow-left","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.333 16.229"}},[_c('path',{attrs:{"d":"M20,12.667A1.248,1.248,0,0,1,18.782,14H11.448L14.5,17.062a1.309,1.309,0,0,1,0,1.876l-.781.791a1.342,1.342,0,0,1-.937.386,1.385,1.385,0,0,1-.949-.386L5.052,12.938A1.344,1.344,0,0,1,4.667,12a1.386,1.386,0,0,1,.385-.948l6.781-6.771a1.35,1.35,0,0,1,.949-.395,1.327,1.327,0,0,1,.937.395l.781.771a1.333,1.333,0,0,1,0,1.9L11.448,10h7.334A1.248,1.248,0,0,1,20,11.333Z","transform":"translate(-4.667 -3.886)"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hU5T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hfGC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0ic21pbGV5IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MiIgaGVpZ2h0PSI1NyIgdmlld0JveD0iMCAwIDYyIDU3Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgICAvKiBEZWZhdWx0ICovCiAgICAgICAgI2JhY2tncm91bmR7ZmlsbDogI2ZmZjt9CiAgICAgICAgLmZhY2Uge2ZpbGw6ICMwMDA7fQogICAgICAgICNoZWFkLWJvcmRlcntmaWxsOiAjMDAwO30KICAgICAgICAKICAgICAgICAvKiBBY3RpdmUgKi8KICAgICAgICAvKgogICAgICAgICNiYWNrZ3JvdW5ke2ZpbGw6ICMwZGEwZGY7fQogICAgICAgIC5mYWNlIHtmaWxsOiAjMGRhMGRmO30KICAgICAgICAjaGVhZC1ib3JkZXJ7ZmlsbDogI2ZmZjt9CiAgICAgICAgKi8KCiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+aWNvbl9zdXJ2ZXlfc21pbGV5PC90aXRsZT4KICA8cGF0aCBpZD0iYmFja2dyb3VuZCIgZD0iTTU3Ljg4NywwSDQuMTEzQTQuMTE0LDQuMTE0LDAsMCwwLDAsNC4xMTNWNTIuODg3QTQuMTE0LDQuMTE0LDAsMCwwLDQuMTEzLDU3SDU3Ljg4N0E0LjExNCw0LjExNCwwLDAsMCw2Miw1Mi44ODdWNC4xMTNBNC4xMTQsNC4xMTQsMCwwLDAsNTcuODg3LDBaTTMxLDQ4LjVhMjAsMjAsMCwxLDEsMjAtMjBBMjAsMjAsMCwwLDEsMzEsNDguNVoiLz4KICA8Y2lyY2xlIGlkPSJoZWFkIiBzdHlsZT0iZmlsbDogI2ZmZjsiIGN4PSIzMSIgY3k9IjI4LjUiIHI9IjE2LjY2NyIvPgogIDxwYXRoIGlkPSJoZWFkLWJvcmRlciIgZD0iTTMxLDguNWEyMCwyMCwwLDEsMCwyMCwyMEEyMCwyMCwwLDAsMCwzMSw4LjVabTAsMzYuNjY3QTE2LjY2NywxNi42NjcsMCwxLDEsNDcuNjY3LDI4LjUsMTYuNjgyLDE2LjY4MiwwLDAsMSwzMSw0NS4xNjdaIi8+CiAgPGVsbGlwc2UgaWQ9ImxlZnQtZXllIiBjbGFzcz0iZmFjZSIgY3g9IjI0LjUiIGN5PSIyMS44MzMiIHJ4PSIzLjUiIHJ5PSIzLjMzMyIvPgogIDxwYXRoIGlkPSJtb3V0aF92ZXJ5LWhhcHB5IiBjbGFzcz0iZmFjZSIgZD0iTTM5LjQ2MywzMS4wODFhMS41NzQsMS41NzQsMCwwLDAtLjIxLS4wNDVsLS4wMDksMGExLjY0NCwxLjY0NCwwLDAsMC0uMjUtLjAyNmMtLjAyNywwLS4wNTItLjAwOC0uMDc5LS4wMDhsLTE1LjgzLDBjLS4wMjcsMC0uMDUyLjAwNy0uMDc5LjAwOGExLjc4MiwxLjc4MiwwLDAsMC0uMjUuMDI2bC0uMDA5LDBhMS43NDksMS43NDksMCwwLDAtLjIxLjA0NSwxLjY1NSwxLjY1NSwwLDAsMC0xLjA2OCwyLjA4M0E5LjkyMyw5LjkyMywwLDAsMCwzMSw0MC4xNjd2MGE5LjkyMiw5LjkyMiwwLDAsMCw5LjUzMS03QTEuNjU0LDEuNjU0LDAsMCwwLDM5LjQ2MywzMS4wODFaIi8+CiAgPGNpcmNsZSBpZD0icmlnaHQtZXllIiBjbGFzcz0iZmFjZSIgY3g9IjM3LjY2NyIgY3k9IjIxLjgzMyIgcj0iMy4zMzMiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "jQtg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jgLe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lAVY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lQOO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lTKt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lpkU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lv/G":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0ic21pbGV5IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MiIgaGVpZ2h0PSI1NyIgdmlld0JveD0iMCAwIDYyIDU3Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgICAvKiBEZWZhdWx0ICovCiAgICAgICAgI2JhY2tncm91bmR7ZmlsbDogI2ZmZjt9CiAgICAgICAgLmZhY2Uge2ZpbGw6ICMwMDA7fQogICAgICAgICNoZWFkLWJvcmRlcntmaWxsOiAjMDAwO30KICAgICAgICAKICAgICAgICAvKiBBY3RpdmUgKi8KICAgICAgICAvKgogICAgICAgICNiYWNrZ3JvdW5ke2ZpbGw6ICMwZGEwZGY7fQogICAgICAgIC5mYWNlIHtmaWxsOiAjMGRhMGRmO30KICAgICAgICAjaGVhZC1ib3JkZXJ7ZmlsbDogI2ZmZjt9CiAgICAgICAgKi8KCiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+aWNvbl9zdXJ2ZXlfc21pbGV5PC90aXRsZT4KICA8cGF0aCBpZD0iYmFja2dyb3VuZCIgZD0iTTU3Ljg4NywwSDQuMTEzQTQuMTE0LDQuMTE0LDAsMCwwLDAsNC4xMTNWNTIuODg3QTQuMTE0LDQuMTE0LDAsMCwwLDQuMTEzLDU3SDU3Ljg4N0E0LjExNCw0LjExNCwwLDAsMCw2Miw1Mi44ODdWNC4xMTNBNC4xMTQsNC4xMTQsMCwwLDAsNTcuODg3LDBaTTMxLDQ4LjVhMjAsMjAsMCwxLDEsMjAtMjBBMjAsMjAsMCwwLDEsMzEsNDguNVoiLz4KICA8Y2lyY2xlIGlkPSJoZWFkIiBzdHlsZT0iZmlsbDogI2ZmZjsiIGN4PSIzMSIgY3k9IjI4LjUiIHI9IjE2LjY2NyIvPgogIDxwYXRoIGlkPSJoZWFkLWJvcmRlciIgZD0iTTMxLDguNWEyMCwyMCwwLDEsMCwyMCwyMEEyMCwyMCwwLDAsMCwzMSw4LjVabTAsMzYuNjY3QTE2LjY2NywxNi42NjcsMCwxLDEsNDcuNjY3LDI4LjUsMTYuNjgyLDE2LjY4MiwwLDAsMSwzMSw0NS4xNjdaIi8+CiAgPGVsbGlwc2UgaWQ9ImxlZnQtZXllIiBjbGFzcz0iZmFjZSIgY3g9IjI0LjUiIGN5PSIyMS44MzMiIHJ4PSIzLjUiIHJ5PSIzLjMzMyIvPgogIDxwYXRoIGlkPSJtb3V0aC11bmhhcHB5IiBjbGFzcz0iZmFjZSIgZD0iTTM5LjQ2MywzOS4yNTVhMS42NzYsMS42NzYsMCwwLDEtMi4xMDktMS4wOTQsNi42NjEsNi42NjEsMCwwLDAtMTIuNzA4LDAsMS42NjQsMS42NjQsMCwxLDEtMy4xNzctLjk5LDkuOTg3LDkuOTg3LDAsMCwxLDE5LjA2MiwwQTEuNjU1LDEuNjU1LDAsMCwxLDM5LjQ2MywzOS4yNTVaIi8+CiAgPGNpcmNsZSBpZD0icmlnaHQtZXllIiBjbGFzcz0iZmFjZSIgY3g9IjM3LjY2NyIgY3k9IjIxLjgzMyIgcj0iMy4zMzMiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "n2rp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pYj7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qK2F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "riau":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uAot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLoadingOverlay_vue__ = __webpack_require__("gh8i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLoadingOverlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLoadingOverlay_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc33b92c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_svg_xlink_href_use_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLoadingOverlay_vue__ = __webpack_require__("goWX");
function injectStyle (ssrContext) {
  __webpack_require__("PyJZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc33b92c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLoadingOverlay_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc33b92c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_svg_xlink_href_use_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLoadingOverlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vIWH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vem3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y+Wp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ycs9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yqBy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zVv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"btn-cancel","data-name":"Icon cancel","xmlns":"http://www.w3.org/2000/svg","width":"13.251","height":"13.251","viewBox":"0 0 13.251 13.251"}},[_c('path',{attrs:{"d":"M18.313,16.8,16.8,18.313a1.074,1.074,0,0,1-1.516,0L12,15.034,8.721,18.313a1.076,1.076,0,0,1-1.517,0L5.686,16.8a1.08,1.08,0,0,1,0-1.517L8.966,12,5.686,8.72a1.08,1.08,0,0,1,0-1.517L7.2,5.686a1.078,1.078,0,0,1,1.517,0L12,8.966l3.28-3.28a1.077,1.077,0,0,1,1.516,0L18.313,7.2a1.078,1.078,0,0,1,0,1.517L15.034,12l3.279,3.279a1.078,1.078,0,0,1,0,1.517Z","transform":"translate(-5.375 -5.374)"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zeB2":
/***/ (function(module, exports) {



/***/ }),

/***/ "zooF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCancel_vue__ = __webpack_require__("zeB2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCancel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCancel_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e31e3f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_svg_xlink_href_use_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCancel_vue__ = __webpack_require__("zVv0");
function injectStyle (ssrContext) {
  __webpack_require__("y+Wp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e31e3f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtnCancel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e31e3f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_svg_xlink_href_use_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtnCancel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.bbab77c51119d8c3f636.js